// TR
export const locale = {
    "seoExtra": {
        "ogImage": "Sosyal Paylaşım Görseli (URL)",
        "ogImageHint": "Sosyal medyada paylaşımda görünen görsel. Boşsa varsayılan/otomatik görsel kullanılır.",
        "canonical": "Canonical URL",
        "canonicalHint": "Bu sayfanın asıl (kanonik) adresi. Boşsa sayfanın kendi adresi kullanılır.",
        "noIndex": "Arama motorlarında gizle (noindex)",
        "hideSitemap": "Site haritasından çıkar",
        "advanced": "Gelişmiş SEO"
    },
    "extra": {
        "customerGroups": "Müşteri Grupları",
        "b2bStatus": "B2B Durumu",
        "b2bNone": "B2B değil",
        "b2bApproved": "Hesabı Var",
        "b2bPending": "Onay Bekliyor",
        "b2bRejected": "Reddedildi",
        "skuBarcodeWeight": "SKU / Barkod / Ağırlık",
        "weightG": "Ağırlık (g)",
        "langNameExample": "Türkçe",
        "currencyNameExample": "Türk Lirası",
        "appSearch": "Uygulama ara (kargo, ödeme, trendyol...)",
        "yourStore": "MAĞAZANIZ"
    },
    "common": {
        "comingSoon": {
            "badge": "Çok Yakında",
            "heading": "Bu modül çok yakında burada!",
            "description": "Bu özellik üzerinde çalışıyoruz ve yakında kullanımınıza sunulacak. İlginiz için teşekkür ederiz."
        },
        "accessDenied": {
            "title": "Bu alana erişiminiz yok",
            "description": "Bu sayfayı görüntülemek için gerekli yetkiye sahip değilsiniz. Erişim gerekiyorsa lütfen sistem yöneticinizle iletişime geçin.",
            "goBack": "Geri Dön",
            "goDashboard": "Panele Git"
        },
        "edit": "Düzenle",
        "yes": "Evet",
        "no": "Hayır",
        "new": "Yeni",
        "back": "Geri",
        "language": "Dil",
        "currency": "Para Birimi",
        "cancel": "Vazgeç",
        "send": "Gönder",
        "confirm": "Devam Et",
        "date": "Tarih",
        "save": "Kaydet",
        "report": "Bildir",
        "active": "Aktif",
        "passive": "Pasif",
        "remove": "Sil",
        "action": "İşlem",
        "search": "Ara",
        "all": "Tümü",
        "startDate": "Başlangıç Tarihi",
        "endDate": "Bitiş Tarihi",
        "close": "Kapat",
        "preview": "Önizleme",
        "today": "Bugün",
        "weekly": "Haftalık",
        "monthly": "Aylık",
        "yearly": "Yıllık",
        "viewAll": "Tümü Gör",
        "notification": "Bildirim",
        "download": "İndir",
        "optional": "İsteğe Bağlı",
        "permission": "Yetki",
        "manager": "Yönetici",
        "default": "Varsayılan",
        "status": "Durum",
        "sort": "Sırala",
        "createdAt": "Oluşturulma Tarihi",
        "chooseSelect": "Bir seçim yapın.",
        "chooseDate": "Tarih seçin.",
        "chooseTime": "Saat seçin.",
        "chooseDateAndTime": "Tarih ve saat seçin.",
        "selectGroup": "Lütfen bir grup seçin.",
        "individual": "Bireysel",
        "corporate": "Kurumsal",
        "cash": "Peşin",
        "system": "Sistem",
        "export": "Dışa Aktar",
        "overview": "Genel Bakış",
        "settings": "Ayarlar",
        "enable": "Etkinleştir",
        "homePage": "Anasayfa",
        "id": "ID",
        "true": "Doğru",
        "false": "Yanlış",
        "hour": "Saat",
        "minute": "Dakika",
        "second": "Saniye",
        "empty": "Boş",
        "indefinite": "Süresiz",
        "changePassword": "Şifre Değiştir",
        "poster": "Öne Çıkan Görsel",
        "you": "Sen",
        "min": "Minimum",
        "max": "Maksimum",
        "start": "Başlangıç",
        "end": "Bitiş",
        "ip": "IP",
        "userAgent": "Tarayıcı Bilgisi",
        "selfLogin": "Hesaba Giriş Yap"
    },
    "menu": {
        "dashboard": {
            "title": "Gösterge Paneli",
            "description": "Sistemin genel durumunu ve istatistiklerini görüntüleyin."
        },
        "ecommerce": {
            "title": "E-Ticaret Yönetimi",
            "description": "E-ticaret süreçlerini ve ürün yönetimini yönetin.",
            "product": {
                "title": "Ürünler",
                "description": "Ürünleri görüntüleyin ve yönetin.",
                "list": {
                    "title": "Ürün Listesi",
                    "description": "Tüm ürünlerin listesini görüntüleyin."
                },
                "buying": {
                    "title": "Satın Alma",
                    "description": "Tedarikçilerden yapılan satın alma işlemlerini yönetin."
                },
                "transfer": {
                    "title": "Transferler",
                    "description": "Depolar arası ürün transferlerini yönetin."
                },
                "stocks": {
                    "title": "Stok Sayımı",
                    "description": "Ürün stok sayımı ve envanter kontrol işlemlerini yönetin."
                },
                "collation": {
                    "title": "Tanımlamalar",
                    "description": "Ürün yönetimi için gerekli tanımlama ayarlarını yönetin.",
                    "category": {
                        "title": "Kategoriler",
                        "description": "Ürün kategorilerini oluşturun ve yönetin."
                    },
                    "brand": {
                        "title": "Markalar",
                        "description": "Ürün markalarını oluşturun ve yönetin."
                    },
                    "variant_types": {
                        "title": "Varyant Türleri",
                        "description": "Ürün varyant türlerini oluşturun ve yönetin."
                    },
                    "product_groups": {
                        "title": "Ürün Grupları",
                        "description": "Ürün gruplarını oluşturun ve yönetin."
                    },
                    "suppliers": {
                        "title": "Tedarikçiler",
                        "description": "Tedarikçi bilgilerini oluşturun ve yönetin."
                    },
                    "tags": {
                        "title": "Etiketler",
                        "description": "Ürün etiketlerini oluşturun ve yönetin."
                    },
                    "product_units": {
                        "title": "Ürün Birimleri",
                        "description": "Ürün birimlerini oluşturun ve yönetin."
                    },
                    "attribute": {
                        "title": "Özel Alanlar",
                        "description": "Özellik setlerini, özel alanları ve seçeneklerini yönetin."
                    }
                },
                "priceList": {
                    "title": "Fiyat Listesi",
                    "description": "Ürünlere ait fiyat listelerini görüntüleyin ve yönetin."
                },
                "productBarcode": {
                    "title": "Ürün Barkod Etiketi",
                    "description": "Ürün barkod etiketlerini oluşturun ve yazdırın."
                }
            },
            "stock": {
                "title": "Stok Yönetimi",
                "description": "Depoları, stok bakiyelerini ve stok süreçlerini yönetin.",
                "warehouses": {
                    "title": "Depolar",
                    "description": "Depo, mağaza ve sanal depoları tanımlayın ve yönetin."
                },
                "status": {
                    "title": "Stok Durumu",
                    "description": "Depo bazında stok bakiyelerini görüntüleyin, eşik ve düzeltme yapın."
                },
                "movements": {
                    "title": "Stok Hareketleri",
                    "description": "Tüm stok giriş/çıkış hareketlerini görüntüleyin."
                },
                "purchases": {
                    "title": "Satın Almalar",
                    "description": "Tedarikçi satın alma siparişlerini oluşturun ve mal kabul yapın."
                },
                "transfers": {
                    "title": "Transferler",
                    "description": "Depolar arası stok transferlerini yönetin."
                },
                "counts": {
                    "title": "Stok Sayımları",
                    "description": "Fiziksel stok sayımı oluşturun ve bakiyeleri düzeltin."
                }
            },
            "order": {
                "title": "Siparişler",
                "description": "Sipariş süreçlerini görüntüleyin ve yönetin.",
                "list": {
                    "title": "Sipariş Listesi",
                    "description": "Tüm siparişleri görüntüleyin ve sipariş detaylarını yönetin."
                },
                "drafts": {
                    "title": "Taslaklar",
                    "description": "Taslak olarak kaydedilen siparişleri görüntüleyin ve düzenleyin."
                },
                "abandonedCarts": {
                    "title": "Terk Edilmiş Sepetler",
                    "description": "Tamamlanmamış ve terk edilmiş sepet işlemlerini görüntüleyin."
                },
                "cartLinks": {
                    "title": "Sepet Linkleri",
                    "description": "Sepet paylaşım bağlantılarını yönetin."
                },
                "tags": {
                    "title": "Etiketler",
                    "description": "Sipariş etiketlerini oluşturun ve yönetin."
                },
                "giftCards": {
                    "title": "Hediye Kartları",
                    "description": "Hediye kartlarını oluşturun, düzenleyin ve yönetin."
                },
                "statuses": {
                    "title": "Sipariş Durumları",
                    "description": "Sipariş durum tanımlarını oluşturun ve yönetin."
                }
            },
            "customer": {
                "title": "Müşteriler",
                "description": "Müşteri hesaplarını ve müşteri yönetim süreçlerini yönetin.",
                "list": {
                    "title": "Müşteri Listesi",
                    "description": "Tüm müşterileri görüntüleyin ve müşteri bilgilerini yönetin."
                },
                "pendingApproval": {
                    "title": "Onay Bekleyenler",
                    "description": "Onay sürecinde olan müşteri hesaplarını görüntüleyin ve yönetin."
                },
                "customerGroups": {
                    "title": "Müşteri Grupları",
                    "description": "Müşteri gruplarını oluşturun ve yönetin."
                },
                "tags": {
                    "title": "Etiketler",
                    "description": "Müşteri etiketlerini oluşturun ve yönetin."
                }
            },
            "report": {
                "title": "Raporlar",
                "description": "Satış, sipariş ve sistem raporlarını görüntüleyin."
            },
            "salesChannels": {
                "title": "Satış Kanalları",
                "description": "Sistem geneli satış kanallarını yönetin (Web Sitesi, Mobil Uygulama, pazaryerleri…); siparişler kanala göre raporlanır."
            },
            "marketing": {
                "title": "Pazarlama",
                "description": "Pazarlama araçlarını ve kampanya yönetim süreçlerini yönetin.",
                "summary": {
                    "title": "Özet",
                    "description": "Pazarlama performansına ait genel istatistikleri görüntüleyin."
                },
                "emailSms": {
                    "title": "E-Posta & SMS",
                    "description": "E-posta ve SMS pazarlama kampanyalarını yönetin."
                },
                "automation": {
                    "title": "Otomasyon",
                    "description": "Otomatik pazarlama senaryolarını oluşturun ve yönetin."
                },
                "affiliateReports": {
                    "title": "Affiliate Raporları",
                    "description": "Affiliate performans raporlarını görüntüleyin."
                }
            },
            "discount": {
                "title": "İndirimler",
                "description": "İndirim ve kampanya yönetim işlemlerini yönetin.",
                "campaigns": {
                    "title": "Kampanyalar",
                    "description": "Kampanyaları oluşturun ve yönetin."
                },
                "couponCodes": {
                    "title": "Kupon Kodları",
                    "description": "İndirim kuponlarını oluşturun ve yönetin."
                },
                "campaignOffers": {
                    "title": "Kampanya Teklifleri",
                    "description": "Özel kampanya tekliflerini oluşturun ve yönetin."
                }
            },
            "app": {
                "title": "Uygulamalar",
                "description": "Sistem uygulamalarını ve entegrasyonlarını yönetin.",
                "market": {
                    "title": "Uygulama Marketi",
                    "description": "Yeni uygulamaları keşfedin ve yükleyin."
                },
                "myApps": {
                    "title": "Uygulamalarım",
                    "description": "Yüklü uygulamaları görüntüleyin ve yönetin."
                },
                "trendyol": {
                    "title": "Trendyol",
                    "description": "Trendyol pazaryeri entegrasyonunu yönetin.",
                    "dashboard": "Genel Bakış",
                    "dashboardDescription": "Entegrasyon durumu ve özet istatistikler.",
                    "products": "Ürünler",
                    "productsDescription": "Trendyol'a gönderilen ürünleri yönetin.",
                    "orders": "Siparişler",
                    "ordersDescription": "Trendyol sipariş paketlerini görüntüleyin ve aktarın.",
                    "claims": "İadeler",
                    "claimsDescription": "Trendyol iade taleplerini yönetin.",
                    "mapping": "Eşleştirmeler",
                    "mappingDescription": "Kategori ve marka eşleştirmelerini yapın.",
                    "logs": "Kayıtlar",
                    "logsDescription": "Toplu işlem ve istek kayıtlarını inceleyin.",
                    "settings": "Ayarlar",
                    "settingsDescription": "API bilgileri ve senkronizasyon ayarları."
                },
                "productCatalog": {
                    "title": "Ürün Kataloğu",
                    "description": "Excel'den katalog oluşturun ve ürünlerle eşleştirin.",
                    "catalogs": "Kataloglar",
                    "catalogsDescription": "Katalogları oluşturun, düzenleyin ve yayınlayın."
                },
                "shopier": {
                    "title": "Shopier",
                    "description": "Shopier mağazanızı iki yönlü yönetin.",
                    "dashboard": "Genel Bakış",
                    "dashboardDescription": "Bağlantı durumu ve özet.",
                    "products": "Ürünler",
                    "productsDescription": "Ürünleri Shopier ile iki yönlü senkronlayın.",
                    "orders": "Siparişler",
                    "ordersDescription": "Shopier siparişlerini aktarın ve kapatın.",
                    "logs": "Kayıtlar",
                    "logsDescription": "İstek ve webhook kayıtları.",
                    "settings": "Ayarlar",
                    "settingsDescription": "Bağlantı, senkron, ödeme ve vitrin ayarları."
                }
            }
        },
        "site": {
            "title": "Site Yönetimi",
            "description": "Site içeriğini, yöneticileri ve site ayarlarını yönetin.",
            "administrators": {
                "title": "Yöneticiler",
                "description": "Yönetici hesaplarını ve yetkilerini yönetin.",
                "admins": {
                    "title": "Yöneticiler",
                    "description": "Yönetici hesaplarını oluşturun ve yönetin."
                },
                "groups": {
                    "title": "Yönetici Grupları",
                    "description": "Yönetici gruplarını ve izinlerini yönetin."
                }
            },
            "content": {
                "title": "İçerik Yönetimi",
                "description": "Site içerik modüllerini oluşturun ve yönetin.",
                "themes": {
                    "title": "Temalarım",
                    "description": "Site temalarını yönetin ve özelleştirin."
                },
                "media": {
                    "title": "Medya Kütüphanesi",
                    "description": "Dosyaları yükleyin, klasörleyin ve yönetin."
                },
                "slider": {
                    "title": "Slider",
                    "description": "Ana sayfa slider içeriklerini yönetin."
                },
                "featured_products": {
                    "title": "Öne Çıkan Ürünler",
                    "description": "Öne çıkan ürün gruplarını ve listelerini yönetin."
                },
                "blog": {
                    "title": "Blog",
                    "description": "Blog yazılarını ve kategorilerini yönetin.",
                    "posts": {
                        "title": "İçerikler",
                        "description": "Blog yazılarını oluşturun ve yönetin."
                    },
                    "categories": {
                        "title": "Kategoriler",
                        "description": "Blog kategorilerini oluşturun ve yönetin."
                    }
                },
                "pages": {
                    "title": "Sayfalar",
                    "description": "Statik site sayfalarını (Hakkımızda, KVKK, gizlilik vb.) oluşturun ve yönetin."
                },
                "faq": {
                    "title": "Sıkça Sorulan Sorular",
                    "description": "Sıkça sorulan soruları oluşturun ve yönetin."
                },
                "forms": {
                    "title": "Form",
                    "description": "Formları ve form yanıtlarını yönetin."
                },
                "popup": {
                    "title": "Popup",
                    "description": "Site popup pencerelerini oluşturun ve yönetin."
                },
                "links": {
                    "title": "Link Yönetimi",
                    "description": "Menü ve bağlantıları oluşturun ve yönetin."
                },
                "sitemap": {"title": "Sitemap ve robots.txt", "description": "Site haritasını ve robots.txt dosyasını yönetin."},
                "menus": {
                    "title": "Menüler",
                    "description": "Header/footer menülerini ve öğelerini (link, dropdown, mega) yönetin."
                }
            },
            "localization": {
                "title": "Lokalizasyon",
                "description": "Dil, para birimi ve bölgesel ayarları yönetin.",
                "languages": {
                    "title": "Diller",
                    "description": "Site dillerini yönetin."
                },
                "currencies": {
                    "title": "Para Birimleri",
                    "description": "Para birimlerini ve kurlarını yönetin."
                },
                "taxes": {
                    "title": "Vergiler",
                    "description": "Vergi tanımlarını yönetin."
                },
                "countries": {
                    "title": "Ülkeler",
                    "description": "Ülke, il ve ilçeleri görüntüleyin."
                }
            },
            "settings": {
                "title": "Ayarlar",
                "description": "Site ve sistem ayarlarını yapılandırın.",
                "general": {
                    "title": "Genel Ayarlar",
                    "description": "Site, kayıt ve sistem değişkeni ayarlarını yapılandırın."
                },
                "register": {
                    "title": "Kayıt Ol Ayarları",
                    "description": "Üye kayıt (kayıt ol) ile ilgili ayarları yapılandırın."
                },
                "site": {
                    "title": "Site Ayarları",
                    "description": "Genel site ayarlarını yapılandırın.",
                    "homepage": {
                        "title": "Anasayfa Ayarları",
                        "description": "Anasayfa ile ilgili ayarları yapılandırın."
                    }
                },
                "theme": {
                    "title": "Tema Ayarları",
                    "description": "Aktif temanın renklerini yönetin."
                },
                "mail_templates": {
                    "title": "İşlemsel E-Postalar",
                    "description": "Giriş doğrulama, parola sıfırlama gibi otomatik e-postaların tasarımını düzenleyin."
                },
                "system_variables": {
                    "title": "Sistem Değişkenleri",
                    "description": "Sistem genelindeki değişkenleri yönetin."
                },
                "system": {
                    "title": "Sistem Ayarları",
                    "description": "Gelişmiş sistem ayarlarını yapılandırın.",
                    "register": {
                        "title": "Kayıt Ol Ayarları",
                        "description": "Üye kayıt (kayıt ol) ile ilgili ayarları yapılandırın."
                    }
                },
                "tracking_codes": {
                    "title": "İzleme Kodları",
                    "description": "Analitik ve izleme kodlarını yönetin."
                },
                "media_providers": {
                    "title": "Medya Sağlayıcıları",
                    "description": "Video/akış sağlayıcılarını ve hesaplarını yönetin."
                }
            }
        }
    },
    "messages": {
        "warning": "Uyarı",
        "success": "Başarılı",
        "error": "Hata",
        "sureAction": "Bu işlemi gerçekleştirmek istediğinizden emin misiniz? Lütfen dikkatli olun.",
        "sureConfirm": "Bu işlemi onaylamak istediğinizden emin misiniz?",
        "sureDelete": "Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        "actionOk": "İşleminiz başarıyla tamamlandı.",
        "copied": "kopyalandı",
        "deleteOk": "Silme işlemi başarıyla tamamlandı.",
        "copyOk": "Kayıt başarıyla kopyalandı. Yeni kaydı kullanmaya başlayabilirsiniz.",
        "copyLinkOk": "Link başarıyla kopyalandı.",
        "copyLinkError": "Link kopyalanırken bir hata oluştu.",
        "selectRow": "Lütfen işlem gerçekleştirmek için bir kayıt seçiniz.",
        "wait": "Lütfen bekleyiniz",
        "loading": "Veriler yükleniyor. Lütfen sabırlı olunuz.",
        "noResultFound": "Arama kriterlerinize uygun sonuç bulunamadı. Lütfen farklı kriterler kullanarak tekrar deneyiniz.",
        "errorOccurred": "Bir hata oluştu",
        "exportFailed": "Dışa aktarma başarısız oldu",
        "fillRequired": "Lütfen zorunlu alanları doldurun"
    },
    "btn": {
        "confirm": "Onayla",
        "preview": "Önizleme",
        "new": "Yeni",
        "add": "Ekle",
        "create": "Oluştur",
        "copy": "Kopyala",
        "edit": "Düzenle",
        "detail": "Detay",
        "customerDelete": "Müşteriyi Sil",
        "delete": "Sil",
        "yes": "Evet",
        "no": "Hayır",
        "cancel": "Vazgeç",
        "close": "Kapat",
        "refresh": "Yenile",
        "categories": "Kategoriler",
        "export": "Dışa Aktar",
        "update": "Güncelle",
        "filter": "Filtrele",
        "ship": "Kargoya Ver",
        "save": "Kaydet",
        "saveAll": "Tümünü Kaydet",
        "select": "Seç",
        "selectFile": "Dosya Seç",
        "upload": "Yükle",
        "download": "İndir",
        "action": "İşlem",
        "previous": "Önceki",
        "ensuing": "Sonraki",
        "next": "İleri",
        "back": "Geri",
        "send": "Gönder",
        "ok": "Tamam",
        "clear": "Temizle",
        "tryAgain": "Tekrar Dene",
        "apply": "Uygula",
        "reset": "Sıfırla",
        "change": "Değiştir",
        "check": "Kontrol Et",
        "clone": "Klonla",
        "selectedRowEvent": "Seçili Kayıt İşlemleri"
    },
    "validation": {
        "required": "Bu alanı doldurmanız gerekmektedir.",
        "email": "Lütfen geçerli bir e-posta adresi giriniz.",
        "number": "Bu alana yalnızca sayı değeri girilmelidir.",
        "confirmed": "Girdiğiniz bilgiler onay ile eşleşmiyor. Lütfen kontrol edin.",
        "length": "Bu alanda en az 2 seçenek bulunmalıdır.",
        "password": "Lütfen güçlü ve geçerli bir şifre giriniz.",
        "passwordConfirmation": "Lütfen şifrenizi yeniden giriniz.",
        "dontMatchPassword": "Girdiğiniz şifreler birbiriyle eşleşmiyor. Lütfen tekrar deneyiniz."
    },
    "pages": {
        "login": {
            "title": "Giriş Yap",
            "description": "Devam etmek için hesabınıza giriş yapın",
            "back": {
                "title": "Henüz üye olmadın mı?",
                "buttonTitle": "Üye Ol"
            },
            "cols": {
                "customerID": "Müşteri Numarası",
                "email": "E - Posta",
                "password": "Şifre",
                "confirmation": "Kabul ediyorum &amp; <a href='#' class='kt-link'>Şartlar ve koşullar</a>."
            },
            "successLogin": "Başarıyla giriş yaptınız. Hoş geldiniz!",
            "btnText": "Giriş Yap",
            "responseMessage": {
                "title": "Hata Oluştu",
                "invalid_credentials": "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
            },
            "placeholders": {
                "email": "ornek{'@'}ticatix.com",
                "password": "••••••••",
                "customerID": "Örn: 100234"
            }
        },
        "auth": {
            "banner": {
                "title": "Tek panel, tam kontrol",
                "content": "Ürün, sipariş, müşteri ve pazarlamayı tek yerden yönetin; anlık verilerle işletmenizi güvenle büyütün.",
                "theme": {
                    "light": "Aydınlık Mod",
                    "dark": "Koyu Mod",
                    "system": "Otomatik"
                }
            },
            "register": {
                "title": "Hesap Oluştur",
                "description": "Sınırsız erişim elde edin ve para kazanın",
                "login": {
                    "title": "Zaten hesabınız var mı?",
                    "signIn": "Giriş Yapın"
                },
                "cols": {
                    "firstname": "Ad",
                    "lastname": "Soyad",
                    "identificationNumber": "Kimlik No",
                    "email": "E-Posta",
                    "mobilePhone": "Telefon",
                    "birthDate": "Doğum Tarihi",
                    "password": "Şifre",
                    "passwordConfirmation": "Şifre Tekrar",
                    "confirmation": "Kabul ediyorum &amp; <a href='#' class='kt-link'>Şartlar ve koşullar</a>."
                },
                "sureRegister": {
                    "title": "Kaydı tamamlamak istiyor musunuz?",
                    "description": "Kayıt olduktan sonra <b>e-posta</b> ve <b>telefon numarasını</b> değiştiremezsiniz, bu yüzden doğru bilgileri girdiğinizden emin olun."
                },
                "responseMessage": {
                    "success": "Başarılı şekilde kaydınızı tamamladınız! Hoş geldiniz!"
                },
                "verify": {
                    "title": "E-posta adresinizi doğrulayın",
                    "description": "E-posta almadınız mı? <a href='/auth/sign-up' class='kt-link kt-link-underlined kt-link-dashed'>Tekrar Dene</a>",
                    "buttonTitle": "Şimdilik Atla"
                }
            },
            "passwordReset": {
                "title": "Şifrenizi mi unuttunuz?",
                "description": "Şifrenizi sıfırlamak için E-posta adresinizi girin.",
                "back": {
                    "title": "Zaten üye misiniz?",
                    "buttonTitle": "Giriş Yap"
                },
                "cols": {
                    "customerID": "Müşteri Numarası",
                    "email": "E-Posta",
                    "confirmation": "Kabul ediyorum &amp; <a href='#' class='kt-link'>Şartlar ve koşullar</a>."
                },
                "responseMessage": {
                    "success": "Şifre sıfırlama talimatları e-posta adresinize gönderildi.",
                    "password_reset_rate_error": "Şifre sıfırlama talebinizi son talep zamanından 120 saniye sonra yapabilirsiniz."
                },
                "verify": {
                    "title": "Şifre Yenile",
                    "description": "Yeni şifrenizi onay kodu ile birlikte girin.",
                    "back": {
                        "title": "Zaten üye misiniz?",
                        "buttonTitle": "Giriş Yap"
                    },
                    "cols": {
                        "email": "E-Posta",
                        "password": "Şifre",
                        "passwordConfirmation": "Şifre Tekrar",
                        "code": "Onay Kodu"
                    },
                    "responseMessage": {
                        "success": "Şifreniz başarıyla sıfırlandı.",
                        "invalid_token": "Bu bağlantı geçerliliğini yitirmiş veya daha önce kullanılmış. Lütfen yeni bir bağlantı talep ediniz."
                    }
                },
                "confirmation": {
                    "title": "Şifreniz başarıyla sıfırlandı.",
                    "description": "Yaratıcı olmak için harika bir fırsat <a href='#' class='kt-link kt-link-underlined kt-link-dashed'>max{'@'}keenthemes.com</a> <br>okuyuculara bir fikir veriyor"
                }
            },
            "twoFactor": {
                "title": "İki Faktörlü Doğrulama",
                "description": "Gönderdiğimiz doğrulama kodunu girin",
                "phoneFormat": "******7859",
                "cols": {
                    "code": "6 haneli güvenlik kodunu girin"
                }
            },
            "deActive": {
                "title": "Hesabınız devre dışı bırakıldı",
                "description": "Harika fırsatlar elde edebilirsiniz. Daha fazla bilgi için lütfen bizimle iletişime geçiniz.",
                "btnText": "Ana Sayfaya Dön"
            }
        },
        "account": {
            "overview": {
                "title": "Profil Detayları",
                "cols": {
                    "name": "Ad",
                    "surname": "Soyad",
                    "email": "E-Posta",
                    "phone": "Telefon",
                    "role": "Rol"
                }
            },
            "settings": {
                "signInMethod": {
                    "title": "Giriş Yöntemi",
                    "emailAddress": "E-Posta Adresi",
                    "password": {
                        "title": "Şifre",
                        "cols": {
                            "currentPassword": "Mevcut Şifre",
                            "password": "Yeni Şifre",
                            "passwordConfirmation": "Yeni Şifre Tekrar"
                        },
                        "changePassword": "Şifre Değiştir",
                        "updatePassword": "Şifreyi Güncelle"
                    }
                }
            },
            "title": "Hesabım",
            "description": "Hesap bilgilerinizi görüntüleyin ve şifrenizi güncelleyin."
        },
        "dashboard": {
            "cols": {
                "title": "Başlık"
            },
            "greet": "Hoş geldiniz",
            "title": "Kontrol Paneli",
            "todayRevenue": "Bugünkü Ciro",
            "ordersToday": "{n} sipariş bugün",
            "newOrder": "Sipariş",
            "reports": "Raporlar",
            "salesTrend": "Satış Trendi",
            "trendSub": "Son 30 günün günlük cirosu",
            "trend30Total": "30 gün toplam",
            "orderStatus": "Sipariş Durumu",
            "noOrders": "Sipariş yok",
            "noOrdersYet": "Henüz sipariş bulunmuyor.",
            "noOrdersReceived": "Henüz sipariş alınmadı.",
            "recentOrders": "Son Siparişler",
            "all": "Tümü",
            "guest": "Misafir",
            "topProducts": "En Çok Satan Ürünler",
            "report": "Rapor",
            "unit": "adet",
            "noSales": "Satış yok",
            "noSalesYet": "Henüz ürün satışı yok.",
            "revenue": "Ciro",
            "total": "Toplam",
            "ordersSuffix": "sipariş",
            "loadError": "Veriler yüklenemedi.",
            "kpi": {
                "monthRevenue": "Bu Ay Ciro",
                "monthOrders": "Bu Ay Sipariş",
                "avgOrder": "Ortalama Sepet",
                "customers": "Müşteri",
                "perOrder": "sipariş başına",
                "ordered": "sipariş veren"
            },
            "quick": {
                "products": "Ürünler",
                "productsDesc": "Katalog yönetimi",
                "orders": "Siparişler",
                "ordersDesc": "Sipariş yönetimi",
                "customers": "Müşteriler",
                "customersDesc": "Müşteri yönetimi",
                "carts": "Terk Edilen Sepetler",
                "cartsDesc": "Kurtarma fırsatları",
                "campaigns": "Kampanyalar",
                "campaignsDesc": "İndirim & promosyon",
                "apps": "Uygulamalar",
                "appsDesc": "Entegrasyonlar"
            }
        },
        "ecommerce": {
            "marketing": {
                "emailSms": {
                    "newTitle": "Yeni Kampanya",
                    "editTitle": "Kampanyayı Düzenle",
                    "channel": "Kanal",
                    "channels": {
                        "email": "E-posta",
                        "sms": "SMS",
                        "push": "Push"
                    },
                    "campaignName": "Kampanya Adı",
                    "namePh": "Örn. Yıl sonu indirim duyurusu",
                    "audience": "Hedef Kitle",
                    "customers": "müşteri",
                    "matchLabel": "Kurallardan",
                    "matchAll": "Hepsini sağlayan",
                    "matchAny": "Herhangi birini sağlayan",
                    "allNote": "Kural eklemezsen bu kanala uygun (iletişim bilgisi olan) TÜM müşterilere gönderilir.",
                    "searchProduct": "Ürün ara...",
                    "selectTag": "Etiket seç",
                    "selectGroup": "Grup seç",
                    "addRule": "Kural Ekle",
                    "content": "İçerik",
                    "subject": "E-posta Konusu",
                    "subjectPh": "{customer.name}, sana özel!",
                    "smsPh": "Kısa mesaj metni. {customer.name} kullanabilirsin.",
                    "chars": "karakter",
                    "pushTitle": "Bildirim Başlığı",
                    "pushTitlePh": "Örn. Yeni Kampanya!",
                    "message": "Mesaj",
                    "pushMsgPh": "Push bildirim metni",
                    "pushHint": "Push, OneSignal ile TÜM abone kullanıcılara yayınlanır (sağlayıcı gerektirir); hedef kitle sayımı bilgilendirme amaçlıdır.",
                    "saveDraft": "Taslak Kaydet",
                    "send": "Gönder",
                    "queued": "Kampanya gönderime alındı.",
                    "nameRequired": "Kampanya adı zorunludur.",
                    "emailRequired": "Önce e-posta içeriğini tasarlayın.",
                    "messageRequired": "Mesaj metni zorunludur.",
                    "reach": "Ulaşılan",
                    "sentShort": "gönderildi",
                    "failedShort": "başarısız",
                    "date": "Tarih",
                    "confirmSend": "Bu kampanya ≈ {n} müşteriye gönderilecek. Onaylıyor musun?",
                    "status": {
                        "draft": "Taslak",
                        "scheduled": "Zamanlanmış",
                        "sending": "Gönderiliyor",
                        "sent": "Gönderildi",
                        "failed": "Başarısız"
                    }
                },
                "automation": {
                    "addTitle": "Otomasyon Oluştur",
                    "editTitle": "Otomasyonu Düzenle",
                    "builderHint": "Tetikleyici, koşul ve aksiyonları sürükleyip bağlayarak akışı kurun.",
                    "namePh": "Örn. Sipariş sonrası teşekkür e-postası",
                    "description": "Açıklama",
                    "descPh": "Bu otomasyon ne yapıyor?",
                    "palette": "Bileşenler",
                    "settings": "Ayarlar",
                    "selectNode": "Ayarlarını düzenlemek için bir düğüm seçin.",
                    "noTrigger": "Tetikleyici yok",
                    "namePh2": "Otomasyon adı",
                    "nameRequired": "Otomasyon adı zorunludur.",
                    "triggerRequired": "En az bir tetikleyici eklemelisiniz.",
                    "oneTrigger": "Bir akışta yalnızca bir tetikleyici olabilir.",
                    "removeNode": "Düğümü Sil",
                    "matchMode": "Eşleşme",
                    "matchAll": "Tümü (AND)",
                    "matchAny": "Herhangi biri (OR)",
                    "needTrigger": "Koşul alanları için önce bir tetikleyici ekleyin.",
                    "condition": "Koşul",
                    "addCondition": "Koşul Ekle",
                    "field": "Alan",
                    "value": "Değer",
                    "selectTag": "Etiket seç",
                    "selectGroup": "Grup seç",
                    "variables": "Kullanılabilir değişkenler (tıkla kopyala)",
                    "groups": {
                        "trigger": "Tetikleyici",
                        "condition": "Koşul",
                        "ab_test": "A/B Test",
                        "delay": "Bekleme",
                        "action": "Aksiyon"
                    },
                    "canvas": {
                        "empty": "Soldaki paletten bir tetikleyici sürükleyerek başlayın.",
                        "yes": "Evet",
                        "no": "Hayır",
                        "conditionWord": "koşul",
                        "noCondition": "Koşul tanımlanmadı",
                        "splitWord": "bölme",
                        "waitWord": "bekle",
                        "noDuration": "Süre ayarlanmadı",
                        "notSet": "Ayarlanmadı",
                        "zoomIn": "Yakınlaştır",
                        "zoomOut": "Uzaklaştır",
                        "fit": "Sığdır",
                        "units": {
                            "minute": "dakika",
                            "hour": "saat",
                            "day": "gün",
                            "week": "hafta",
                            "month": "ay"
                        }
                    },
                    "trig": {
                        "order_created": "Sipariş Oluşturuldu",
                        "order_status_changed": "Sipariş Durumu Değişti",
                        "order_paid": "Sipariş Ödendi",
                        "order_cancelled": "Sipariş İptal Edildi",
                        "customer_registered": "Yeni Müşteri Kaydı",
                        "cart_abandoned": "Sepet Terk Edildi"
                    },
                    "cols": {
                        "name": "Otomasyon",
                        "trigger": "Tetikleyici",
                        "runs": "Çalıştırma",
                        "updated": "Güncelleme"
                    },
                    "email": {
                        "title": "E-posta Tasarımı",
                        "contentLabel": "E-posta İçeriği",
                        "notDesigned": "E-posta henüz tasarlanmadı",
                        "design": "E-posta Tasarla",
                        "edit": "E-postayı Düzenle",
                        "templates": "Hazır Şablonlar",
                        "tplConfirm": "Mevcut tasarımın silinip seçtiğin şablonla değiştirilecek. Devam edilsin mi?",
                        "heroTitle": "Başlık",
                        "heroSubtitle": "Alt Başlık",
                        "titleColor": "Başlık Rengi",
                        "subtitleColor": "Alt Başlık Rengi",
                        "padding": "İç Boşluk (px)",
                        "icon": "İkon",
                        "iconColor": "İkon Rengi",
                        "itemsHeading": "Bölüm Başlığı",
                        "itemsHeadingPh": "Örn. Sipariş Özeti",
                        "itemsNote": "Gerçek ürünler gönderim anında eklenir",
                        "itemsInfo": "Bu blok gönderim sırasında siparişteki / sepetteki gerçek ürünlerle (görsel, adet, tutar) otomatik doldurulur.",
                        "tpl": {
                            "welcome": "Hoş Geldiniz",
                            "order": "Sipariş Onayı",
                            "promo": "Kampanya",
                            "cart": "Sepet Hatırlatma"
                        },
                        "block": {
                            "hero": "Hero Banner",
                            "logo": "Logo",
                            "heading": "Başlık",
                            "text": "Metin",
                            "icon": "İkon",
                            "features": "İkonlu Liste",
                            "items": "Ürünler",
                            "code": "Doğrulama Kodu",
                            "button": "Buton",
                            "image": "Görsel",
                            "social": "Sosyal",
                            "divider": "Ayırıcı",
                            "spacer": "Boşluk",
                            "footer": "Alt Bilgi"
                        },
                        "codeValue": "Kod Değeri (yer tutucu)",
                        "codeNote": "Kodun Altındaki Not",
                        "codeSpacing": "Harf Aralığı",
                        "featTitle": "Başlık",
                        "featDesc": "Açıklama",
                        "blocks": "Bloklar",
                        "global": "Genel Ayarlar",
                        "bg": "Arka Plan",
                        "cardBg": "İçerik Rengi",
                        "textColor": "Metin Rengi",
                        "width": "Genişlik (px)",
                        "radius": "Köşe Yuvarlaklığı",
                        "content": "İçerik",
                        "logoText": "Logo Metni",
                        "image": "Görsel URL",
                        "logoHint": "Logo görseli seçin ya da URL girin (boşsa metin gösterilir).",
                        "widthPx": "Genişlik (px)",
                        "btnText": "Buton Metni",
                        "btnUrl": "Buton Linki",
                        "btnBg": "Buton Rengi",
                        "btnColor": "Yazı Rengi",
                        "link": "Bağlantı (URL)",
                        "widthPct": "Genişlik (%)",
                        "color": "Renk",
                        "height": "Yükseklik (px)",
                        "align": "Hizalama",
                        "size": "Boyut",
                        "removeBlock": "Bloğu Sil",
                        "selectBlock": "Düzenlemek için bir blok seçin.",
                        "emptyHint": "Soldaki panelden blok ekleyerek e-postanızı oluşturun.",
                        "dragMove": "Taşı",
                        "duplicate": "Kopyala",
                        "sampleProduct": "Örnek Ürün",
                        "qtyLabel": "Adet"
                    }
                },
                "summaryPage": {
                    "eyebrow": "Pazarlama",
                    "title": "Pazarlama Merkezi",
                    "subtitle": "Kampanyalarını, otomasyonlarını ve müşteri ilgisini tek ekrandan takip et.",
                    "newCampaign": "Yeni Kampanya",
                    "newAutomation": "Yeni Otomasyon",
                    "viewAll": "Tümü",
                    "loadError": "Özet verileri yüklenemedi.",
                    "kpi": {
                        "campaigns": "Kampanya",
                        "sent": "gönderildi",
                        "recipients": "Ulaşılan Alıcı",
                        "delivered": "iletildi",
                        "automations": "Aktif Otomasyon",
                        "totalShort": "toplam",
                        "runs": "Otomasyon Çalışması",
                        "runsSub": "toplam tetikleme",
                        "favorites": "Favori",
                        "customers": "müşteri"
                    },
                    "channels": {
                        "title": "Kanal Dağılımı",
                        "subtitle": "Kanala göre kampanya sayısı",
                        "email": "E-posta",
                        "sms": "SMS",
                        "push": "Push Bildirim",
                        "noData": "Henüz kampanya yok"
                    },
                    "campaigns": {
                        "title": "Son Kampanyalar",
                        "recipients": "alıcı",
                        "empty": "Henüz kampanya yok",
                        "emptyHint": "İlk toplu e-posta/SMS kampanyanı oluştur."
                    },
                    "automations": {
                        "title": "En Aktif Otomasyonlar",
                        "runs": "çalışma",
                        "active": "Aktif",
                        "passive": "Pasif",
                        "empty": "Henüz otomasyon yok",
                        "emptyHint": "Tetikleyici tabanlı ilk otomasyonunu kur."
                    },
                    "favorites": {
                        "title": "En Çok Favorilenen Ürünler",
                        "times": "kez",
                        "empty": "Henüz favori yok",
                        "emptyHint": "Müşteriler ürünleri favorilediğinde burada görünür."
                    },
                    "status": {
                        "draft": "Taslak",
                        "scheduled": "Zamanlanmış",
                        "sending": "Gönderiliyor",
                        "sent": "Gönderildi",
                        "failed": "Başarısız"
                    }
                }
            },
            "report": {
                "refresh": "Yenile",
                "refreshed": "Rapor güncellendi",
                "loadError": "Rapor verileri yüklenirken bir hata oluştu.",
                "empty": "Kayıt bulunamadı",
                "updatedNote": "Rapor verileri performans için 24 saat önbelleğe alınır; en güncel veri için Yenile'ye basın.",
                "searchProduct": "Ürün ara (en az 2 harf)…",
                "searchCustomer": "Müşteri ara (en az 2 harf)…",
                "prev": "Önceki",
                "next": "Sonraki",
                "goToday": "Bugüne dön",
                "pickProduct": "Bir ürün seçin",
                "pickCustomer": "Bir müşteri seçin",
                "pickProductHint": "Raporu görüntülemek için yukarıdaki arama kutusundan ürün seçin.",
                "pickCustomerHint": "Raporu görüntülemek için yukarıdaki arama kutusundan müşteri seçin.",
                "vsPrev": "önceki döneme göre",
                "salesTrend": "Satış Trendi",
                "revenueTrend": "Ciro Trendi",
                "periodTotal": "Dönem toplamı",
                "orderStatus": "Sipariş Durumu",
                "noOrdersPeriod": "Bu dönemde sipariş yok",
                "customerSummary": "Müşteri Özeti",
                "lifetimeOrders": "Yaşam boyu sipariş",
                "lifetimeValue": "Yaşam boyu değer",
                "avgOrder": "Ortalama sepet",
                "firstOrder": "İlk sipariş",
                "lastOrder": "Son sipariş",
                "topBought": "En Çok Aldığı Ürünler",
                "topSold": "En Çok Satan Ürünler",
                "unit": "adet",
                "note": "Rakamlar iptal/iade/ödeme bekleyen siparişler hariç hesaplanır. Genel sayılar tüm zamanları kapsar.",
                "totalOrders": "Toplam Sipariş",
                "ordersSuffix": "sipariş",
                "period": {
                    "day": "Günlük",
                    "week": "Haftalık",
                    "month": "Aylık",
                    "year": "Yıllık"
                },
                "mode": {
                    "general": "Genel",
                    "product": "Ürün",
                    "customer": "Müşteri"
                },
                "trend": {
                    "hourly": "Saatlik {n}",
                    "daily": "Günlük {n}",
                    "dailyRange": "Günlük {n} (Pzt–Paz)",
                    "monthly": "Aylık {n}"
                },
                "noun": {
                    "salesUnit": "satış (adet)",
                    "spending": "harcama",
                    "revenue": "ciro"
                },
                "kpi": {
                    "soldUnits": "Satılan Adet",
                    "revenue": "Ciro",
                    "orders": "Sipariş",
                    "containingThis": "bu ürünü içeren",
                    "allTime": "Tüm Zaman",
                    "periodOrders": "Dönem Siparişi",
                    "periodSpending": "Dönem Harcaması",
                    "lifetimeValue": "Yaşam Boyu Değer",
                    "avgOrderShort": "Ort. Sepet",
                    "lifetime": "yaşam boyu",
                    "periodRevenue": "Dönem Cirosu",
                    "avgOrder": "Ortalama Sepet",
                    "totalProducts": "Toplam Ürün",
                    "registeredProducts": "kayıtlı ürün (tüm zamanlar)",
                    "perOrder": "sipariş başına"
                }
            },
            "salesChannels": {
                "addTitle": "Kanal Ekle",
                "editTitle": "Kanalı Düzenle",
                "cols": {
                    "name": "Ad",
                    "code": "Kod",
                    "sort": "Sıra"
                },
                "custom": "Özel",
                "systemChannelHint": "Sistem kanalı — checkout ve entegrasyonlar bu koda referans verdiği için silinemez.",
                "namePlaceholder": "Instagram, Telefon…",
                "warehouses": {
                    "action": "Depolar",
                    "title": "Kanal Depo Ataması",
                    "hint": "Bu kanaldan gelen siparişlerin hangi depodan (öncelik sırasıyla) karşılanacağını ve kanala bildirilen stok miktarını belirler.",
                    "empty": "Bu kanala henüz depo atanmadı — tüm depolar kullanılır.",
                    "warehouse": "Depo",
                    "priority": "Öncelik",
                    "stockRatio": "Stok Oranı (%)",
                    "safetyStock": "Emniyet Stoğu",
                    "add": "Depo Ekle"
                }
            },
            "stock": {
                "warehouse": {
                    "title": "Depolar",
                    "empty": "Henüz depo tanımlanmadı. İlk deponuzu ekleyin.",
                    "addTitle": "Depo Ekle",
                    "editTitle": "Depo Düzenle",
                    "default": "Varsayılan",
                    "isDefault": "Varsayılan Depo",
                    "isDefaultHint": "Sistemde tek varsayılan depo bulunur.",
                    "isSellable": "Satılabilir",
                    "isSellableHint": "Kapalıysa satışta kullanılmaz (ör. iade deposu).",
                    "cols": {
                        "name": "Ad",
                        "code": "Kod",
                        "type": "Tip",
                        "city": "Şehir",
                        "address": "Adres",
                        "priority": "Öncelik",
                        "sellable": "Satılabilir"
                    },
                    "types": {
                        "warehouse": "Depo",
                        "store": "Mağaza",
                        "virtual": "Sanal"
                    }
                },
                "status": {
                    "title": "Stok Durumu",
                    "viewMovements": "Hareketleri Görüntüle",
                    "searchPlaceholder": "Ürün ara…",
                    "stockCode": "Stok Kodu",
                    "stockState": "Stok Durumu",
                    "states": {
                        "in_stock": "Stokta",
                        "out_of_stock": "Tükendi",
                        "critical": "Kritik"
                    },
                    "criticalOnly": "Yalnızca kritik",
                    "criticalHint": "Kullanılabilir stok, minimum eşiğin altında veya eşit.",
                    "editLevels": "Eşikleri Düzenle",
                    "maxLevel": "Maksimum Eşik",
                    "shelf": "Raf Konumu",
                    "adjust": "Stok Düzelt",
                    "adjustTitle": "Manuel Stok Düzeltme",
                    "current": "Mevcut",
                    "targetQuantity": "Hedef Miktar",
                    "note": "Not",
                    "notePlaceholder": "Düzeltme nedeni (zorunlu)",
                    "cols": {
                        "warehouse": "Depo",
                        "product": "Ürün",
                        "quantity": "Miktar",
                        "reserved": "Rezerve",
                        "incoming": "Gelen",
                        "available": "Kullanılabilir",
                        "min": "Min. Eşik"
                    }
                },
                "movement": {
                    "title": "Stok Hareketleri",
                    "dateRange": "Tarih Aralığı",
                    "cols": {
                        "date": "Tarih",
                        "warehouse": "Depo",
                        "product": "Ürün",
                        "type": "Tip",
                        "quantity": "Miktar",
                        "after": "Sonraki",
                        "reference": "Referans",
                        "note": "Not"
                    },
                    "types": {
                        "initial": "Açılış",
                        "purchase_in": "Satın Alma Girişi",
                        "sale_out": "Satış Çıkışı",
                        "transfer_in": "Transfer Girişi",
                        "transfer_out": "Transfer Çıkışı",
                        "adjustment_in": "Düzeltme Girişi",
                        "adjustment_out": "Düzeltme Çıkışı",
                        "return_in": "İade Girişi",
                        "count_correction": "Sayım Düzeltmesi"
                    }
                },
                "purchase": {
                    "title": "Satın Almalar",
                    "empty": "Henüz satın alma siparişi yok. Yeni bir taslak oluşturun.",
                    "itemsShort": "Kalem",
                    "addTitle": "Yeni Satın Alma",
                    "expectedDate": "Beklenen Tarih",
                    "createdAt": "Oluşturma Tarihi",
                    "total": "Tutar",
                    "currency": "Para Birimi",
                    "exchangeRate": "Kur",
                    "items": "Kalemler",
                    "addItem": "Kalem Ekle",
                    "noItems": "Henüz kalem eklenmedi.",
                    "selectProduct": "Ürün seçin…",
                    "variant": "Varyant",
                    "variants": "Varyantlar",
                    "selectVariant": "Varyant seçin…",
                    "variantRequired": "Varyantlı ürünlerde kombinasyon seçmelisiniz.",
                    "bulkApplyHint": "hepsine uygula:",
                    "applyAll": "Tümüne uygula",
                    "unitPrice": "Birim Fiyat",
                    "taxRate": "Vergi %",
                    "received": "Alınan",
                    "receiveNow": "Şimdi Al",
                    "receiveAll": "Hepsini Al",
                    "fillRemaining": "Kalanı doldur ({n})",
                    "doReceive": "Mal Kabul",
                    "createDraft": "Taslak Oluştur",
                    "cols": {
                        "code": "Kod",
                        "warehouse": "Depo",
                        "supplier": "Tedarikçi",
                        "product": "Ürün",
                        "quantity": "Miktar"
                    },
                    "statuses": {
                        "draft": "Taslak",
                        "ordered": "Sipariş Verildi",
                        "partially_received": "Kısmen Alındı",
                        "received": "Alındı",
                        "cancelled": "İptal"
                    }
                },
                "transfer": {
                    "title": "Transferler",
                    "empty": "Henüz transfer yok. Yeni bir taslak oluşturun.",
                    "itemsShort": "Kalem",
                    "addTitle": "Yeni Transfer",
                    "createdAt": "Oluşturma Tarihi",
                    "route": "Güzergah",
                    "fromWarehouse": "Kaynak Depo",
                    "toWarehouse": "Hedef Depo",
                    "items": "Kalemler",
                    "addItem": "Kalem Ekle",
                    "noItems": "Henüz kalem eklenmedi.",
                    "selectProduct": "Ürün seçin…",
                    "variant": "Varyant",
                    "selectVariant": "Varyant seçin…",
                    "variantRequired": "Varyantlı ürünlerde kombinasyon seçmelisiniz.",
                    "createDraft": "Taslak Oluştur",
                    "cols": {
                        "code": "Kod",
                        "product": "Ürün",
                        "quantity": "Miktar"
                    },
                    "statuses": {
                        "draft": "Taslak",
                        "in_transit": "Yolda",
                        "completed": "Tamamlandı",
                        "cancelled": "İptal"
                    }
                },
                "count": {
                    "title": "Stok Sayımları",
                    "empty": "Henüz stok sayımı yok. Yeni bir sayım oluşturun.",
                    "addTitle": "Yeni Sayım",
                    "createdAt": "Oluşturma Tarihi",
                    "completedAt": "Tamamlanma Tarihi",
                    "note": "Not",
                    "notePlaceholder": "Örn. Yıl sonu sayımı",
                    "startHint": "Sayımı başlatınca mevcut bakiyeler beklenen miktar olarak fotoğraflanır.",
                    "categories": "Kategoriler (kapsam)",
                    "categoriesHint": "Boş bırakılırsa tüm depo sayıma dahil edilir.",
                    "allWarehouse": "Tüm depo",
                    "start": "Sayımı Başlat",
                    "saveCounts": "Sayımı Kaydet",
                    "complete": "Tamamla",
                    "completeConfirm": "Sayım tamamlanacak ve farklar için stok düzeltmesi yapılacak. Devam edilsin mi?",
                    "expected": "Beklenen",
                    "counted": "Sayılan",
                    "fillAll": "Beklenenle Doldur",
                    "fillExpected": "Beklenen ({n}) ile doldur",
                    "diff": "Fark",
                    "noLines": "Sayım satırı bulunamadı.",
                    "cols": {
                        "code": "Kod",
                        "warehouse": "Depo",
                        "note": "Not",
                        "product": "Ürün"
                    },
                    "statuses": {
                        "draft": "Taslak",
                        "in_progress": "Devam Ediyor",
                        "completed": "Tamamlandı",
                        "cancelled": "İptal"
                    }
                }
            },
            "tags": {
                "addTitle": "Yeni Etiket",
                "editTitle": "Etiketi Düzenle",
                "nameLabel": "Etiket Adı",
                "namePlaceholder": "Etiket adı",
                "visibilityLabel": "Görünürlük",
                "visible": "Görünür",
                "hidden": "Gizli",
                "sortLabel": "Sıralama",
                "cols": {
                    "tag": "Etiket",
                    "visibility": "Görünürlük",
                    "sort": "Sıralama",
                    "usage": "Kullanım",
                    "productCount": "Ürün Sayısı",
                    "orderCount": "Sipariş Sayısı",
                    "customerCount": "Müşteri Sayısı"
                },
                "createOk": "Etiket eklendi",
                "updateOk": "Etiket güncellendi"
            },
            "order": {
                "giftCards": {
                    "addTitle": "Hediye Kartı Oluştur",
                    "editTitle": "Hediye Kartını Düzenle",
                    "cardInfo": "Hediye Kartı Bilgileri",
                    "codeLabel": "Hediye Kartı Kodu",
                    "codePlaceholder": "Örn. YILBASI2026 (maks. 20)",
                    "generate": "Kod Oluştur",
                    "currency": "Para Birimi",
                    "value": "Hediye Kartı Değeri",
                    "currentBalance": "Mevcut Bakiye",
                    "usedAmount": "Kullanılan",
                    "requirements": "Gereksinimler",
                    "minAmount": "Minimum Sipariş Tutarı",
                    "minAmountHint": "Kartın geçerli olması için sepetin ulaşması gereken minimum tutar (boşsa sınır yok).",
                    "noMinAmount": "Sınır yok",
                    "startDate": "Başlangıç Tarihi",
                    "endDate": "Bitiş Tarihi",
                    "datePlaceholder": "Tarih seçin",
                    "customer": "Müşteri",
                    "searchCustomer": "Müşteri adı ile arayın…",
                    "customerHint": "Boş bırakılırsa hediye kartı herkes tarafından kullanılabilir.",
                    "anyCustomer": "Herkes",
                    "salesChannel": "Satış Kanalı",
                    "allChannels": "Tüm kanallar",
                    "salesChannelHint": "Kartın geçerli olacağı satış kanalı (boşsa tüm kanallarda geçerli).",
                    "balanceOps": "Bakiye & İşlem Geçmişi",
                    "adjustBalance": "Bakiye Ayarla",
                    "adjustPlaceholder": "Örn. -100 veya 250",
                    "adjustNote": "Açıklama (opsiyonel)",
                    "adjustHint": "Pozitif tutar bakiye ekler, negatif tutar düşer. Bakiye 0'ın altına inemez.",
                    "apply": "Uygula",
                    "adjustOk": "Bakiye güncellendi",
                    "errBalanceNegative": "Bakiye 0'ın altına inemez.",
                    "history": "İşlem Geçmişi",
                    "noHistory": "Henüz işlem yok.",
                    "createOk": "Hediye kartı oluşturuldu",
                    "updateOk": "Hediye kartı güncellendi",
                    "states": {
                        "active": "Aktif",
                        "passive": "Pasif",
                        "depleted": "Tükendi",
                        "expired": "Süresi Doldu",
                        "scheduled": "Zamanlanmış",
                        "usable": "Kullanılabilir"
                    },
                    "tx": {
                        "issue": "Açılış",
                        "redeem": "Kullanım",
                        "refund": "İade",
                        "adjust": "Düzeltme"
                    },
                    "cols": {
                        "code": "Kod",
                        "balance": "Bakiye",
                        "customer": "Müşteri",
                        "dates": "Geçerlilik"
                    }
                },
                "cartLinks": {
                    "addTitle": "Sepet Linki Oluştur",
                    "editTitle": "Sepet Linkini Düzenle",
                    "general": "Genel",
                    "cols": {
                        "title": "Başlık",
                        "items": "Ürünler",
                        "coupon": "Kupon",
                        "stats": "İstatistik",
                        "expires": "Son Geçerlilik"
                    },
                    "code": "Kod",
                    "product": "ürün",
                    "viewCount": "Görüntülenme",
                    "orderCount": "Sipariş",
                    "copyUrl": "Linki kopyala",
                    "urlCopied": "Link panoya kopyalandı.",
                    "titlePlaceholder": "Ahmet Bey WhatsApp",
                    "titleHint": "Yalnızca panelde görünen not; müşteriye gösterilmez.",
                    "noExpiry": "Süresiz",
                    "itemsTitle": "Ürünler",
                    "addProduct": "Ürün Ekle",
                    "noItems": "Linke en az bir ürün ekleyin.",
                    "selectProduct": "Ürün seçin",
                    "searchProduct": "Ürün adı ile arayın…",
                    "selectVariant": "Varyant seçin",
                    "noVariant": "Varyant yok",
                    "personalizations": "Kişiselleştirmeler",
                    "fillRequiredPers": "Zorunlu kişiselleştirme alanlarını doldurun.",
                    "requiredFileBlock": "Bu üründe zorunlu dosya tipi kişiselleştirme var — panelden dosya yüklenemediği için ürün linke eklenemez. Alanı ürün ekranından zorunlu olmaktan çıkarabilirsiniz.",
                    "fileNotSupported": "Dosya alanı panelden doldurulamaz; boş bırakılır.",
                    "itemError": "{row}. üründe hata: {error}",
                    "errors": {
                        "requiredVariant": "{row}. ürün için varyant seçmelisiniz.",
                        "invalidVariant": "{row}. üründe seçilen varyant geçersiz.",
                        "invalidProduct": "{row}. ürün satışta değil (pasif ya da satış tarihi dışında).",
                        "invalidQuantity": "{row}. ürünün adedi geçersiz.",
                        "personalizationRequired": "{row}. üründe zorunlu kişiselleştirme alanı ({name}) doldurulmamış.",
                        "invalidPersValue": "{row}. üründe kişiselleştirme değeri geçersiz (listede olmayan seçim ya da geçersiz tarih).",
                        "unsupportedPers": "{row}. üründe ürüne ait olmayan bir kişiselleştirme alanı gönderildi.",
                        "persValueTooLong": "{row}. üründe kişiselleştirme metni karakter limitini aşıyor.",
                        "persDependencyNotMet": "{row}. üründe bağımlı alan, bağlı olduğu alan boşken doldurulmuş."
                    }
                },
                "list": {
                    "cols": {
                        "order": "Sipariş",
                        "customer": "Müşteri",
                        "items": "Ürün",
                        "total": "Tutar",
                        "payment": "Ödeme",
                        "status": "Durum",
                        "date": "Tarih",
                        "tags": "Etiketler"
                    },
                    "vat": "KDV",
                    "installment": "taksit",
                    "shipConfirm": "{count} sipariş kargoya verilecek. Onaylıyor musunuz?",
                    "shipOk": "Siparişler kargoya verildi",
                    "preview": {
                        "title": "Sipariş #{id} — {count} ürün",
                        "more": "+{count} ürün daha",
                        "deleted": "Silinmiş ürün",
                        "empty": "Ürün yok"
                    },
                    "filters": {
                        "search": "Ara",
                        "searchPh": "Sipariş no, müşteri adı, e-posta, telefon",
                        "status": "Sipariş durumu",
                        "tag": "Etiket",
                        "date": "Sipariş tarihi",
                        "coupon": "Kupon kodu",
                        "tracking": "Kargo takip no"
                    }
                },
                "statuses": {
                    "system": "Sistem",
                    "custom": "Özel",
                    "addTitle": "Yeni Durum",
                    "editTitle": "Durumu Düzenle",
                    "codeLabel": "Kod",
                    "nameLabel": "Ad",
                    "namePlaceholder": "Durum adı",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "type": "Tür"
                    },
                    "updateOk": "Durum güncellendi",
                    "createOk": "Durum eklendi"
                },
                "create": {
                    "title": "Yeni Sipariş",
                    "subtitle": "Manuel olarak yeni bir sipariş oluşturun.",
                    "createOrder": "Siparişi Oluştur",
                    "products": "Ürünler",
                    "addProduct": "Ürün Ekle",
                    "product": "Ürün",
                    "searchProduct": "Ürün ara…",
                    "variant": "Varyant",
                    "selectVariant": "Varyant kombinasyonu seçin",
                    "variantRequired": "Varyantlı ürünler için varyant seçimi zorunludur",
                    "quantity": "Adet",
                    "usageStart": "Kullanım Başlangıç",
                    "usageEnd": "Kullanım Bitiş",
                    "optional": "Opsiyonel",
                    "loadingExtras": "Eklenti ve paket öğeleri yükleniyor…",
                    "addons": "Eklentiler",
                    "packageItems": "Paket Öğeleri",
                    "customUsageStart": "Özel kullanım başl.",
                    "customUsageEnd": "Özel kullanım bitiş",
                    "customer": "Müşteri",
                    "searchCustomer": "Müşteri ara…",
                    "address": "Adres",
                    "selectAddress": "Adres seçin",
                    "selectCustomerFirst": "Önce müşteri seçin",
                    "noCustomerAddress": "Bu müşterinin kayıtlı adresi yok.",
                    "orderStatus": "Sipariş Durumu",
                    "productDetailFail": "Ürün detayları alınamadı",
                    "addressFetchFail": "Adresler alınamadı",
                    "addAtLeastOneProduct": "En az bir ürün ekleyin",
                    "createOk": "Sipariş oluşturuldu"
                },
                "detail": {
                    "title": "Sipariş Detayı",
                    "subtitle": "Sipariş bilgilerini görüntüleyin.",
                    "orderNo": "Sipariş #{id}",
                    "products": "Ürünler",
                    "cols": {
                        "product": "Ürün",
                        "quantity": "Adet",
                        "subtotal": "Ara Toplam",
                        "total": "Toplam"
                    },
                    "variantNo": "Varyant #{id}",
                    "noProducts": "Ürün bulunmuyor",
                    "summary": "Özet",
                    "vat": "KDV",
                    "shipping": "Kargo",
                    "usageDates": "Kullanım Tarihleri",
                    "notes": "Notlar",
                    "notePlaceholder": "Sipariş notu ekleyin…",
                    "addNote": "Not Ekle",
                    "noNotes": "Henüz not eklenmemiş",
                    "customer": "Müşteri",
                    "deliveryAddress": "Teslimat Adresi",
                    "payment": "Ödeme",
                    "method": "Yöntem",
                    "subMethod": "Alt Yöntem",
                    "installmentLabel": "Taksit",
                    "paid": "Ödenen",
                    "remainingCollection": "Kalan Tahsilat",
                    "addCollection": "Tahsilat Ekle",
                    "amount": "Tutar",
                    "collectAllShort": "Tümü",
                    "collectAllTooltip": "Tümünü Tahsilat Et (kalan tutarı yazar)",
                    "noteOptional": "Not (opsiyonel)",
                    "weight": "Ağırlık",
                    "trackingNumber": "Takip Numarası",
                    "waybill": "İrsaliye",
                    "movements": "Hareketler",
                    "delivered": "Teslim edildi",
                    "notDelivered": "Teslim edilmedi",
                    "noMovements": "Hareket bilgisi bulunmuyor",
                    "orderInfo": "Sipariş Bilgisi",
                    "tags": "Etiketler",
                    "tagsPh": "Etiket seçin ya da yazıp Enter'a basın",
                    "tagsHint": "Yeni etiket yazarsanız sipariş etiketi olarak oluşturulur.",
                    "tagsSaved": "Etiketler kaydedildi",
                    "manageTags": "Etiketleri yönet",
                    "viewProduct": "Ürünü düzenle",
                    "viewCustomer": "Müşteriyi aç",
                    "notFound": "Sipariş bulunamadı",
                    "updateStatus": "Durum Güncelle",
                    "updateStatusHint": "Sipariş için yeni bir durum seçin.",
                    "statusUpdateOk": "Sipariş durumu güncellendi",
                    "trackingSaveOk": "Kargo takip numarası kaydedildi",
                    "enterNote": "Lütfen bir not girin",
                    "noteAddOk": "Not eklendi",
                    "enterValidAmount": "Geçerli bir tutar girin",
                    "collectionAddOk": "Tahsilat eklendi",
                    "usageDatesUpdateOk": "Kullanım tarihleri güncellendi",
                    "shippingFetchFail": "Kargo bilgileri alınamadı",
                    "waybillFail": "İrsaliye önizlemesi alınamadı",
                    "deleteConfirm": "Bu sipariş silinecek. Onaylıyor musunuz?"
                }
            },
            "customer": {
                "list": {
                    "cols": {
                        "customer": "Müşteri",
                        "contact": "İletişim",
                        "labels": "Etiketler",
                        "status": "Durum",
                        "date": "Kayıt Tarihi"
                    },
                    "selfLogin": "Hesabına Giriş",
                    "loginKeyReceived": "Giriş anahtarı alındı",
                    "loginStarted": "Giriş işlemi başlatıldı"
                },
                "tags": {
                    "addTitle": "Yeni Etiket",
                    "editTitle": "Etiketi Düzenle",
                    "nameLabel": "Etiket Adı",
                    "namePlaceholder": "Etiket adı",
                    "cols": {
                        "tag": "Etiket",
                        "customerCount": "Müşteri Sayısı"
                    },
                    "updateOk": "Etiket güncellendi",
                    "createOk": "Etiket eklendi"
                },
                "save": {
                    "addTitle": "Yeni Müşteri",
                    "editTitle": "Müşteriyi Düzenle",
                    "subtitle": "Müşteri bilgilerini girin ve kaydedin.",
                    "generalInformation": "Genel Bilgiler",
                    "firstname": "Ad",
                    "lastname": "Soyad",
                    "email": "E-posta",
                    "phone": "Telefon",
                    "gender": "Cinsiyet",
                    "birthDate": "Doğum Tarihi",
                    "selectDate": "Tarih seçin",
                    "idNumber": "TC Kimlik No",
                    "idNumberPlaceholder": "11 haneli",
                    "abroad": "Yurt Dışı",
                    "addresses": "Adresler",
                    "addAddress": "Adres Ekle",
                    "default": "Varsayılan",
                    "noAddress": "Kayıtlı adres yok",
                    "statusAndLabels": "Durum & Etiketler",
                    "labels": "Etiketler",
                    "changePassword": "Şifre Değiştir",
                    "password": "Şifre",
                    "newPassword": "Yeni şifre",
                    "passwordConfirm": "Şifre (Tekrar)",
                    "passwordConfirmPlaceholder": "Şifre tekrar",
                    "newPasswordConfirm": "Yeni şifre tekrar",
                    "updatePassword": "Şifreyi Güncelle",
                    "notFound": "Müşteri bulunamadı, yeni kayıt ekranına yönlendirildiniz.",
                    "updateOk": "Müşteri güncellendi",
                    "createOk": "Müşteri oluşturuldu",
                    "passwordMismatch": "Şifreler boş olmamalı ve eşleşmeli",
                    "passwordUpdateOk": "Şifre güncellendi",
                    "address": {
                        "addTitle": "Yeni Adres",
                        "editTitle": "Adresi Düzenle",
                        "title": "Adres Başlığı",
                        "titlePlaceholder": "Ev, İş…",
                        "country": "Ülke",
                        "state": "İl",
                        "city": "İlçe",
                        "district": "Mahalle/Semt",
                        "districtPlaceholder": "Mahalle",
                        "zipCode": "Posta Kodu",
                        "fullAddress": "Açık Adres",
                        "fullAddressPlaceholder": "Cadde, sokak, no…",
                        "invoiceType": "Fatura Tipi",
                        "companyName": "Firma Adı",
                        "taxOffice": "Vergi Dairesi",
                        "setDefault": "Varsayılan adres olarak ayarla",
                        "updateOk": "Adres güncellendi",
                        "createOk": "Adres eklendi"
                    }
                }
            },
            "product": {
                "list": {
                    "variantShort": "varyant",
                    "variantStockHint": "Varyantlı ürün — gösterilen stok, kombinasyon stoklarının toplamıdır.",
                    "cols": {
                        "product": "Ürün",
                        "group": "Tür",
                        "type": "Tip",
                        "price": "Fiyat",
                        "stock": "Stok",
                        "status": "Durum"
                    }
                },
                "collation": {
                    "category": {
                        "addTitle": "Kategori Ekle",
                        "editTitle": "Kategori Düzenle",
                        "generalInformation": "Genel Detaylar",
                        "cols": {
                            "title": "Başlık",
                            "description": "Açıklama",
                            "sort": "Sıra",
                            "status": "Durum",
                            "icon": "İkon",
                            "image": "Görsel",
                            "type": "Tür"
                        },
                        "general": "Genel",
                        "titlePlaceholder": "Kategori adı",
                        "slugPlaceholder": "kategori-slug",
                        "descriptionPlaceholder": "Kısa açıklama",
                        "settings": "Ayarlar",
                        "typeLabel": "Kategori Türü",
                        "typeSimple": "Klasik",
                        "typeDynamic": "Dinamik",
                        "typeSimpleHint": "Ürünler kategoriye elle atanır.",
                        "typeDynamicHint": "Ürünler, seçtiğiniz etiketlere göre otomatik eşlenir.",
                        "tagMatchMode": "Etiket Eşleşme Modu",
                        "tagMatchAny": "Herhangi biri (OR)",
                        "tagMatchAll": "Hepsi (AND)",
                        "tags": "Etiketler",
                        "tagsPlaceholder": "Ürün etiketleri seçin",
                        "tagsEmpty": "Etiket bulunamadı",
                        "seoSettings": "SEO Ayarları",
                        "attributeSet": "Özellik Seti",
                        "attributeSetPlaceholder": "Set seçin (opsiyonel)",
                        "attributeSetHint": "Bu kategorideki ürünler seçilen setin özel alanlarını miras alır.",
                        "seoCols": {
                            "slug": "Slug",
                            "title": "SEO Başlık",
                            "description": "SEO Açıklama",
                            "keywords": "SEO Anahtar Kelimeler"
                        }
                    },
                    "brand": {
                        "addTitle": "Marka Ekle",
                        "editTitle": "Marka Düzenle",
                        "general": "Genel",
                        "cols": {
                            "title": "Başlık",
                            "description": "Açıklama",
                            "image": "Görsel",
                            "sort": "Sıra",
                            "products": "Ürün"
                        },
                        "titlePlaceholder": "Marka adı",
                        "slugPlaceholder": "marka-slug",
                        "descriptionPlaceholder": "Kısa açıklama"
                    },
                    "suppliers": {
                        "addTitle": "Tedarikçi Ekle",
                        "editTitle": "Tedarikçi Düzenle",
                        "general": "Genel",
                        "contact": "İletişim",
                        "billing": "Fatura Bilgileri",
                        "cols": {
                            "name": "Ad",
                            "company": "Firma",
                            "employeeName": "Yetkili",
                            "email": "E-posta",
                            "phone": "Telefon",
                            "address": "Adres",
                            "taxNumber": "Vergi Numarası",
                            "taxOffice": "Vergi Dairesi",
                            "taxInfo": "Vergi Bilgisi",
                            "contact": "İletişim"
                        },
                        "namePlaceholder": "Tedarikçi adı",
                        "companyPlaceholder": "Firma ünvanı",
                        "employeeNamePlaceholder": "Yetkili kişi adı",
                        "addressPlaceholder": "Açık adres",
                        "taxOfficePlaceholder": "Vergi dairesi"
                    },
                    "product_units": {
                        "addTitle": "Birim Ekle",
                        "editTitle": "Birim Düzenle",
                        "cols": {
                            "code": "Kod",
                            "name": "Ad",
                            "sort": "Sıra"
                        },
                        "namePlaceholder": "kilogram",
                        "codeHint": "Kod benzersizdir ve programatik referanslarda kullanılır; ad serbestçe değiştirilebilir."
                    },
                    "attribute": {
                        "title": "Özel Alanlar",
                        "sets": "Özellik Setleri",
                        "globalFields": "Global Alanlar",
                        "globalFieldsHint": "Her sette geçerli olan, sete bağlı olmayan ortak alanlar.",
                        "fieldsOf": "{name} — Alanlar",
                        "optionsOf": "{name} — Seçenekler",
                        "viewFields": "Alanları Görüntüle",
                        "viewOptions": "Seçenekleri Görüntüle",
                        "emptyFields": "Bu sette henüz alan tanımlı değil.",
                        "emptyOptions": "Bu alanda henüz seçenek tanımlı değil.",
                        "addSet": "Set Ekle",
                        "editSet": "Seti Düzenle",
                        "addField": "Alan Ekle",
                        "editField": "Alanı Düzenle",
                        "addOption": "Seçenek Ekle",
                        "editOption": "Seçeneği Düzenle",
                        "codeHint": "Benzersiz, programatik anahtar (a-z, 0-9, _ , -). Oluşturulduktan sonra değiştirilemez.",
                        "typeLocked": "Tip, oluşturulduktan sonra değiştirilemez.",
                        "behavior": "Davranış",
                        "validation": "Doğrulama Kuralları",
                        "optionsAfterSave": "Seçenekleri, alanı kaydettikten sonra ekleyebilirsiniz.",
                        "colorHex": "Renk Kodu",
                        "cols": {
                            "code": "Kod",
                            "name": "Ad",
                            "description": "Açıklama",
                            "type": "Tip",
                            "unit": "Birim",
                            "flags": "Özellikler",
                            "value": "Değer",
                            "label": "Etiket",
                            "sort": "Sıra",
                            "fieldCount": "Alan"
                        },
                        "flags": {
                            "required": "Zorunlu",
                            "filterable": "Filtrelenebilir",
                            "searchable": "Aranabilir",
                            "comparable": "Karşılaştırılabilir",
                            "variant": "Varyant",
                            "visible": "Vitrinde Görünür"
                        },
                        "types": {
                            "text": "Metin",
                            "textarea": "Uzun Metin",
                            "richtext": "Zengin Metin",
                            "number": "Tam Sayı",
                            "decimal": "Ondalık",
                            "boolean": "Evet / Hayır",
                            "select": "Tekli Seçim",
                            "multiselect": "Çoklu Seçim",
                            "color": "Renk",
                            "date": "Tarih",
                            "datetime": "Tarih & Saat",
                            "url": "Bağlantı",
                            "range": "Aralık",
                            "json": "JSON"
                        }
                    },
                    "variant": {
                        "cols": {
                            "title": "Başlık",
                            "description": "Açıklama",
                            "sort": "Sıra",
                            "status": "Durum",
                            "icon": "İkon",
                            "name": "Ad",
                            "itemCount": "Öğe Sayısı",
                            "type": "Tür"
                        },
                        "typeLabel": "Görünüm Türü",
                        "typeList": "Liste",
                        "typeColor": "Renk / Görsel",
                        "typeListHint": "Öğeler düz metin liste olarak gösterilir (ör. Beden: S, M, L).",
                        "typeColorHint": "Her öğe bir renk veya görsel swatch taşır (ör. Renk: Siyah, Kırmızı).",
                        "valueLabel": "Değer (renk / görsel)",
                        "valuePlaceholder": "#000000 veya /uploads/swatch.png",
                        "valueHint": "Hex renk kodu (#1E88E5) ya da görsel yolu girin.",
                        "addTitle": "Yeni Varyant Grubu",
                        "editTitle": "Varyant Grubunu Düzenle",
                        "systemRecord": "Sistem Kaydı",
                        "systemRecordHint": "Bu kayıt sistem tarafından yönetilmekte olup düzenlenemez.",
                        "systemRecordNotSortable": "Sistem kaydı sıralanamaz",
                        "codeLabel": "Kod",
                        "nameLabel": "Ad",
                        "namePlaceholder": "Varyant grup adı",
                        "productGroups": "Ürün Grupları",
                        "items": "Öğeler",
                        "addItem": "Öğe Ekle",
                        "addItemTitle": "Yeni öğe ekle",
                        "saveGroupFirst": "Önce grubu kaydedin",
                        "reorderHint": "Öğeleri yeniden sıralamak için sürükleyip bırakın",
                        "dragToSort": "Sürükleyerek sırala",
                        "noItems": "Henüz öğe eklenmemiş",
                        "noItemsHint": "Bu varyant grubuna ilk öğeyi ekleyin.",
                        "editItemTitle": "Öğeyi Düzenle",
                        "newItemTitle": "Yeni Öğe",
                        "itemNamePlaceholder": "Örn. Siyah, Large, 42",
                        "saveGroupBeforeItem": "Öğe eklemeden önce varyant grubunu kaydedin",
                        "itemUpdateOk": "Öğe güncellendi",
                        "itemCreateOk": "Öğe eklendi",
                        "itemTitleRequired": "Lütfen tüm öğe başlıklarını doldurun",
                        "itemSaveFail": "Öğeler kaydedilirken bir hata oluştu",
                        "reorderPartialFail": "Bazı öğeler sıralanamadı, liste yenileniyor",
                        "reorderOk": "Sıralama güncellendi",
                        "reorderFail": "Sıralama kaydedilemedi"
                    },
                    "productGroups": {
                        "optionGroups": "Seçenek Grupları",
                        "variantGroups": "Varyant Grupları",
                        "detailGroups": "Detay Grupları",
                        "notDefined": "Tanımlı değil",
                        "addTitle": "Yeni Ürün Grubu",
                        "editTitle": "Ürün Grubunu Düzenle",
                        "codeLabel": "Kod",
                        "nameLabel": "Ad",
                        "namePlaceholder": "Ürün grup adı",
                        "supportedGroups": "Desteklenen Gruplar",
                        "optionGroupPlaceholder": "Seçenek grubu seçin",
                        "variantGroupPlaceholder": "Varyant grubu seçin",
                        "detailGroupPlaceholder": "Detay grubu seçin",
                        "modules": "Modüller",
                        "modulePlaceholder": "Modül seçin",
                        "cols": {
                            "code": "Kod",
                            "name": "Ad"
                        }
                    }
                },
                "save": {
                    "addTitle": "Yeni Ürün",
                    "editTitle": "Ürünü Düzenle",
                    "subtitle": "Ürün bilgilerini girin ve kaydedin.",
                    "generalInformation": "Genel Bilgiler",
                    "productGroup": "Ürün Grubu",
                    "groupLocked": "Ürün grubu oluşturulduktan sonra değiştirilemez.",
                    "productType": "Ürün Tipi",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Ürün başlığı",
                    "categories": "Kategoriler",
                    "taxes": "Vergiler",
                    "brand": "Marka",
                    "attributeSet": "Özellik Seti",
                    "attributeSetInherit": "Kategoriden miras al",
                    "attributeSetHint": "Boş bırakılırsa kategorinin seti kullanılır.",
                    "shortDescription": "Kısa Açıklama",
                    "shortDescriptionPlaceholder": "Liste ve kartlarda görünen kısa açıklama",
                    "showInList": "Listede Göster",
                    "showInListHint": "Ürün listelerinde görünsün.",
                    "showInPopular": "Popülerlerde Göster",
                    "showInPopularHint": "Popüler ürünler bölümünde görünsün.",
                    "priceRequired": "En az bir fiyat girmelisiniz.",
                    "tags": "Etiketler",
                    "tagsPlaceholder": "Etiket yazıp Enter'a basın",
                    "sort": "Sıra",
                    "mainImage": "Ana Görsel",
                    "content": "İçerik",
                    "contentPlaceholder": "Ürün açıklaması",
                    "pricing": "Fiyatlandırma",
                    "addPrice": "Fiyat Ekle",
                    "price": "Fiyat",
                    "discounted": "İndirimli",
                    "datesAndStock": "Tarihler & Stok",
                    "saleStart": "Satış Başlangıç",
                    "saleEnd": "Satış Bitiş",
                    "usageStart": "Kullanım Başlangıç",
                    "usageEnd": "Kullanım Bitiş",
                    "selectDate": "Tarih seçin",
                    "maxUsageDay": "Maks. Kullanım (Gün)",
                    "stock": "Stok",
                    "trackStock": "Stok Takibi",
                    "trackStockHint": "Kapalıysa ürün stok kontrolüne tabi olmaz (sanal ürünler).",
                    "currentStock": "Mevcut Stok",
                    "variantStockNote": "kombinasyon toplamı",
                    "errTitleRequired": "Ürün başlığı zorunludur.",
                    "errContentRequired": "Ürün içeriği (açıklama) zorunludur.",
                    "errPriceRequired": "En az bir geçerli fiyat girin (para birimi + tutar).",
                    "langSelectHint": "Çeviri alanları (başlık, içerik, SEO) seçili dile göre düzenlenir.",
                    "viewOnSite": "Ürünü sitede görüntüle",
                    "stockMovements": "Stok hareketleri",
                    "initialWarehouse": "Açılış Deposu",
                    "initialStock": "Açılış Stoğu",
                    "stockCode": "Stok Kodu",
                    "shippingWeight": "Kargo Ağırlığı (kg)",
                    "shipping": "Kargo",
                    "keywords": "Anahtar Kelimeler",
                    "keywordsPlaceholder": "kelime1, kelime2",
                    "metaTitlePlaceholder": "Meta başlık",
                    "metaDescPlaceholder": "Meta açıklama",
                    "googlePreview": "Google Önizleme",
                    "previewHint": "Başlık ~60, açıklama ~160 karakterde kesilir. Önizleme temsilidir.",
                    "yourStore": "Mağazanız",
                    "previewDescFallback": "Bu ürün için bir açıklama girildiğinde burada görünecektir.",
                    "notFound": "Ürün bulunamadı, yeni ürün ekleme ekranına yönlendirildiniz."
                }
            },
            "discount": {
                "couponCodes": {
                    "addTitle": "Yeni Kupon",
                    "editTitle": "Kuponu Düzenle",
                    "generalInfo": "Kupon Bilgileri",
                    "type": "Oluşturma Tipi",
                    "typeSingle": "Tekli",
                    "typeMulti": "Toplu",
                    "typeMultiHint": "Toplu üretimde kodlar otomatik üretilir ve Excel olarak indirilir.",
                    "codeLabel": "Kupon Kodu",
                    "codePlaceholder": "Örn. WELCOME10",
                    "generate": "Kod Üret",
                    "count": "Adet",
                    "countPlaceholder": "Örn. 100",
                    "discountType": "İndirim Tipi",
                    "discountStatic": "Sabit (₺)",
                    "discountPercent": "Yüzdesel (%)",
                    "discountValue": "İndirim Değeri",
                    "minAmount": "Minimum Sepet Tutarı",
                    "limits": "Kullanım Limitleri",
                    "totalUseLimit": "Toplam Kullanım Limiti",
                    "userUseLimit": "Kullanıcı Başına Limit",
                    "unlimitedHint": "Boş bırakılırsa sınırsız.",
                    "cannotCombined": "Diğer kuponlarla birleştirilemez",
                    "dates": "Geçerlilik Tarihleri",
                    "startDate": "Başlangıç Tarihi",
                    "endDate": "Bitiş Tarihi",
                    "datePlaceholder": "Tarih seçin",
                    "immutableHint": "Kod, indirim tipi ve değeri oluşturulduktan sonra değiştirilemez.",
                    "createOk": "Kupon oluşturuldu",
                    "multiCreateOk": "Kuponlar oluşturuldu ve Excel indirildi",
                    "updateOk": "Kupon güncellendi",
                    "unlimited": "Sınırsız",
                    "cols": {
                        "code": "Kod",
                        "type": "Tip",
                        "value": "Değer",
                        "used": "Kullanım",
                        "dates": "Tarihler"
                    }
                }
            }
        },
        "site": {
            "content": {
                "themes": {
                    "loading": "Yükleniyor…",
                    "notFound": "Tema bulunamadı.",
                    "activate": "Aktif Et",
                    "activating": "Etkinleştiriliyor…",
                    "activateSuccess": "Tema aktif edildi",
                    "actionFailed": "İşlem başarısız",
                    "customizeTheme": "Temayı Özelleştir",
                    "settingsButton": "Ayarlar",
                    "allThemes": "Tüm Temalar",
                    "activeTheme": "Aktif Tema",
                    "intro": {
                        "around": "Around, modern ve çok amaçlı bir e-ticaret temasıdır. Geniş bileşen kütüphanesi, hızlı yüklenen sayfaları ve mobil uyumlu tasarımıyla mağazanıza şık ve profesyonel bir görünüm kazandırır."
                    },
                    "settings": {
                        "title": "Tema Ayarları",
                        "description": "Temanın renk ve görünüm ayarlarını yapılandırın.",
                        "theme": "Tema",
                        "empty": "Bu tema için ayar bulunmuyor."
                    }
                },
                "themeBuilder": {
                    "title": "Sayfa Düzenleyici",
                    "description": "Sayfa seçip bileşenleri sürükle-bırak ile düzenleyin, önizleyin ve yayınlayın.",
                    "pages": "Sayfalar",
                    "pagesHint": "Düzenlemek için bir sayfa seçin.",
                    "noPages": "Özelleştirilebilir sayfa yok.",
                    "blocks": "Bileşenler",
                    "backToPages": "Sayfalara dön",
                    "addComponent": "Bileşen Ekle",
                    "addToZone": "Bu alana bileşen ekle",
                    "palette": "Bileşen Paleti",
                    "paletteHint": "Eklemek için bir bileşene tıklayın.",
                    "noComponents": "Bu alan için uygun bileşen yok.",
                    "emptyZone": "Bu alan boş — aşağıdan bileşen ekleyin.",
                    "editBlock": "Bileşeni Düzenle",
                    "blockSettings": "Bileşen Ayarları",
                    "language": "Dil",
                    "spacing": "Boşluk (px)",
                    "spacingPt": "Üst iç boşluk",
                    "spacingPb": "Alt iç boşluk",
                    "spacingMt": "Üst dış boşluk",
                    "spacingMb": "Alt dış boşluk",
                    "duplicate": "Çoğalt",
                    "remove": "Kaldır",
                    "removeBlockConfirm": "Bu bileşen kaldırılsın mı?",
                    "status": "Durum",
                    "draft": "Taslak",
                    "published": "Yayınlanan",
                    "saveDraft": "Taslağı Kaydet",
                    "saving": "Kaydediliyor…",
                    "autoSaved": "Kaydedildi",
                    "autoSavePending": "Bekliyor…",
                    "publish": "Yayınla",
                    "publishing": "Yayınlanıyor…",
                    "publishConfirm": "Taslak yayınlansın mı? Mevcut yayınlanan içerik değişecek.",
                    "preview": "Önizleme",
                    "deviceDesktop": "Masaüstü",
                    "deviceTablet": "Tablet",
                    "deviceMobile": "Mobil",
                    "goToSite": "Siteye git",
                    "openInNewTab": "Taslağı yeni sekmede aç",
                    "refreshPreview": "Önizlemeyi yenile",
                    "previewPlaceholder": "Önizleme için bir sayfa seçin.",
                    "previewLoading": "Önizleme oluşturuluyor…",
                    "previewEmpty": "Önizlenecek bileşen yok.",
                    "previewUnavailable": "Önizleme şu an kullanılamıyor.",
                    "relationId": "İlişki Kaydı",
                    "relationDefault": "Tüm kategoriler (varsayılan)",
                    "relationDefaultProduct": "Tüm ürünler (varsayılan) · ürün ara veya id gir",
                    "relationDefaultBlog": "Tüm blog yazıları (varsayılan) · ara veya id gir",
                    "relationDefaultPage": "Tüm sayfalar (varsayılan) · ara veya id gir",
                    "relationDefaultForm": "Tüm form sayfaları (varsayılan) · ara veya id gir",
                    "relationScopeDefault": "Varsayılan düzen düzenleniyor — tüm kayıtlar için geçerli.",
                    "relationScopeOverride": "Bu kayda özel düzen düzenleniyor (varsayılanı geçersiz kılar).",
                    "unsavedChanges": "Kaydedilmemiş değişiklikler var.",
                    "loadFailed": "Sayfa düzeni yüklenemedi.",
                    "saveOk": "Taslak kaydedildi.",
                    "saveFailed": "Taslak kaydedilemedi.",
                    "publishOk": "Sayfa yayınlandı.",
                    "publishFailed": "Yayınlanamadı.",
                    "category": "Kategori"
                },
                "slider": {
                    "addTitle": "Yeni Slider Grubu",
                    "editTitle": "Slider Grubunu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "aliasLabel": "Takma Ad (alias)",
                    "actions": {
                        "slides": "Slaytlar"
                    },
                    "cols": {
                        "alias": "Takma Ad",
                        "itemsCount": "Slayt Sayısı"
                    },
                    "items": {
                        "title": "Slaytlar",
                        "subtitle": "Grup #{id} slayt içeriklerini yönetin.",
                        "buttons": "Butonlar",
                        "addTitle": "Yeni Slayt",
                        "editTitle": "Slaytı Düzenle",
                        "content": "İçerik",
                        "titleLabel": "Başlık",
                        "titlePlaceholder": "Slayt başlığı",
                        "shortTitle": "Kısa Başlık",
                        "shortTitlePlaceholder": "Kısa başlık",
                        "description": "Açıklama",
                        "link": "Bağlantı (slug)",
                        "imageSettings": "Görsel & Ayarlar",
                        "scheduleSettings": "Zamanlama & Görünürlük",
                        "image": "Görsel",
                        "imagePerLangHint": "Her dil için ayrı görsel seçebilirsiniz. Boş bırakılırsa diğer dilin görseli kullanılır.",
                        "imageRequired": "Ana dil için görsel seçilmelidir.",
                        "startDate": "Başlangıç Tarihi",
                        "endDate": "Bitiş Tarihi",
                        "datePlaceholder": "Tarih seçin",
                        "sort": "Sıra",
                        "slideButtons": "Slayt Butonları",
                        "editButton": "Butonu Düzenle",
                        "newButton": "Yeni Buton",
                        "buttonText": "Buton metni",
                        "icon": "İkon",
                        "definedButtons": "Tanımlı Butonlar",
                        "loading": "Yükleniyor…",
                        "noButtons": "Henüz buton eklenmemiş.",
                        "cols": {
                            "image": "Görsel",
                            "title": "Başlık",
                            "dates": "Tarihler",
                            "sort": "Sıra",
                            "buttons": "Butonlar"
                        }
                    }
                },
                "seo": {
                    "title": "SEO",
                    "metaTitle": "Meta Başlık",
                    "metaTitlePlaceholder": "Meta başlık",
                    "metaDescription": "Meta Açıklama",
                    "metaDescriptionPlaceholder": "Meta açıklama",
                    "metaKeywords": "Meta Anahtar Kelimeler",
                    "metaKeywordsPlaceholder": "virgülle ayrılmış"
                },
                "blogCategories": {
                    "title": "Blog Kategorileri",
                    "subtitle": "Blog kategorilerini oluşturun ve yönetin.",
                    "addTitle": "Yeni Kategori",
                    "editTitle": "Kategoriyi Düzenle",
                    "general": "Genel",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Kategori adı",
                    "slug": "Slug",
                    "description": "Açıklama",
                    "sort": "Sıra",
                    "breadcrumb": "Kategoriler",
                    "cols": {
                        "title": "Başlık",
                        "postsCount": "Yazı Sayısı"
                    }
                },
                "blog": {
                    "addTitle": "Yeni Blog Yazısı",
                    "editTitle": "Blog Yazısını Düzenle",
                    "content": "İçerik",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Blog başlığı",
                    "slug": "Slug",
                    "categories": "Kategoriler",
                    "selectCategory": "Kategori seçin",
                    "image": "Görsel",
                    "summary": "Özet",
                    "summaryPlaceholder": "Kısa açıklama",
                    "contentPlaceholder": "Blog içeriği",
                    "sort": "Sıra",
                    "cols": {
                        "image": "Görsel",
                        "title": "Başlık",
                        "categories": "Kategoriler"
                    }
                },
                "pages": {
                    "addTitle": "Yeni Sayfa",
                    "editTitle": "Sayfayı Düzenle",
                    "content": "İçerik",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Sayfa başlığı",
                    "slug": "Slug",
                    "image": "Kapak Görseli",
                    "contentPlaceholder": "Sayfa içeriği (HTML)",
                    "sort": "Sıra",
                    "pageWidth": "Sayfa Genişliği",
                    "widths": {
                        "normal": "Normal",
                        "large": "Geniş",
                        "full": "Tam Genişlik"
                    },
                    "cols": {
                        "title": "Başlık",
                        "slug": "Slug"
                    }
                },
                "faq": {
                    "categoriesAction": "Kategoriler",
                    "addTitle": "Yeni Grup",
                    "editTitle": "Grubu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "code": "Kod",
                    "name": "Ad",
                    "namePlaceholder": "Örn. Genel Sorular",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "questionsCount": "Soru Sayısı"
                    }
                },
                "faqCategories": {
                    "title": "SSS Kategorileri",
                    "subtitle": "Grup #{id} kategorilerini yönetin.",
                    "questionsAction": "Sorular",
                    "addTitle": "Yeni Kategori",
                    "editTitle": "Kategoriyi Düzenle",
                    "categoryInfo": "Kategori Bilgileri",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Kategori adı",
                    "slug": "Slug",
                    "description": "Açıklama",
                    "sort": "Sıra",
                    "breadcrumb": "Kategoriler",
                    "cols": {
                        "title": "Başlık",
                        "questionsCount": "Soru Sayısı"
                    }
                },
                "faqQuestions": {
                    "title": "Sorular",
                    "subtitle": "Kategori #{id} sorularını yönetin.",
                    "addTitle": "Yeni Soru",
                    "editTitle": "Soruyu Düzenle",
                    "questionAnswer": "Soru & Cevap",
                    "question": "Soru",
                    "questionPlaceholder": "Soru metni",
                    "answer": "Cevap",
                    "answerPlaceholder": "Cevap metni",
                    "sort": "Sıra",
                    "cols": {
                        "question": "Soru",
                        "answer": "Cevap",
                        "sort": "Sıra"
                    }
                },
                "featuredProducts": {
                    "productsAction": "Ürünler",
                    "addTitle": "Yeni Grup",
                    "editTitle": "Grubu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "name": "Ad",
                    "namePlaceholder": "Örn. IELTS",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Vitrin başlığı",
                    "description": "Açıklama",
                    "sort": "Sıra",
                    "cols": {
                        "name": "Ad",
                        "title": "Başlık",
                        "productsCount": "Ürün Sayısı"
                    }
                },
                "featuredProductsItems": {
                    "title": "Öne Çıkan Ürünler",
                    "subtitle": "Grup #{id} için öne çıkan ürünleri yönetin.",
                    "addTitle": "Yeni Öne Çıkan Ürün",
                    "editTitle": "Öne Çıkan Ürünü Düzenle",
                    "productInfo": "Ürün Bilgileri",
                    "product": "Ürün",
                    "selectProduct": "Ürün seçin",
                    "productLocked": "Ürün, oluşturulduktan sonra değiştirilemez.",
                    "tag": "Etiket (watch_tag)",
                    "tagPlaceholder": "Örn. Online",
                    "description": "Açıklama",
                    "descriptionPlaceholder": "İsteğe bağlı açıklama",
                    "sort": "Sıra",
                    "breadcrumb": "Ürünler",
                    "cols": {
                        "product": "Ürün",
                        "tag": "Etiket",
                        "sort": "Sıra"
                    }
                },
                "forms": {
                    "elementsAction": "Alanlar",
                    "answersAction": "Yanıtlar",
                    "designAction": "Sayfayı Tasarla",
                    "addTitle": "Yeni Form",
                    "editTitle": "Formu Düzenle",
                    "general": "Genel",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Form başlığı",
                    "slug": "Slug",
                    "description": "Açıklama",
                    "image": "Görsel",
                    "redirectUrl": "Yanıt sonrası yönlendirme URL",
                    "redirectUrlPlaceholder": "https://... (opsiyonel)",
                    "cols": {
                        "title": "Başlık",
                        "manage": "Yönetim"
                    }
                },
                "formElements": {
                    "title": "Form Alanları",
                    "subtitle": "Form #{id} alanlarını yönetin.",
                    "addTitle": "Yeni Alan",
                    "editTitle": "Alanı Düzenle",
                    "fieldInfo": "Alan Bilgileri",
                    "fieldType": "Alan Tipi",
                    "selectType": "Tip seçin",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Örn. Adınız Soyadınız",
                    "description": "Açıklama",
                    "helpText": "Yardım metni",
                    "placeholder": "Placeholder",
                    "placeholderHint": "İpucu metni",
                    "sort": "Sıra",
                    "advanced": "Gelişmiş",
                    "advancedHint": "Doğrulama/seçenekler JSON formatında. Örn. doğrulama:",
                    "validationOptions": "Doğrulama / Seçenekler (options)",
                    "itemsLabel": "Öğeler (items) — seçim tipleri için",
                    "itemsPlaceholder": "[\"Seçenek 1\",\"Seçenek 2\"]",
                    "breadcrumb": "Alanlar",
                    "invalidJson": "options / items alanı geçerli JSON olmalı",
                    "cols": {
                        "type": "Tip",
                        "title": "Başlık",
                        "sort": "Sıra"
                    }
                },
                "formAnswers": {
                    "title": "Form Yanıtları",
                    "subtitle": "Form #{id} yanıtlarını görüntüleyin.",
                    "view": "Görüntüle",
                    "answerDetail": "Yanıt Detayı",
                    "loading": "Yükleniyor…",
                    "ip": "IP",
                    "dateLabel": "Tarih",
                    "browser": "Tarayıcı",
                    "answers": "Cevaplar",
                    "noAnswers": "Cevap yok.",
                    "breadcrumb": "Yanıtlar",
                    "exportFailed": "Dışa aktarma başarısız",
                    "cols": {
                        "ip": "IP",
                        "answersCount": "Cevap Sayısı",
                        "date": "Tarih"
                    }
                },
                "sitemap": {
                    "tabSettings": "Ayarlar",
                    "tabXml": "XML",
                    "customActive": "Özel sitemap.xml yayında",
                    "lastSaved": "Son kayıt",
                    "sectionsTitle": "Sitemap bölümleri",
                    "section": "Bölüm",
                    "urlCount": "URL",
                    "include": "Dahil",
                    "changefreq": "Değişim sıklığı",
                    "priority": "Öncelik",
                    "preview": "Önizle",
                    "sectionsHint": "Kapatılan bölüm sitemap'ten çıkar. Google değişim sıklığı ve öncelik değerlerini yalnızca ipucu olarak kullanır; asıl belirleyici sayfaların güncellenme tarihidir (lastmod, otomatik eklenir). Tek tek sayfaları gizlemek için içeriğin kendi SEO ayarındaki \"Site haritasında gizle\" seçeneğini kullanın.",
                    "sections": {
                        "general": "Anasayfa",
                        "categories": "Ürün kategorileri",
                        "products": "Ürünler",
                        "brands": "Markalar",
                        "blog-categories": "Blog kategorileri",
                        "blog": "Blog yazıları",
                        "pages": "Sayfalar",
                        "custom": "Özel URL'ler"
                    },
                    "freq": {
                        "always": "Sürekli",
                        "hourly": "Saatlik",
                        "daily": "Günlük",
                        "weekly": "Haftalık",
                        "monthly": "Aylık",
                        "yearly": "Yıllık",
                        "never": "Hiçbir zaman"
                    },
                    "customUrls": "Özel URL'ler",
                    "customUrlsHint": "Sistemin otomatik listelemediği sayfalar (ör. /iletisim, kampanya sayfaları). \"/yol\" biçiminde ya da bu sitenin tam adresiyle yazın; /sitemap/custom.xml içinde yayınlanır.",
                    "noCustomUrls": "Henüz özel URL eklenmedi.",
                    "excluded": "Hariç tutulan adresler",
                    "excludedHint": "Her satıra bir yol. \"/eski-urun\" yalnız o adresi, \"/kampanya/*\" o yolla başlayan tüm adresleri sitemap'ten çıkarır.",
                    "customXml": "Özel sitemap.xml kullan",
                    "customXmlHint": "Açıkken /sitemap.xml aşağıdaki XML'i birebir yayınlar ve otomatik oluşturma devre dışı kalır (yeni ürün/blog eklendikçe sitemap kendiliğinden güncellenmez). Yalnızca gerçekten gerekiyorsa kullanın; başlamak için \"Otomatik oluşturulanı getir\" ile mevcut index'i editöre alabilirsiniz.",
                    "loadGenerated": "Otomatik oluşturulanı getir",
                    "validate": "Doğrula",
                    "format": "Düzenle (girinti)",
                    "goToLine": "Satıra git",
                    "valid": "XML geçerli.",
                    "xmlPlaceholder": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<urlset xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\">\n  <url><loc>https://…</loc></url>\n</urlset>",
                    "emptyXml": "XML boş.",
                    "invalidXml": "XML okunamadı.",
                    "wrongRoot": "Kök etiket <urlset> ya da <sitemapindex> olmalı.",
                    "wrongNs": "Kök etiket xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\" ad alanını taşımalı.",
                    "generatedLoaded": "Otomatik oluşturulan sitemap editöre alındı.",
                    "previewUnavailable": "Bu bölüm kapalı ya da boş.",
                    "saved": "Sitemap ayarları kaydedildi.",
                    "robotsEdit": "robots.txt içeriği",
                    "robotsLoadDefault": "Varsayılanı getir",
                    "robotsHint": "Boş bırakırsanız varsayılan kullanılır. Sitemap satırı yoksa otomatik eklenir.",
                    "robotsLive": "Yayındaki robots.txt",
                    "robotsLiveHint": "Kaydettikten sonra /robots.txt adresinde görünecek içerik.",
                    "robotsSaved": "robots.txt kaydedildi."
                },
                "links": {
                    "hiddenInSearch": "Aramada gizli",
                    "hiddenInSitemap": "Site haritasında gizli",
                    "addTitle": "Yeni Yönlendirme",
                    "editTitle": "Linki Düzenle",
                    "link": "Bağlantı",
                    "content": "İçerik",
                    "redirectType": "Yönlendirme Türü",
                    "permanentRedirect": "Kalıcı Yönlendirme (301)",
                    "temporaryRedirect": "Geçici Yönlendirme (302)",
                    "slug": "Slug",
                    "redirect": "Yönlendirme (redirect)",
                    "targetSlug": "hedef-baglanti",
                    "targetSlugOptional": "hedef-baglanti (opsiyonel)",
                    "redirectHint": "Bu slug, hedef slug'a yönlendirilir.",
                    "searchEngine": "Arama Motoru",
                    "hideInSearch": "Aramada gizle (noindex)",
                    "hideInSitemap": "Site haritasında gizle",
                    "seoCard": "SEO (arama sonucu görünümü)",
                    "seoHint": "Bu sistem sayfasının Google'da ve sosyal paylaşımlarda görünecek başlık ve açıklaması. Boş bırakılan alanlar Site Ayarları'ndaki genel değerleri kullanır.",
                    "metaTitle": "Meta başlık",
                    "metaTitleHint": "Önerilen en fazla 60 karakter. Marka adı otomatik eklenmez (ör. … | PARNOVÉ).",
                    "metaDescription": "Meta açıklama",
                    "metaDescriptionHint": "Önerilen 140–155 karakter.",
                    "metaKeyword": "Anahtar kelimeler",
                    "ogImage": "Paylaşım görseli (OG) URL",
                    "canonical": "Canonical URL",
                    "chars": "karakter",
                    "typeSystem": "Sistem sayfası",
                    "typeRedirect301": "Kalıcı yönlendirme (301)",
                    "typeRedirect302": "Geçici yönlendirme (302)",
                    "cols": {
                        "language": "Dil",
                        "type": "Tür",
                        "content": "İçerik",
                        "slug": "Slug",
                        "redirect": "Yönlendirme",
                        "flags": "Bayraklar"
                    }
                },
                "menus": {
                    "addTitle": "Yeni Menü",
                    "editTitle": "Menüyü Düzenle",
                    "namePlaceholder": "Örn. Ana Menü (Header)",
                    "codeImmutable": "Kod oluşturulduktan sonra değiştirilemez (HEADER/FOOTER bileşeni bu kodu kullanır).",
                    "editItems": "Öğeleri düzenle",
                    "builderTitle": "Menü Düzenleyici",
                    "builderHint": "Öğeleri sürükleyerek sıralayın; alt seviyelere taşıyarak dropdown/mega yapısı kurun.",
                    "addItem": "Öğe Ekle",
                    "newItem": "Yeni Öğe",
                    "editItem": "Öğeyi Düzenle",
                    "empty": "Bu menüde henüz öğe yok",
                    "emptyHint": "İlk öğeyi ekleyin; link, dropdown veya mega menü olarak kurgulayabilirsiniz.",
                    "savingOrder": "Sıralama kaydediliyor…",
                    "titlePlaceholder": "Örn. Anasayfa",
                    "titleRequired": "En az bir dilde başlık girin.",
                    "perLanguage": "Dile Göre İçerik",
                    "urlHint": "Bağlantı adresi. Örn. /, /kampanya, https://...",
                    "urlContainerHint": "Kapsayıcı öğeler (dropdown/mega/kolon) için genelde boş bırakılır (# olur).",
                    "megaTabsHint": "Solda sekmeler, sağda seçilen sekmenin içeriği. Bu öğeye alt öğe olarak eklediğiniz her Kolon bir sekme olur; sekmenin içine link, başlıklı kolon veya Ürün Kartları ekleyebilirsiniz. Ürün Kartları doğrudan sekme olarak da eklenebilir.",
                    "deleteConfirm": "Bu öğe ve tüm alt öğeleri silinecek. Emin misiniz?",
                    "types": {
                        "LINK": "Link",
                        "DROPDOWN": "Açılır Menü (Dropdown)",
                        "MEGA": "Mega Menü",
                        "MEGA_TABS": "Sekmeli Mega Menü",
                        "COLUMN": "Kolon",
                        "PRODUCTS": "Ürün Kartları"
                    },
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "items": "Öğe Sayısı",
                        "type": "Tip",
                        "title": "Başlık",
                        "url": "URL",
                        "columns": "Kolon Sayısı"
                    }
                },
                "popup": {
                    "buttonsAction": "Butonlar",
                    "addTitle": "Yeni Popup",
                    "editTitle": "Popup Düzenle",
                    "drawerSubtitle": "Görünüm, zamanlama ve hedefleme ayarları",
                    "general": "Genel",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Popup başlığı",
                    "contentLabel": "İçerik",
                    "contentPlaceholder": "Popup içeriği",
                    "scheduling": "Zamanlama",
                    "startDate": "Başlangıç Tarihi",
                    "endDate": "Bitiş Tarihi",
                    "datePlaceholder": "Tarih seçin",
                    "displaySettings": "Görüntüleme Ayarları",
                    "popupType": "Popup Tipi",
                    "typeContent": "İçerik",
                    "typeImage": "Görsel",
                    "repeatDays": "Tekrar (gün)",
                    "delaySeconds": "Gecikme (sn)",
                    "sticky": "Yapışkan",
                    "stickyDuration": "Yapışkan süresi (sn)",
                    "dontShowAgain": "\"Bir daha gösterme\"",
                    "hideHeader": "Başlığı gizle",
                    "hideFooter": "Alt bilgiyi gizle",
                    "sort": "Sıra",
                    "visibility": "Görünürlük (Sayfa Hedefleme)",
                    "visibilityHint": "Gösterilecek doluysa yalnızca o sayfalarda çıkar; boş + gizlenecek doluysa onlar hariç her yerde; ikisi de boşsa her yerde.",
                    "routeSection": "Sayfalar",
                    "userLabelSection": "Kullanıcı Etiketleri",
                    "pagesToShow": "Gösterilecek sayfalar",
                    "pagesToHide": "Gizlenecek sayfalar",
                    "labelsToShow": "Gösterilecek etiketler",
                    "labelsToHide": "Gizlenecek etiketler",
                    "noRule": "Kural yok.",
                    "noRuleShow": "Kural yok (her yerde gösterilir).",
                    "noRuleHide": "Kural yok.",
                    "allHint": "type_id: belirli bir kaydın ID'si; -1 = bu tipteki tüm sayfalar.",
                    "type": "Tip",
                    "popupButtons": "Popup Butonları",
                    "editButton": "Butonu Düzenle",
                    "newButton": "Yeni Buton",
                    "buttonText": "Buton metni",
                    "link": "Bağlantı (slug)",
                    "definedButtons": "Tanımlı Butonlar",
                    "loading": "Yükleniyor…",
                    "noButtons": "Henüz buton eklenmemiş.",
                    "cols": {
                        "title": "Başlık",
                        "dates": "Tarihler",
                        "buttons": "Butonlar"
                    }
                }
            },
            "administrators": {
                "admins": {
                    "addTitle": "Yeni Yönetici",
                    "editTitle": "Yöneticiyi Düzenle",
                    "accountInfo": "Hesap Bilgileri",
                    "selectGroup": "Grup seçin",
                    "currentPassword": "Mevcut Şifre",
                    "ifRequired": "(gerekiyorsa)",
                    "newPassword": "Yeni Şifre",
                    "newPasswordConfirm": "Yeni Şifre (Tekrar)",
                    "newPasswordConfirmPlaceholder": "Yeni şifre tekrar",
                    "cols": {
                        "firstname": "Ad",
                        "lastname": "Soyad",
                        "fullname": "Ad Soyad",
                        "email": "E-Posta",
                        "group": "Grup",
                        "password": "Şifre"
                    }
                },
                "groups": {
                    "addTitle": "Yeni Grup",
                    "editTitle": "Grubu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "permissions": "İzinler",
                    "duplicate": "Çoğalt",
                    "duplicateConfirm": "\"{name}\" grubunu çoğaltmak istiyor musunuz?",
                    "duplicateSuccess": "Grup çoğaltıldı",
                    "namePlaceholder": "Örn. Editör",
                    "optionalPlaceholder": "(opsiyonel)",
                    "cols": {
                        "name": "Ad",
                        "code": "Kod",
                        "users": "Kullanıcı"
                    }
                },
                "permissions": {
                    "title": "İzin Yönetimi",
                    "groupPermissions": "{name} grubu izinleri",
                    "groupNumber": "Grup #{id}",
                    "endpointPermissions": "Endpoint İzinleri",
                    "searchPlaceholder": "Ara…",
                    "loading": "Yükleniyor…",
                    "notFound": "Endpoint bulunamadı.",
                    "endpoint": "Endpoint",
                    "otherGroup": "Diğer",
                    "saveFailed": "Kaydedilemedi",
                    "selectAllGroup": "Tüm grubu seç / kaldır"
                }
            },
            "localization": {
                "currencies": {
                    "addTitle": "Yeni Para Birimi",
                    "editTitle": "Para Birimini Düzenle",
                    "currencyInfo": "Para Birimi Bilgileri",
                    "prefix": "Ön Ek (prefix)",
                    "suffix": "Son Ek (suffix)",
                    "commissionRate": "Komisyon / Kur",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "symbol": "Sembol",
                        "commission": "Komisyon"
                    }
                },
                "languages": {
                    "addTitle": "Yeni Dil",
                    "editTitle": "Dili Düzenle",
                    "languageInfo": "Dil Bilgileri",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad"
                    }
                },
                "taxes": {
                    "addTitle": "Yeni Vergi",
                    "editTitle": "Vergiyi Düzenle",
                    "taxInfo": "Vergi Bilgileri",
                    "selectCountry": "Ülke seçin",
                    "ratePercent": "Oran (%)",
                    "sort": "Sıra",
                    "cols": {
                        "country": "Ülke",
                        "code": "Kod",
                        "name": "Ad",
                        "rate": "Oran"
                    }
                },
                "countries": {
                    "title": "Ülkeler",
                    "states": "İller",
                    "cities": "İlçeler",
                    "searchCountry": "Ülke ara...",
                    "searchState": "İl ara...",
                    "searchCity": "İlçe ara...",
                    "viewStates": "İlleri görüntüle",
                    "viewCities": "İlçeleri görüntüle",
                    "statesOf": "{name} illeri",
                    "citiesOf": "{name} ilçeleri",
                    "addCountry": "Yeni Ülke",
                    "editCountry": "Ülkeyi Düzenle",
                    "addState": "Yeni İl",
                    "editState": "İli Düzenle",
                    "addCity": "Yeni İlçe",
                    "editCity": "İlçeyi Düzenle",
                    "countryInfo": "Ülke Bilgileri",
                    "stateInfo": "İl Bilgileri",
                    "cityInfo": "İlçe Bilgileri",
                    "emptyStates": "Bu ülkeye ait il bulunmuyor.",
                    "emptyCities": "Bu ile ait ilçe bulunmuyor.",
                    "cols": {
                        "id": "ID",
                        "name": "Ad",
                        "isoCode2": "ISO Kodu (2)",
                        "isoCode3": "ISO Kodu (3)",
                        "currency": "Para Birimi",
                        "stateCount": "İl Sayısı"
                    }
                }
            },
            "settings": {
                "mediaProviders": {
                    "addTitle": "Yeni Sağlayıcı",
                    "editTitle": "Sağlayıcıyı Düzenle",
                    "providerInfo": "Sağlayıcı Bilgileri",
                    "accounts": "Hesaplar",
                    "codeImmutable": "Kod oluşturulduktan sonra değiştirilemez.",
                    "namePlaceholder": "Örn. Vimeo",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "platforms": "Platformlar",
                        "accountsCount": "Hesap Sayısı"
                    }
                },
                "mediaProvider": {
                    "description": "Sağlayıcı hesaplarını ve kimlik bilgilerini yönetin.",
                    "providers": "Sağlayıcılar",
                    "accounts": "Hesaplar",
                    "addTitle": "Yeni Hesap",
                    "editTitle": "Hesabı Düzenle",
                    "accountInfo": "Hesap Bilgileri",
                    "titlePlaceholder": "Örn. Ana Hesap",
                    "credentials": "Kimlik Bilgileri",
                    "credentialsHint": "Güvenlik için mevcut değerler gösterilmez. Değiştirmek istemiyorsanız boş bırakın.",
                    "noCredentialFields": "Bu sağlayıcı için tanımlı kimlik bilgisi alanı bulunmuyor.",
                    "cols": {
                        "title": "Başlık"
                    }
                },
                "siteSetting": {
                    "title": "Site & Anasayfa Ayarları",
                    "empty": "Tanımlı ayar alanı bulunmuyor."
                },
                "systemSetting": {
                    "title": "Kayıt Ayarları",
                    "empty": "Tanımlı ayar alanı bulunmuyor."
                },
                "registerElements": {
                    "title": "Kayıt Formu Alanları",
                    "addTitle": "Yeni Alan",
                    "editTitle": "Alanı Düzenle",
                    "nameLabel": "Alan Adı (name)",
                    "nameHint": "Formdaki alanın anahtar adı (ör. tax_number, phone). Oluşturduktan sonra değiştirilemez.",
                    "optionsTitle": "Seçenekler",
                    "inputType": "Girdi Tipi",
                    "required": "Zorunlu alan",
                    "multiple": "Çoklu seçim",
                    "items": "Seçenekler",
                    "itemText": "Etiket",
                    "itemValue": "Değer (opsiyonel)",
                    "addItem": "Seçenek ekle",
                    "itemsRequired": "Bu alan tipi için en az bir seçenek girilmelidir.",
                    "inputTypes": {
                        "text": "Metin",
                        "email": "E-posta",
                        "password": "Parola",
                        "number": "Sayı",
                        "tel": "Telefon",
                        "url": "URL",
                        "radio": "Tekli seçim (radio)",
                        "checkbox": "Onay kutusu"
                    },
                    "typeNames": {
                        "input": "Girdi",
                        "textarea": "Uzun Metin",
                        "select": "Açılır Menü",
                        "radio_group": "Radyo Grubu",
                        "checkbox_group": "Onay Kutusu Grubu",
                        "state": "İl",
                        "city": "İlçe"
                    }
                },
                "systemVariables": {
                    "addTitle": "Yeni Değişken",
                    "editTitle": "Değişkeni Düzenle",
                    "variable": "Değişken",
                    "codeImmutable": "Kod oluşturulduktan sonra değiştirilemez.",
                    "descriptionPlaceholder": "Opsiyonel açıklama",
                    "cols": {
                        "code": "Kod",
                        "value": "Değer",
                        "description": "Açıklama"
                    }
                },
                "mailTemplates": {
                    "edit": "Tasarımı Düzenle",
                    "subject": "E-Posta Konusu",
                    "customized": "Özelleştirildi",
                    "default": "Varsayılan şablon kullanılıyor",
                    "active": "Aktif",
                    "variables": "Kullanılabilir Değişkenler",
                    "test": "Test Gönder",
                    "testPlaceholder": "test{'@'}ornek.com",
                    "testSent": "Test e-postası gönderildi.",
                    "saved": "Şablon kaydedildi.",
                    "hint": "Gövde boşken sistem, temadaki varsayılan şablonu kullanmaya devam eder."
                },
                "trackingCodes": {
                    "addTitle": "Yeni İzleme Kodu",
                    "editTitle": "İzleme Kodunu Düzenle",
                    "codeInfo": "Kod Bilgileri",
                    "namePlaceholder": "Örn. Google Analytics",
                    "selectLocation": "Konum seçin",
                    "contentLabel": "İçerik (kod)",
                    "visibility": "Görünürlük (Sayfa Hedefleme)",
                    "visibilityHint": "ID için: <b>0</b> kök, <b>-1</b> ilgili tipin tümü. Boş bırakılırsa her yerde çalışır.",
                    "toShow": "Gösterilecek",
                    "toHide": "Gizlenecek",
                    "type": "Tip",
                    "consentCategory": "Çerez kategorisi",
                    "consentHint": "Analitik / Pazarlama kodları ziyaretçi çerez penceresinden izin verene kadar çalışmaz (KVKK). Yalnız sitenin çalışması için şart olan kodlar 'Zorunlu' seçilmeli.",
                    "consent": {
                        "analytics": "Analitik",
                        "marketing": "Pazarlama",
                        "necessary": "Zorunlu"
                    },
                    "cols": {
                        "name": "Ad",
                        "location": "Konum",
                        "sort": "Sıra"
                    }
                }
            }
        },
        "library": {
            "liveDataWarning": "Canlı veride işlem yapmaktasınız. Lütfen bir değişiklik yaparken dikkatli olunuz.",
            "action": {
                "selectAll": "Hepsini seç",
                "deselectAll": "Tüm seçimi kaldır"
            },
            "menu": {
                "favorites": "Favoriler",
                "trash": "Çöp Kutusu"
            }
        },
        "campaignsPage": {
            "drawer": {
                "editTitle": "Kampanyayı Düzenle",
                "createTitle": "Kampanya Oluştur"
            },
            "sections": {
                "info": "Kampanya Bilgileri",
                "discount": "İndirim",
                "buyXPayY": "X Al Y Öde",
                "targeting": "Hangi Ürünlerde Geçerli",
                "conditions": "Koşullar",
                "validityPriority": "Geçerlilik & Öncelik"
            },
            "labels": {
                "name": "Kampanya Adı",
                "type": "Kampanya Türü",
                "discountType": "İndirim Tipi",
                "discountValue": "İndirim Değeri",
                "maxDiscount": "Maksimum İndirim",
                "buyQuantity": "Alınan Adet (X)",
                "payQuantity": "Ödenen Adet (Y)",
                "minAmount": "Minimum Sepet Tutarı",
                "minQuantity": "Minimum Ürün Adedi",
                "startDate": "Başlangıç Tarihi",
                "endDate": "Bitiş Tarihi",
                "priority": "Öncelik",
                "salesChannel": "Satış Kanalı",
                "cannotCombined": "Diğer kampanyalarla birleştirilemez"
            },
            "types": {
                "cartDiscount": "Sepet İndirimi",
                "productDiscount": "Ürün İndirimi",
                "buyXPayY": "X Al Y Öde",
                "freeShipping": "Bedava Kargo"
            },
            "discountTypes": {
                "fixed": "Sabit Tutar",
                "percent": "Yüzde"
            },
            "targetModes": {
                "products": "Ürünler",
                "categories": "Kategori",
                "brands": "Marka",
                "tags": "Etiket"
            },
            "placeholders": {
                "name": "Örn. Yaz İndirimi",
                "maxDiscount": "Sınırsız",
                "searchProduct": "Ürün adı ile ara…",
                "selectCategory": "Kategori seçin",
                "selectBrand": "Marka seçin",
                "selectTag": "Etiket seçin",
                "none": "Yok",
                "selectDate": "Tarih seçin",
                "allChannels": "Tüm kanallar"
            },
            "hints": {
                "buyXPayY": "Örn. 3 Al 2 Öde → en ucuz 1 ürün bedava. Eşleşen ürünler aşağıdaki hedeflemeden alınır.",
                "targeting": "Boş bırakılırsa tüm ürünlerde geçerli olur.",
                "conditions": "Koşullar sağlandığında kampanya sepete otomatik uygulanır (kod gerekmez).",
                "priority": "Küçük değer = yüksek öncelik."
            },
            "cols": {
                "name": "Ad",
                "type": "Tür",
                "benefit": "Fayda",
                "condition": "Koşul",
                "priority": "Öncelik"
            },
            "filter": {
                "name": "Kampanya Adı",
                "type": "Tür"
            },
            "benefit": {
                "freeShipping": "Kargo Bedava",
                "buyXPayY": "{buy} Al {pay} Öde"
            },
            "units": {
                "piece": "adet"
            }
        },
        "couponCodesPage": {
            "productSectionTitle": "Hangi Ürünlerde Kullanılabilir",
            "userSectionTitle": "Hangi Kullanıcılar Kullanabilir",
            "include": "Dahil",
            "exclude": "Hariç",
            "includeHint": "Yalnızca seçilenlerde geçerli",
            "excludeHint": "Seçilenler hariç her yerde geçerli",
            "productSearchPlaceholder": "Ürün adı ile ara…",
            "categorySelectPlaceholder": "Kategori seçin",
            "brandSelectPlaceholder": "Marka seçin",
            "tagSelectPlaceholder": "Etiket seçin",
            "customerSearchPlaceholder": "Müşteri adı ile ara…",
            "userLabelSelectPlaceholder": "Kullanıcı etiketi seçin",
            "exportFileName": "kuponlar.xlsx",
            "productMode": {
                "all": "Tümü",
                "products": "Ürünler",
                "categories": "Kategori",
                "brands": "Marka",
                "tags": "Etiket"
            },
            "userMode": {
                "all": "Herkes",
                "users": "Seçili Müşteriler",
                "labels": "Etikete Göre"
            }
        },
        "draftsPage": {
            "newDraft": "Yeni Taslak",
            "customerRequiredBadge": "Müşteri gerekli",
            "itemsCount": "{count} kalem",
            "convertTooltip": "Siparişe çevir",
            "convertBtn": "Siparişe Çevir",
            "editTooltip": "Düzenle",
            "drawerTitle": "Taslak Detayı",
            "customerLabel": "Müşteri",
            "notSelected": "Seçilmedi",
            "productsWithCount": "Ürünler ({count})",
            "productNo": "Ürün #{id}",
            "pieces": "{count} adet",
            "variant": "varyant",
            "estimatedTotal": "Tahmini Toplam",
            "customerNamePlaceholder": "Müşteri adı",
            "columns": {
                "customer": "Müşteri",
                "items": "Kalem",
                "total": "Tutar",
                "note": "Not",
                "date": "Tarih"
            },
            "errors": {
                "draftCustomerRequired": "Bu taslakta müşteri seçilmemiş. Taslağı düzenleyip müşteri ekleyin, sonra siparişe çevirin.",
                "draftAlreadyConverted": "Bu taslak zaten siparişe çevrilmiş.",
                "recordNotFound": "Taslak bulunamadı.",
                "usageDateRange": "Kullanım bitiş tarihi başlangıç tarihinden önce olamaz.",
                "cartEmpty": "Taslakta ürün yok.",
                "convertFailedWithMsg": "Siparişe çevrilemedi: {msg}",
                "convertFailedGeneric": "Siparişe çevrilirken bir hata oluştu."
            },
            "customerMissingMessage": "Bu taslakta müşteri seçilmemiş. Siparişe çevirmek için önce bir müşteri eklemelisiniz. Taslağı şimdi düzenlemek ister misiniz?",
            "customerMissingHeader": "Müşteri Gerekli",
            "cancel": "Vazgeç",
            "convertConfirmMessage": "\"{name}\" taslağını gerçek siparişe çevirmek istediğinize emin misiniz? Stok bu aşamada rezerve edilir.",
            "orderCreated": "Sipariş oluşturuldu #{id}"
        },
        "abandonedCartsPage": {
            "guest": "Misafir",
            "unregisteredSession": "Kayıtsız / oturum",
            "productsWord": "ürün",
            "itemsWord": "adet",
            "recoverable": "Kurtarılabilir",
            "recoverability": "Kurtarılabilirlik",
            "detail": "Detay",
            "goToCustomer": "Müşteriye git",
            "goToCustomerBtn": "Müşteriye Git",
            "cartDetail": "Sepet Detayı",
            "customer": "Müşteri",
            "cartProducts": "Sepetteki Ürünler",
            "cartTotal": "Sepet Toplamı",
            "abandonedAgo": "{duration} önce terk edildi",
            "searchPlaceholder": "Ad / e-posta",
            "abandonStage": "Terk aşaması",
            "lastActivity": "Son aktivite",
            "column": {
                "customer": "Müşteri",
                "products": "Ürünler",
                "amount": "Tutar",
                "abandonDuration": "Terk Süresi"
            },
            "duration": {
                "justNow": "az önce",
                "minutes": "dakika",
                "hour": "saat",
                "minShort": "dk",
                "day": "gün"
            },
            "stage": {
                "active": "Aktif",
                "stage1": "1 saat+",
                "stage2": "1 gün+",
                "stage3": "3 gün+ · son fırsat",
                "lost": "7 gün+ · kayıp"
            },
            "filterStage": {
                "active": "Aktif (<1 saat)",
                "stage1": "1 saat+ (ilk hatırlatma)",
                "stage2": "1 gün+ (ikinci hatırlatma)",
                "stage3": "3 gün+ (son fırsat)",
                "lost": "7 gün+ (kayıp)"
            }
        },
        "barcodePage": {
            "print": "Yazdır",
            "addProduct": "Ürün Ekle",
            "searchPlaceholder": "En az 2 harf yazın...",
            "variantHint": "Varyantlı ürünler kombinasyon başına ayrı etikete açılır.",
            "labelSettings": "Etiket Ayarları",
            "labelsPerRow": "Satır başına etiket",
            "showName": "Ürün adını göster",
            "showPrice": "Fiyatı göster",
            "showSku": "SKU göster",
            "labels": "Etiketler",
            "clearAll": "Tümünü temizle",
            "bulkQty": "Toplu adet:",
            "applyToAll": "Tümüne uygula",
            "incEach": "Her etikete +1",
            "decEach": "Her etiketten -1",
            "toAll": "Hepsine",
            "totalPrefix": "Toplam",
            "labelWord": "etiket",
            "colProduct": "Ürün",
            "colBarcode": "Barkod",
            "colQuantity": "Adet",
            "emptyTitle": "Henüz etiket eklenmedi",
            "emptyText": "Yazdırmak için soldaki panelden ürün arayıp ekleyin. Varyantlı ürünler her kombinasyon için ayrı etikete açılır.",
            "preview": "Önizleme",
            "popupBlocked": "Yazdırma penceresi açılamadı (pop-up engeli olabilir).",
            "printTitle": "Barkod Etiketleri"
        },
        "campaignOffersPage": {
            "drawer": {
                "editTitle": "Teklifleri Düzenle",
                "addTitle": "Kampanya Teklifi Ekle"
            },
            "form": {
                "productLabel": "Ürün",
                "productSearchPlaceholder": "Ürün adı ile ara…",
                "productHint": "Bu ürünün detay sayfasında gösterilecek öneriler.",
                "crossSellTitle": "Çapraz Satış (Tamamlayıcı Ürünler)",
                "crossSellHint": "\"Birlikte alınır\" — bu ürünle birlikte önerilecek tamamlayıcı ürünler.",
                "upSellTitle": "Yukarı Satış (Daha İyi Ürün)",
                "upSellHint": "\"Bunun yerine\" — üst model / daha iyi alternatif önerileri.",
                "productAddPlaceholder": "Ürün ara ve ekle…"
            },
            "columns": {
                "product": "Ürün",
                "crossSell": "Çapraz Satış",
                "upSell": "Yukarı Satış"
            },
            "filters": {
                "productName": "Ürün Adı"
            }
        },
        "priceListSavePage": {
            "title": {
                "edit": "Fiyat Listesini Düzenle",
                "new": "Yeni Fiyat Listesi"
            },
            "subtitle": "B2B fiyat listesi — müşteri grubu/etiketine özel fiyatlandırma",
            "cancel": "Vazgeç",
            "save": "Kaydet",
            "loading": "Yükleniyor...",
            "listInfo": "Liste Bilgileri",
            "listName": "Liste Adı",
            "listNamePlaceholder": "Örn. Toptan Fiyatları",
            "listNameRequired": "Liste adı zorunludur.",
            "generalDiscount": "Genel İndirim (%)",
            "priority": "Öncelik",
            "status": "Durum",
            "active": "Aktif",
            "passive": "Pasif",
            "generalDiscountHint": "Genel indirim, ürüne özel fiyatı olmayan tüm ürünlere uygulanır.",
            "targetAudience": "Hedef Kitle",
            "customerGroups": "Müşteri Grupları",
            "selectGroup": "Grup seç",
            "customerTags": "Müşteri Etiketleri",
            "selectTag": "Etiket seç",
            "targetRequired": "En az bir müşteri grubu veya etiket seçin.",
            "targetHint": "Bu grup <b>veya</b> etikete sahip giriş yapmış müşteriler liste fiyatını görür.",
            "productsAndPrices": "Ürünler & Fiyatlar",
            "fetchByFilterTitle": "Kategori / marka / etiketle ürün çek",
            "fetchProducts": "Ürünleri Getir",
            "fetching": "Getiriliyor",
            "or": "veya",
            "searchSingleProduct": "Tek ürün ara…",
            "all": "Tümü",
            "applyToSelected": "Seçiliye uygula:",
            "percentRatePlaceholder": "% oran",
            "pricePlaceholder": "Fiyat",
            "apply": "Uygula",
            "removeSelected": "Seçilenleri Kaldır",
            "searchProduct": "Ürün ara…",
            "listPrice": "Liste fiyatı:",
            "allProduct": "Tüm ürün",
            "selectVariant": "Varyant seç",
            "noVariant": "— varyantsız",
            "emptyTitle": "Henüz ürün eklenmedi",
            "emptyText": "Yukarıdan kategori, marka veya etiketle ürünleri toplu çekin ya da tek tek arayıp ekleyin. Sonra seçip toplu indirim uygulayabilirsiniz.",
            "breadcrumb": "Fiyat Listesi",
            "edit": "Düzenle",
            "new": "Yeni",
            "filters": {
                "category": "Kategori",
                "brand": "Marka",
                "productTag": "Ürün etiketi"
            },
            "cols": {
                "product": "Ürün",
                "variant": "Varyant",
                "priceDiscount": "Fiyat / İndirim",
                "fixed": "Sabit ₺",
                "percentDiscount": "% İndirim"
            },
            "msg": {
                "alreadyInList": "Bu ürün zaten listede.",
                "productsAdded": "{count} ürün eklendi. Seçili ürünlere toplu indirim uygulayabilirsiniz.",
                "noNewProducts": "Eklenecek yeni ürün bulunamadı (zaten listede veya eşleşme yok).",
                "first500": "İlk 500 ürün getirildi — daha fazlası için filtreyi daraltın.",
                "appliedToProducts": "{count} ürüne uygulandı.",
                "badRows": "{count} ürün satırında eksik/hatalı alan var — ürün ve geçerli fiyat/oran girin."
            }
        },
        "priceListPage": {
            "cols": {
                "list": "Liste",
                "discount": "İndirim",
                "target": "Hedef",
                "specialPrice": "Özel Fiyat",
                "discountSuffix": "indirim",
                "itemsSuffix": "özel fiyat"
            },
            "filters": {
                "listName": "Liste Adı"
            },
            "msg": {
                "targetNotAssigned": "Hedef atanmadı"
            }
        },
        "cartLinksPage": {
            "cols": {
                "title": "Başlık",
                "items": "Ürünler",
                "coupon": "Kupon",
                "stats": "İstatistik",
                "expires": "Son Kullanım"
            },
            "code": "Kod",
            "product": "ürün",
            "viewCount": "Görüntülenme",
            "orderCount": "Sipariş",
            "copyUrl": "URL'yi kopyala",
            "addTitle": "Sepet Linki Oluştur",
            "editTitle": "Sepet Linkini Düzenle",
            "general": "Genel",
            "titlePlaceholder": "Örn. Kampanya sepeti",
            "titleHint": "Müşteriye gösterilmez, yalnızca sizin için.",
            "searchCoupon": "Kupon kodu ara...",
            "noExpiry": "Süresiz",
            "itemsTitle": "Ürünler",
            "addProduct": "Ürün Ekle",
            "noItems": "Henüz ürün eklenmedi",
            "searchProduct": "Ürün ara...",
            "selectVariant": "Varyant seçin",
            "noVariant": "Varyant yok",
            "personalizations": "Kişiselleştirmeler",
            "fileNotSupported": "Dosya alanı burada desteklenmez",
            "requiredFileBlock": "Zorunlu dosya alanı burada doldurulamaz",
            "fillRequiredPers": "Zorunlu kişiselleştirme alanlarını doldurun",
            "urlCopied": "URL panoya kopyalandı",
            "itemError": "Satır {row}: {error}",
            "errors": {
                "personalizationRequired": "Satır {row}: '{name}' kişiselleştirmesi zorunlu",
                "requiredVariant": "Satır {row}: Varyant seçimi zorunlu",
                "invalidVariant": "Satır {row}: Geçersiz varyant",
                "invalidProduct": "Satır {row}: Geçersiz ürün",
                "invalidQuantity": "Satır {row}: Geçersiz adet",
                "invalidPersValue": "Satır {row}: Geçersiz kişiselleştirme değeri",
                "unsupportedPers": "Satır {row}: Ürün için desteklenmeyen kişiselleştirme",
                "persValueTooLong": "Satır {row}: Kişiselleştirme değeri çok uzun",
                "persDependencyNotMet": "Satır {row}: Kişiselleştirme bağımlılığı karşılanmadı"
            }
        },
        "pendingApprovalPage": {
            "cols": {
                "customerGroup": "Müşteri Grubu"
            },
            "filters": {
                "searchPlaceholder": "Ad / e-posta"
            },
            "btn": {
                "approve": "Onayla",
                "reject": "Reddet"
            },
            "confirm": {
                "approveHeader": "B2B Onayı",
                "approveMessage": "\"{name}\" müşterisinin B2B hesabını onaylamak istediğinize emin misiniz?",
                "rejectHeader": "B2B Reddi",
                "rejectMessage": "\"{name}\" müşterisinin B2B başvurusunu reddetmek istediğinize emin misiniz?"
            },
            "msg": {
                "approved": "Müşteri onaylandı (Hesabı Var).",
                "rejected": "Müşteri reddedildi."
            }
        },
        "customerGroupsPage": {
            "editTitle": "Grubu Düzenle",
            "addTitle": "Müşteri Grubu Ekle",
            "groupName": "Grup Adı",
            "namePlaceholder": "Örn. Toptancılar, VIP",
            "assignHint": "Müşterileri gruplara müşteri düzenleme ekranından atayabilirsiniz.",
            "cols": {
                "name": "Grup Adı",
                "members": "Müşteri Sayısı"
            },
            "filters": {
                "name": "Grup Adı"
            }
        },
        "customerListPage": {
            "filters": {
                "searchPlaceholder": "Ad / e-posta",
                "customerGroup": "Müşteri Grubu",
                "b2bStatus": "B2B Durumu"
            },
            "cols": {
                "customerGroup": "Müşteri Grubu",
                "b2b": "B2B"
            },
            "states": {
                "b2bApproved": "Hesabı Var",
                "b2bPending": "Onay Bekliyor",
                "b2bRejected": "Reddedildi",
                "b2bNone": "B2B Değil"
            }
        },
        "trendyol": {
            "dashboard": {
                "connected": "Bağlı",
                "notConfigured": "Yapılandırılmadı",
                "setupTitle": "Entegrasyon henüz kurulmadı",
                "setupText": "Satıcı ID, API Key ve API Secret bilgilerini girerek Trendyol bağlantısını tamamlayın.",
                "goSettings": "Ayarlara Git",
                "productStatus": "Ürün Durumları",
                "orderStatus": "Sipariş Durumları",
                "systemHealth": "Sistem Durumu",
                "noProducts": "Henüz ürün gönderilmedi",
                "noProductsText": "Ürünler ekranından eşleştirilmiş ürünlerinizi Trendyol'a gönderebilirsiniz.",
                "manageProducts": "Ürünleri Yönet",
                "noOrders": "Henüz sipariş yok",
                "noOrdersText": "Siparişler ekranından el ile senkronizasyon başlatabilirsiniz.",
                "manageOrders": "Siparişleri Yönet",
                "sellerId": "Satıcı ID",
                "lastSync": "Son Senkronizasyon",
                "pendingBatches": "Bekleyen Toplu İşlem",
                "failedRequests": "Başarısız İstek (24 sa)",
                "lastError": "Son Hata",
                "viewLogs": "Kayıtları Gör",
                "quickActions": "Hızlı İşlemler",
                "actionSyncOrders": "Siparişleri Çek",
                "actionSyncInventory": "Stok ve Fiyat Gönder",
                "actionRefreshProducts": "Ürün Durumlarını Tazele",
                "actionSyncClaims": "İadeleri Çek",
                "actionCheckBatches": "Toplu İşlemleri Sorgula",
                "kpiProducts": "Gönderilen Ürün",
                "kpiProductsFailed": "{count} üründe hata var",
                "kpiOrders": "Sipariş Paketi",
                "kpiOrdersPending": "{count} paket aktarılmayı bekliyor",
                "kpiRevenue": "Ciro (30 gün)",
                "kpiRevenueHint": "İptal ve tedarik edilemeyenler hariç",
                "kpiClaims": "İade Talebi",
                "kpiClaimsHint": "Son 7 günde {count} adet"
            },
            "settings": {
                "title": "Trendyol Ayarları",
                "description": "API bilgileri, gönderim varsayılanları ve otomasyon tercihleri.",
                "credentials": "API Bilgileri",
                "supplierId": "Satıcı ID (Cari ID)",
                "supplierIdHelp": "Satıcı panelindeki Hesap Bilgilerim bölümünden alınır.",
                "integrator": "Entegratör Adı",
                    "integratorHelp": "User-Agent başlığında gönderilir. Kendi yazılımınızsa SelfIntegration bırakın.",
                "apiKey": "API Key",
                "apiSecret": "API Secret",
                "environment": "Ortam",
                "envProduction": "Canlı",
                "envStage": "Test (Stage)",
                "environmentHelp": "Test ortamı ayrı API anahtarı ve IP yetkilendirmesi gerektirir.",
                "enabled": "Entegrasyon etkin",
                "defaults": "Gönderim Varsayılanları",
                "shipmentAddress": "Sevkiyat Adresi",
                "returningAddress": "İade Adresi",
                "priceMarkup": "Fiyat Farkı",
                "priceMarkupHelp": "Trendyol fiyatına uygulanacak yüzde. Komisyonu karşılamak için kullanılır, 0 ise yerel fiyat aynen gider.",
                "stockBuffer": "Emniyet Stoğu",
                "stockBufferHelp": "Trendyol'a bildirilen stoktan düşülür. Aşırı satışa karşı tampon oluşturur.",
                "defaultVatRate": "KDV Oranı",
                "deliveryDuration": "Teslimat Süresi (gün)",
                "deliveryDurationHelp": "0 yazarsanız gönderilmez ve Trendyol kategori varsayılanı kullanılır. Kategorinin izin verdiği aralık dışındaki değer ürünü reddettirir.",
                "systemAdmin": "Sistem Yöneticisi",
                "systemAdminHelp": "Pazaryeri siparişleri bu yönetici adına oluşturulur.",
                "automation": "Otomasyon",
                "autoImportOrders": "Siparişleri otomatik aktar",
                "autoImportOrdersHelp": "Çekilen paketler yerel siparişe dönüştürülür ve stok rezerve edilir.",
                "autoPushInventory": "Stok değişince otomatik bildir",
                "autoPushInventoryHelp": "Stok hareketi olduğunda ilgili barkodun stok ve fiyatı Trendyol'a gönderilir.",
                "autoPushOrderStatus": "Sipariş durumunu otomatik bildir",
                "autoPushOrderStatusHelp": "Yerel sipariş hazırlanmaya alındığında Trendyol'a Picking bildirilir.",
                "testConnection": "Bağlantıyı Test Et",
                "encryptedNote": "API bilgileri veritabanında şifreli saklanır.",
                "testResult": "Test Sonucu",
                "testOk": "Bağlantı başarılı.",
                "testFailed": "Bağlantıda sorun var, ayrıntılara bakın.",
                "check": {
                    "brands": "Marka servisi",
                    "addresses": "Adres servisi",
                    "orders": "Sipariş servisi"
                },
                "stepsTitle": "Kurulum Adımları",
                "step1": "Satıcı panelinde Hesap Bilgilerim bölümünden Satıcı ID, API Key ve API Secret bilgilerini alın.",
                "step2": "Bilgileri buraya girip kaydedin, ardından Bağlantıyı Test Et ile doğrulayın.",
                "step3": "Eşleştirmeler ekranından kategori ve marka eşleştirmelerinizi yapın.",
                "step4": "Ürünler ekranından ürünlerinizi gönderin, sonucu Kayıtlar ekranından takip edin."
            },
            "mapping": {
                "title": "Trendyol Eşleştirmeleri",
                "description": "Ürün gönderiminin ön koşulu: kategori ve marka eşleştirmesi.",
                "categoryTitle": "Kategori Eşleştirme",
                "brandTitle": "Marka Eşleştirme",
                "categoryDialogTitle": "Kategori Eşleştirmesi",
                "brandDialogTitle": "Marka Eşleştirmesi",
                "localCategory": "Yerel Kategori",
                "trendyolCategory": "Trendyol Kategorisi",
                "trendyolCategoryHelp": "En alt seviye (yaprak) kategori seçilmelidir. Arama yaparak listeyi daraltın.",
                "localBrand": "Yerel Marka",
                "trendyolBrand": "Trendyol Markası",
                "brandSearchPlaceholder": "Marka adı yazın",
                "brandSearchHelp": "Trendyol marka aramasında büyük ve küçük harf ayrımı vardır.",
                "attributes": "Özellik Eşleştirme",
                "attributesHelp": "Zorunlu özellikler doldurulmazsa Trendyol ürünü reddeder. Değer sabit girilebilir, ürün özelliğinden ya da varyant grubundan okunabilir.",
                "noAttributes": "Özellik listesi boş",
                "noAttributesText": "Önce bir Trendyol kategorisi seçin.",
                "required": "Zorunlu",
                "varianter": "Varyant",
                "freeText": "Serbest metin",
                "freeTextPlaceholder": "Değer girin",
                "sourceFixed": "Sabit değer",
                "sourceAttribute": "Ürün özelliği",
                "sourceVariantGroup": "Varyant grubu",
                "attributeCount": "özellik",
                "searchPlaceholder": "Eşleştirmelerde ara",
                "requiredFields": "Zorunlu alanları doldurun."
            },
            "products": {
                "title": "Trendyol Ürünleri",
                "description": "Ürün gönderimi, stok ve fiyat senkronizasyonu.",
                "linkedTitle": "Gönderilen Ürünler",
                "candidateTitle": "Gönderilecek Ürünler",
                "product": "Ürün",
                "barcode": "Barkod",
                "price": "Fiyat",
                "stock": "Stok",
                "error": "Hata",
                "onlyFailed": "Yalnız hatalılar",
                "searchPlaceholder": "Ürün adı, barkod ya da stok kodu",
                "filterSent": "Gönderim durumu",
                "onlyUnsent": "Yalnız gönderilmemişler",
                "readiness": "Gönderime Uygunluk",
                "ready": "Hazır",
                "alreadySent": "Gönderilmiş",
                "preview": "Önizle",
                "previewTitle": "Gönderim Önizlemesi",
                "previewErrors": "Gönderimi engelleyen sorunlar",
                "refreshStatus": "Durumları Tazele",
                "pushInventory": "Stok ve Fiyat Gönder",
                "archive": "Arşivle",
                "archiveConfirm": "Seçili ürünler Trendyol'da arşive alınacak. Devam edilsin mi?",
                "removeFromTrendyol": "Trendyol'dan Sil",
                "removeConfirm": "Seçili ürünler Trendyol'dan silinecek ve yerel bağ kaldırılacak. Bu işlem geri alınamaz.",
                "pushSelected": "Seçilenleri Gönder ({count})",
                "pushQueued": "{count} kalem kuyruğa alındı, {batches} toplu işlem oluşturuldu. Sonuç birkaç dakika içinde Kayıtlar ekranına düşer.",
                "onSale": "Satışta",
                "locked": "Kilitli",
                "openOnTrendyol": "Trendyol'da aç",
                "editProduct": "Ürünü düzenle",
                "rePush": "Yeniden gönder"
            },
            "productStatus": {
                "unsent": "Gönderilmedi",
                "pending": "Onay Bekliyor",
                "approved": "Onaylı",
                "rejected": "Reddedildi",
                "archived": "Arşivde",
                "failed": "Hatalı"
            },
            "issues": {
                "category_mapping_missing": "Kategori eşleştirmesi yok",
                "brand_mapping_missing": "Marka eşleştirmesi yok",
                "product_image_missing": "Ürün görseli yok",
                "price_missing": "Fiyat tanımlı değil",
                "product_title_missing": "Ürün adı yok",
                "barcode_missing": "Barkod üretilemedi"
            },
            "orders": {
                "title": "Trendyol Siparişleri",
                "description": "Sipariş paketlerini çekin, yerel siparişe aktarın ve statü bildirin.",
                "order": "Sipariş",
                "package": "Paket",
                "itemsWord": "kalem",
                "customer": "Müşteri",
                "total": "Tutar",
                "trendyolStatus": "Trendyol Durumu",
                "localOrder": "Yerel Sipariş",
                "cargo": "Kargo",
                "tracking": "Takip No",
                "date": "Tarih",
                "detail": "Detay",
                "lines": "Sipariş Kalemleri",
                "shipmentAddress": "Teslimat Adresi",
                "import": "Siparişe Aktar",
                "imported": "Aktarıldı",
                "notImported": "Aktarılmadı",
                "importFailed": "Aktarım Hatası",
                "importStatus": "Aktarım Durumu",
                "ignored": "Yoksayıldı",
                "ignore": "Yoksay",
                "openLocalOrder": "Yerel Siparişi Aç",
                "markPicking": "Hazırlanıyor bildir",
                "markInvoiced": "Faturalandı bildir",
                "unsupplied": "Tedarik Edilemedi",
                "unsuppliedWarning": "Bu işlem paketi Trendyol'da iptal eder ve geri alınamaz.",
                "unsuppliedReason": "İptal Sebebi",
                "sync": "Senkronize Et",
                "lastDays": "Son {days} gün",
                "syncResult": "{fetched} paket çekildi, {created} yeni, {imported} aktarıldı, {failed} hatalı.",
                "searchPlaceholder": "Sipariş no, paket no, müşteri ya da takip no",
                "statusConfirm": "Paket durumu Trendyol'a {status} olarak bildirilecek. Devam edilsin mi?",
                "invoiceNumber": "Fatura Numarası",
                "invoiceNumberPlaceholder": "Zorunlu değil",
                "invoiceNumberHelp": "Yalnız Faturalandı bildiriminde gönderilir.",
                "sendInvoiceLink": "Fatura Linki Gönder",
                "invoiceLink": "Fatura Linki",
                "invoiceLinkHelp": "E-Arşiv ya da e-Fatura PDF adresi. Yasal olarak 10 yıl erişilebilir kalmalıdır.",
                "invoiceLinkRequired": "Fatura linki zorunludur."
            },
            "orderStatus": {
                "Awaiting": "Bekliyor",
                "Created": "Yeni",
                "Picking": "Hazırlanıyor",
                "Invoiced": "Faturalandı",
                "Shipped": "Kargoda",
                "Delivered": "Teslim Edildi",
                "UnDelivered": "Teslim Edilemedi",
                "Cancelled": "İptal",
                "UnSupplied": "Tedarik Edilemedi",
                "Returned": "İade",
                "AtCollectionPoint": "Toplama Noktasında"
            },
            "unsuppliedReason": {
                "500": "Ürün stokta yok",
                "501": "Ürün hasarlı",
                "502": "Yanlış ürün ya da fiyat",
                "504": "Müşteri talebiyle iptal",
                "505": "Diğer",
                "506": "Ürün tedarik edilemiyor"
            },
            "claims": {
                "title": "Trendyol İadeleri",
                "description": "İade taleplerini görüntüleyin ve depo kabulünü onaylayın.",
                "claim": "İade Talebi",
                "items": "İade Kalemleri",
                "itemsWord": "kalem",
                "date": "Talep Tarihi",
                "detail": "Detay",
                "approve": "Onayla",
                "approveAll": "Tüm Kalemleri Onayla",
                "approveConfirm": "İade kalemleri depoya kabul edilmiş sayılacak. Devam edilsin mi?",
                "approveHelp": "Onaylama servisi dakikada 5 istekle sınırlıdır, talepler tek tek onaylanır.",
                "sync": "Senkronize Et",
                "syncResult": "{fetched} talep çekildi, {created} yeni kayıt eklendi.",
                "searchPlaceholder": "Sipariş no, talep no ya da müşteri"
            },
            "logs": {
                "title": "Trendyol Kayıtları",
                "description": "Toplu işlem sonuçları ve ham istek kayıtları.",
                "batchTitle": "Toplu İşlemler",
                "requestTitle": "İstek Kayıtları",
                "batch": "İşlem",
                "items": "Kalem",
                "failedWord": "hatalı",
                "date": "Tarih",
                "detail": "Detay",
                "code": "Kod",
                "duration": "Süre",
                "type": "Tür",
                "context": "Bağlam",
                "onlyFailed": "Yalnız hatalılar",
                "checkNow": "Şimdi Sorgula",
                "checkResult": "{count} toplu işlem sonuçlandı.",
                "prune": "Eski Kayıtları Temizle",
                "pruneConfirm": "30 günden eski istek kayıtları silinecek. Devam edilsin mi?",
                "pruneResult": "{count} kayıt silindi.",
                "payload": "İstek Gövdesi",
                "response": "Yanıt"
            },
            "batchType": {
                "product_create": "Ürün Gönderimi",
                "product_content_update": "İçerik Güncelleme",
                "product_variant_update": "Varyant Güncelleme",
                "inventory": "Stok ve Fiyat",
                "archive": "Arşivleme",
                "delete": "Silme"
            },
            "logContext": {
                "product": "Ürün",
                "inventory": "Stok ve Fiyat",
                "order": "Sipariş",
                "claim": "İade",
                "lookup": "Referans",
                "settings": "Ayarlar",
                "general": "Genel"
            }
        },
        "shopier": {
            "dashboard": {
                "productsForbiddenTitle": "Shopier bu hesapta ürün API'sini kapatmış (403)",
                "productsForbiddenText": "Kategori, sipariş ve webhook uçları çalışıyor; ancak Shopier ürün uçlarına (listeleme, okuma, oluşturma) erişimi reddediyor. Bu bir izin (scope) sorunu değil — token tüm izinlere sahip. Shopier desteğinden hesabınız için ürün API erişimini açtırmanız gerekiyor. O zamana kadar: siparişler aktarılır (ürünler isimle eşleştirilir), Shopier webhook'larıyla gelen ürün değişiklikleri uygulanır ve \"Elle Eşle\" ile bağ kurulabilir.",
                "title": "Shopier",
                "description": "Shopier entegrasyonunun durumu ve hızlı işlemler.",
                "connected": "Bağlı",
                "notConfigured": "Yapılandırılmadı",
                "setupTitle": "Shopier bağlantısı henüz kurulmadı",
                "setupText": "Shopier hesabınızda ürettiğiniz Personal Access Token'ı (PAT) ayarlara girerek başlayın.",
                "goSettings": "Ayarlara Git",
                "linkedProducts": "Bağlı ürün",
                "importedOrders": "Aktarılan sipariş",
                "revenue30d": "Son 30 gün ciro",
                "webhooks": "Webhook olayları",
                "failedCount": "{count} hatalı",
                "last24h": "son 24 saat",
                "invalidSig": "{count} geçersiz imza",
                "quickActions": "Hızlı İşlemler",
                "importAll": "Tüm ürünleri içe aktar",
                "importAllHelp": "Shopier'deki tüm ürün, kategori ve varyantları siteye aktarır (stok dahil).",
                "syncOrders": "Siparişleri senkronla",
                "syncOrdersHelp": "Son 7 günün Shopier siparişlerini çeker ve aktarır.",
                "pushProducts": "Siteden Shopier'e gönder",
                "pushProductsHelp": "Sitedeki ürünleri seçip Shopier'de oluşturun/güncelleyin.",
                "webhookHelp": "Anlık sipariş ve ürün bildirimleri için Shopier'e abonelik kurar.",
                "features": "Özellikler",
                "featureApi": "API bağlantısı",
                "featureWebhook": "Webhook (anlık senkron)",
                "featureBuyButton": "\"Shopier'den Satın Al\" butonu",
                "featurePayment": "Shopier ile ödeme (sepet)",
                "on": "Açık",
                "off": "Kapalı",
                "lastError": "Son hata",
                "viewLogs": "Kayıtları gör"
            },
            "settings": {
                "authMethod": "Bağlantı yöntemi",
                "authOAuth": "Shopier uygulaması (önerilen)",
                "authPat": "Personal Access Token (PAT)",
                "authOAuthHelp": "Shopier'in önerdiği yöntem: Shopier Geliştirici Portalı'nda oluşturduğunuz uygulamanın bilgilerini girip \"Shopier ile Bağlan\"a tıklayın. Token paylaşmanız gerekmez; erişim otomatik yenilenir.",
                "authPatHelp": "Yalnız kendi hesabınız için. Shopier, hizmet aldığınız yazılıma PAT vermek yerine uygulama kullanılmasını önerir.",
                "clientId": "Client ID",
                "clientSecret": "Client Secret",
                "redirectUri": "Redirect URI (Yönlendirme adresi)",
                "redirectUriHelp": "Bu adresi Shopier uygulamanızın \"Redirect URI\" alanına BİREBİR girin (https:// ile başlamalı). Boş bırakırsanız gösterilen adres kullanılır.",
                "oauthConnected": "Bağlı",
                "oauthNotConnected": "Bağlı değil",
                "oauthConnectedAt": "Bağlanma: {date}",
                "connectShopier": "Shopier ile Bağlan",
                "reconnect": "Yeniden bağlan",
                "disconnect": "Bağlantıyı kes",
                "oauthScope": "Verilen izinler",
                "oauthWebhookHelp": "Uygulama modunda webhook'lar Shopier Geliştirici Portalı'nda uygulamanızın \"Webhook olay bildirimleri\" bölümünden tanımlanır: tüm olayları seçip her birine yukarıdaki webhook adresini girin. Uygulama sayfasındaki webhook token'ını aşağıdaki \"Ek webhook token'ı\" alanına yapıştırın (imza doğrulaması için).",
                "oauthConnectedToast": "Shopier hesabı bağlandı",
                "title": "Shopier Ayarları",
                "description": "Bağlantı, iki yönlü ürün senkronu, sipariş, ödeme ve vitrin ayarları.",
                "connection": "Bağlantı",
                "pat": "Personal Access Token (PAT)",
                "patPlaceholder": "Shopier > Hesap > Personal Access Token",
                "patHelp": "Shopier hesabınızda Hesap > Personal Access Token bölümünden üretin (2FA açık olmalı). Token yalnız bir kez gösterilir.",
                "enabled": "Entegrasyon etkin",
                "importSection": "Ürünler: Shopier → Site",
                "autoPull": "Shopier değişikliklerini otomatik uygula",
                "autoPullHelp": "Shopier'de ürün eklenince/güncellenince (webhook) sitedeki ürün de güncellenir. Stoğa dokunulmaz.",
                "autoCreate": "Shopier'de yeni ürün açılınca sitede oluştur",
                "autoCreateHelp": "Kapalıysa yalnız bağlı ürünler güncellenir.",
                "updateExisting": "Bağlı ürünleri güncelle",
                "updateExistingHelp": "Kapalıysa içe aktarma yalnız yeni ürün oluşturur, mevcutlara dokunmaz.",
                "newActive": "Yeni ürünler aktif olsun",
                "newActiveHelp": "Kapalıysa içe aktarılan ürünler taslak (pasif) açılır.",
                "importFields": "Shopier'den alınacak alanlar",
                "importFieldsHelp": "Stok yalnız ilk içe aktarmada (ve \"stok dahil\" seçildiğinde) alınır; sonrasında stoğun kaynağı sitedir.",
                "productGroup": "Varsayılan ürün grubu",
                "warehouse": "Stoğun yazılacağı depo",
                "warehouseDefault": "Varsayılan depo",
                "exportSection": "Ürünler: Site → Shopier",
                "autoPush": "Sitede değişince Shopier'i otomatik güncelle",
                "autoPushHelp": "Shopier'e bağlı bir ürün sitede düzenlenince (başlık, fiyat, görsel, stok…) Shopier'deki ürün de güncellenir.",
                "pushFields": "Shopier'e gönderilecek alanlar",
                "pushFieldsHelp": "Seçilmeyen alanlar Shopier'de değiştirilmez (Shopier'de elle yapılan düzenlemeler korunur).",
                "priceMarkup": "Fiyat farkı",
                "priceMarkupHelp": "Shopier fiyatına eklenecek yüzde (komisyon için). Negatif değer indirim uygular.",
                "stockBuffer": "Emniyet stoğu",
                "stockBufferHelp": "Shopier'e bildirilen stoktan düşülür (fazla satışı önler).",
                "shippingPayer": "Kargo ücretini kim öder",
                "buyerPays": "Alıcı öder",
                "sellerPays": "Satıcı öder",
                "dispatchDuration": "Kargoya verme süresi",
                "days": "gün",
                "defaultVat": "Varsayılan KDV",
                "defaultVatHelp": "Ürünün vergisi yoksa kullanılır. Shopier yalnız %0/1/10/20 kabul eder.",
                "ordersSection": "Siparişler",
                "autoImportOrders": "Shopier siparişlerini otomatik aktar",
                "autoImportOrdersHelp": "Yeni Shopier siparişleri siteye sipariş olarak düşer, stok rezerve edilir.",
                "pushFulfillment": "Kargoya verince Shopier'de kapat",
                "pushFulfillmentHelp": "Sitede Shopier siparişine kargo takip no girilince sipariş Shopier'de otomatik kapatılır.",
                "ordersSince": "Bu tarihten itibaren aktar",
                "ordersSinceHelp": "Daha eski Shopier siparişleri aktarılmaz.",
                "systemAdmin": "Siparişleri oluşturan yönetici",
                "cargoMap": "Kargo firması eşlemesi",
                "cargoMapHelp": "Sitedeki kargo yöntemi → Shopier'de sipariş kapatılırken bildirilecek firma. Boşsa isimden tahmin edilir.",
                "cargoAuto": "Otomatik",
                "storefrontSection": "Vitrin ve Ödeme",
                "buyButton": "\"Shopier'den Satın Al\" butonu",
                "cartDisabled": "Sepeti kapat — yalnız Shopier'den satış",
                "cartDisabledHelp": "Sepet, sepete ekle butonları ve sepet sayfası kapanır. Shopier'e bağlı ürünlerde \"Shopier'den Satın Al\" butonu yeni sekmede Shopier ürün sayfasını açar (adet ve müşteri referansıyla). Bağlı olmayan ürünler satın alınamaz.",
                "freeShippingThreshold": "Ücretsiz kargo alt limiti (₺)",
                "freeShippingThresholdHelp": "Shopier dükkanınızdaki \"X ₺ ve üzeri ücretsiz kargo\" tutarı. Shopier bunu API'de paylaşmadığı için buraya girin; 0 = limit yok (Shopier ürün ayarı kullanılır).",
                "shippingFee": "Limit altı kargo ücreti (₺)",
                "shippingFeeHelp": "Boş bırakılırsa ürünün Shopier'deki kargo ücreti kullanılır.",
                "buyButtonHelp": "Shopier'e bağlı ürünlerin detay sayfasında müşteriyi doğrudan Shopier ürün sayfasına götüren buton.",
                "buyButtonLabel": "Buton metni",
                "payment": "Shopier ile ödeme (sepet)",
                "paymentHelp": "Sepetteki ürünlerin ödemesi Shopier'in güvenli ödeme sayfasında alınır; sipariş sitede kalır. Shopier > Entegrasyonlar > Modül Yönetimi'nden API bilgileri alınır.",
                "paymentApiKey": "API Kullanıcı (Key)",
                "paymentApiSecret": "API Şifre (Secret)",
                "paymentTitle": "Sepette görünecek ad",
                "websiteIndex": "Web sitesi sırası",
                "callbackUrl": "Geri dönüş URL'si",
                "callbackUrlHelp": "Bu adresi Shopier modül ayarlarında seçtiğiniz web sitesi sırasının \"Geri dönüş URL\" alanına girin.",
                "webhookSection": "Webhook (anlık senkron)",
                "webhookUrl": "Webhook adresi",
                "registerWebhooks": "Webhook'ları kur",
                "unregisterWebhooks": "Kaldır",
                "webhooksActive": "{count} olay aboneliği aktif",
                "webhooksNone": "Abonelik yok — siparişler 15 dakikada bir taranır.",
                "webhooksRegistered": "Webhook abonelikleri kuruldu",
                "webhookVerify": "İmza doğrulaması",
                "webhookVerifyHelp": "Kapalıysa imzası doğrulanamayan olaylar da işlenir (önerilmez).",
                "webhookToken": "Ek webhook token'ı",
                "webhookTokenHelp": "Webhook'u Shopier panelinden elle kurduysanız oradaki token'ı girin. Buradan kurulan aboneliklerin token'ı otomatik saklanır.",
                "testConnection": "Bağlantıyı Test Et",
                "testOk": "Bağlantı başarılı",
                "testFailed": "Bazı kontroller başarısız",
                "encryptedNote": "Token ve API bilgileri şifreli saklanır.",
                "copied": "Kopyalandı",
                "check": {
                    "shop": "Mağaza bilgisi",
                    "products": "Ürünler",
                    "categories": "Kategoriler",
                    "orders": "Siparişler"
                },
                "stepsTitle": "Kurulum Adımları",
                "step1": "Shopier Geliştirici Portalı'nda uygulama oluşturun (Redirect URI ve webhook adreslerini bu sayfadan kopyalayın), Client ID/Secret'ı girip kaydedin ve \"Shopier ile Bağlan\"a tıklayın. Yalnız kendi hesabınız içinse PAT da kullanabilirsiniz.",
                "step2": "\"Bağlantıyı Test Et\" ile erişimi doğrulayın. PAT kullanıyorsanız \"Webhook'ları kur\" ile anlık bildirimleri açın; uygulama kullanıyorsanız webhook'ları uygulama sayfasında tanımlayın.",
                "step3": "Ürünler ekranından Shopier ürünlerini siteye aktarın ya da site ürünlerini Shopier'e gönderin.",
                "step4": "İsterseniz ürün sayfasına \"Shopier'den Satın Al\" butonunu açın.",
                "step5": "Sepette Shopier ile ödeme için modül API bilgilerini girip geri dönüş URL'sini Shopier'e tanımlayın."
            },
            "products": {
                "importStale": "İş kuyrukta bekliyor — kuyruk işçisi (php artisan queue:work) çalışmıyor olabilir.",
                "title": "Shopier Ürünleri",
                "description": "Ürünleri Shopier ile iki yönlü yönetin.",
                "linkedTitle": "Bağlı Ürünler",
                "remoteTitle": "Shopier'deki Ürünler",
                "siteTitle": "Sitedeki Ürünler",
                "product": "Ürün",
                "price": "Fiyat",
                "stock": "Stok",
                "siteStock": "Site",
                "site": "Site",
                "variants": "{count} varyant",
                "lastSync": "Son senkron",
                "openOnShopier": "Shopier'de aç",
                "editProduct": "Ürünü düzenle",
                "pushNow": "Shopier'e gönder",
                "pullNow": "Shopier'den yeniden al",
                "unlink": "Bağı kaldır",
                "unlinkConfirm": "\"{title}\" ürününün Shopier bağı kaldırılacak. Sitedeki ürün silinmez.",
                "deleteOnShopier": "Ürünü Shopier'den de sil",
                "manualLink": "Elle Eşle",
                "manualLinkHelp": "Sitede ve Shopier'de zaten var olan iki ürünü birbirine bağlar (ürün oluşturmaz). Shopier ürün ID'si ürün adresinin sonundaki sayıdır.",
                "siteProduct": "Sitedeki ürün",
                "shopierProductId": "Shopier ürün ID",
                "includeStock": "Stok dahil",
                "importSelected": "Seçilenleri aktar ({count})",
                "importAll": "Tümünü içe aktar",
                "importOne": "Siteye aktar",
                "importRunning": "İçe aktarma sürüyor…",
                "importDone": "İçe aktarma tamamlandı",
                "importQueued": "İçe aktarma arka planda başlatıldı",
                "importSummary": "Oluşturulan {created} · Güncellenen {updated} · Atlanan {skipped} · Hatalı {failed}",
                "importedCount": "{count} ürün aktarıldı",
                "pushedCount": "{count} ürün Shopier'e gönderildi",
                "someFailed": "{count} ürün başarısız",
                "pushSelected": "Seçilenleri gönder ({count})",
                "pushQueued": "{count} ürün arka planda gönderiliyor",
                "pulled": "Ürün Shopier'den güncellendi",
                "changedOnShopier": "Shopier'de değişti",
                "inSync": "Senkron",
                "notOnSite": "Sitede yok",
                "siteState": "Site durumu",
                "shopierState": "Shopier durumu",
                "onShopier": "Shopier'de",
                "readyToPush": "Gönderilebilir",
                "passive": "Pasif",
                "inStock": "Stokta",
                "outOfStock": "Tükendi",
                "onlyUnlinked": "Yalnız Shopier'de olmayanlar",
                "onlyActive": "Yalnız aktifler",
                "searchPlaceholder": "Ürün adı ya da Shopier ID",
                "preview": "Gönderim önizlemesi",
                "previewTitle": "Shopier'e gönderilecek veri",
                "willCreate": "Shopier'de yeni ürün oluşturulacak",
                "willUpdate": "Shopier'deki ürün güncellenecek"
            },
            "orders": {
                "title": "Shopier Siparişleri",
                "description": "Shopier siparişlerini aktarın, takip edin ve kapatın.",
                "syncHint": "Siparişler webhook ile anında, ayrıca 15 dakikada bir otomatik aktarılır.",
                "syncNow": "Şimdi senkronla",
                "lastDays": "Son {days} gün",
                "syncResult": "{fetched} sipariş çekildi · {imported} aktarıldı · {failed} hatalı",
                "order": "Sipariş",
                "customer": "Müşteri",
                "total": "Tutar",
                "importState": "Aktarım",
                "localOrder": "Site siparişi #{id}",
                "detail": "Detay",
                "detailTitle": "Shopier siparişi #{id}",
                "import": "Siteye aktar",
                "imported": "Sipariş aktarıldı",
                "fulfill": "Shopier'de kapat",
                "fulfilled": "Sipariş Shopier'de kapatıldı",
                "ignore": "Yok say",
                "items": "Ürünler",
                "shipping": "Kargo",
                "discount": "İndirim",
                "address": "Teslimat adresi",
                "note": "Alıcı notu",
                "rawPayload": "Ham veri",
                "searchPlaceholder": "Sipariş no, müşteri adı ya da e-posta",
                "refund_partial": "Kısmi iade",
                "refund_full": "Tam iade"
            },
            "logs": {
                "title": "Shopier Kayıtları",
                "description": "API istekleri ve gelen webhook olayları.",
                "requests": "İstekler",
                "webhooks": "Webhook Olayları",
                "endpoint": "Uç nokta",
                "date": "Tarih",
                "event": "Olay",
                "context": "Bağlam",
                "onlyFailed": "Yalnız hatalılar",
                "invalidSignature": "İmza geçersiz",
                "retry": "Yeniden işle",
                "detail": "Kayıt detayı",
                "payload": "Gönderilen",
                "response": "Yanıt",
                "prune": "30 günden eskileri sil",
                "pruned": "Eski kayıtlar silindi"
            },
            "fields": {
                "title": "Başlık",
                "description": "Açıklama",
                "price": "Fiyat",
                "images": "Görseller",
                "categories": "Kategoriler",
                "stock": "Stok"
            },
            "linkStatus": {
                "linked": "Bağlı",
                "failed": "Hatalı",
                "deleted": "Shopier'de yok"
            },
            "orderStatus": {
                "unfulfilled": "Hazırlanacak",
                "fulfilled": "Kargolandı"
            },
            "importStatus": {
                "pending": "Bekliyor",
                "imported": "Aktarıldı",
                "failed": "Hatalı",
                "ignored": "Yok sayıldı"
            },
            "webhookStatus": {
                "pending": "Bekliyor",
                "processed": "İşlendi",
                "skipped": "Atlandı",
                "failed": "Hatalı"
            },
            "issues": {
                "shopier_oauth_client_missing": "Önce Client ID ve Client Secret girip kaydedin",
                "shopier_oauth_not_selected": "Bağlantı yöntemi olarak Shopier uygulamasını seçip kaydedin",
                "shopier_oauth_webhooks_managed_in_app": "Uygulama modunda webhook'lar Shopier Geliştirici Portalı'ndan tanımlanır",
                "shopier_oauth_invalid_state": "Oturum süresi doldu, yeniden bağlanın",
                "product_image_missing": "Görsel yok",
                "image_format_unsupported": "Görsel biçimi desteklenmiyor (jpg/png)",
                "price_missing": "Fiyat yok",
                "product_price_missing": "Fiyat yok",
                "product_title_missing": "Başlık yok",
                "shopier_not_configured": "Shopier bağlantısı kurulmadı",
                "shopier_unauthorized": "Shopier yetkisiz (PAT hatalı ya da izin eksik)",
                "shopier_forbidden": "Shopier bu kaynağa erişimi kapatmış (403) — Shopier'den açtırılmalı",
                "shopier_not_found": "Shopier'de bulunamadı",
                "shopier_too_many_requests": "Shopier istek limiti aşıldı, biraz sonra deneyin",
                "ids_or_all_required": "Ürün seçin"
            }
        },
        "productCatalog": {
            "loading": "Yükleniyor…",
            "cancel": "Vazgeç",
            "save": "Kaydet",
            "saved": "Kaydedildi",
            "delete": "Sil",
            "deleted": "Silindi",
            "status": {
                "public": "Yayında",
                "draft": "Taslak",
                "inactive": "Pasif"
            },
            "matchStatus": {
                "auto": "Otomatik",
                "manual": "Elle",
                "none": "Eşleşmedi"
            },
            "types": {
                "text": "Metin",
                "long_text": "Uzun metin",
                "number": "Sayı",
                "link": "Bağlantı",
                "image": "Görsel (URL)",
                "tags": "Etiket listesi",
                "category": "Kategori (sistem)"
            },
            "productFields": {
                "image": "Ürün görseli",
                "title": "Ürün adı",
                "price": "Fiyat",
                "stock": "Stok durumu",
                "link": "Ürüne Git butonu",
                "brand": "Marka",
                "category": "Kategori",
                "stock_code": "Stok kodu / SKU",
                "short_description": "Kısa açıklama"
            },
            "errors": {
                "catalog_key_column_required": "Otomatik eşleştirme için Kurallar sekmesinden bir anahtar sütun seçin.",
                "catalog_import_empty_file": "Dosyada okunabilir veri bulunamadı.",
                "catalog_import_file_expired": "Yüklenen dosyanın süresi doldu, lütfen yeniden yükleyin.",
                "catalog_import_invalid_token": "Geçersiz dosya, lütfen yeniden yükleyin.",
                "catalog_import_no_columns": "En az bir sütunu içe aktarın.",
                "catalog_column_product_field_required": "Ürün sütunu için bir ürün alanı seçin.",
                "validate_error": "Lütfen alanları kontrol edin."
            },
            "list": {
                "title": "Ürün Katalogları",
                "description": "Excel'den katalog oluşturun, ürünlerinizle eşleştirin ve yayınlayın.",
                "newEmpty": "Boş Katalog",
                "newFromExcel": "Excel'den Oluştur",
                "newEmptyHint": "Katalog ürün görseli, adı, fiyatı ve \"Ürüne Git\" sütunlarıyla başlar; ek sütunları sonra ekleyebilirsiniz.",
                "create": "Oluştur",
                "appMissingTitle": "Ürün Kataloğu uygulaması kurulu değil",
                "appDisabledTitle": "Ürün Kataloğu uygulaması pasif",
                "appMissingText": "Katalogları hazırlayabilirsiniz; ancak vitrinde görünmeleri için uygulamanın kurulu ve etkin olması gerekir.",
                "installApp": "Uygulamayı Kur",
                "enableApp": "Uygulamayı Etkinleştir",
                "emptyTitle": "Henüz katalog yok",
                "emptyText": "Excel dosyanızı yükleyin; sütunlar otomatik algılanır, satırlar ürünlerinizle eşleştirilir.",
                "rows": "Satır",
                "columns": "Sütun",
                "matched": "Eşleşen",
                "matchRate": "Ürünle eşleşme: {percent}",
                "manage": "Yönet",
                "viewOnStore": "Vitrinde gör",
                "deleteConfirm": "\"{name}\" kataloğu ve tüm satırları silinsin mi?"
            },
            "detail": {
                "description": "Satırları ürünlerinizle eşleştirin, sütunları ve kuralları düzenleyin.",
                "notFound": "Katalog bulunamadı.",
                "back": "Kataloglara dön",
                "downloadExcel": "Excel İndir",
                "uploadExcel": "Excel Yükle",
                "viewOnStore": "Vitrinde Gör",
                "unmatched": "Eşleşmeyen",
                "tabs": {
                    "items": "Ürünler",
                    "columns": "Sütunlar",
                    "rules": "Kurallar",
                    "preview": "Önizleme"
                }
            },
            "items": {
                "search": "Satırlarda ara…",
                "selected": "{count} seçili",
                "bulk": "Toplu işlem",
                "bulkActions": {
                    "activate": "Etkinleştir",
                    "deactivate": "Pasifleştir",
                    "unmatch": "Eşleşmeyi kaldır",
                    "delete": "Sil"
                },
                "bulkDone": "{count} satır güncellendi",
                "bulkDeleteConfirm": "{count} satır silinsin mi?",
                "filters": {
                    "all": "Tümü ({count})",
                    "matched": "Eşleşen ({count})",
                    "unmatched": "Eşleşmeyen ({count})",
                    "auto": "Otomatik eşleşen ({count})",
                    "manual": "Elle eşleşen ({count})",
                    "inactive": "Pasif ({count})"
                },
                "autoMatch": "Otomatik Eşleştir",
                "autoMatchUnmatched": "Yalnız eşleşmeyenler",
                "autoMatchAll": "Otomatikleri de yeniden dene (elle eşleşenlere dokunmaz)",
                "autoMatchDone": "{matched} satır eşleşti, {unmatched} satır eşleşmedi",
                "add": "Satır Ekle",
                "emptyTitle": "Katalogda satır yok",
                "emptyText": "Excel yükleyin ya da satırları elle ekleyin.",
                "matchedProduct": "Eşleşen Ürün",
                "match": "Ürünle eşleştir",
                "matched": "Ürün eşleştirildi",
                "unmatched": "Eşleşme kaldırıldı",
                "productDeleted": "Ürün silinmiş",
                "drag": "Sürükleyerek sırala",
                "dragDisabled": "Sıralamak için arama ve filtreyi temizleyin",
                "goToProduct": "Ürün sayfasına git",
                "editProduct": "Ürünü düzenle",
                "edit": "Düzenle",
                "deleteConfirm": "Bu satır silinsin mi?",
                "noResult": "Aramaya uygun satır yok.",
                "showing": "{from}–{to} / {total}"
            },
            "item": {
                "newTitle": "Yeni Satır",
                "editTitle": "Satırı Düzenle",
                "product": "Eşleşen ürün",
                "change": "Değiştir",
                "matchProduct": "Ürünle eşleştir",
                "linkText": "Görünen metin",
                "tagsPlaceholder": "Yazıp Enter'a basın",
                "pickImage": "Seç",
                "categoryPlaceholder": "Sistem kategorilerinden seçin",
                "noCategories": "Kategori bulunamadı",
                "noDataColumns": "Bu katalogda veri sütunu yok. Sütunlar sekmesinden ekleyebilirsiniz.",
                "active": "Satır vitrinde görünsün"
            },
            "picker": {
                "title": "Ürünle Eşleştir",
                "rowHint": "Satır:",
                "searchPlaceholder": "Ürün adı, stok kodu, SKU, barkod ya da ID",
                "typeToSearch": "Aramak için en az 2 karakter yazın.",
                "noResult": "Ürün bulunamadı.",
                "stock": "Stok: {count}",
                "variants": "{count} varyant",
                "variant": "Varyant (isteğe bağlı)",
                "wholeProduct": "Tüm ürün",
                "match": "Eşleştir",
                "unmatch": "Eşleşmeyi kaldır"
            },
            "columns": {
                "title": "Sütunlar",
                "description": "Katalogda hangi bilginin hangi sırayla görüneceğini belirleyin. Sürükleyerek sıralayın.",
                "addData": "Veri sütunu",
                "addProduct": "Ürün alanı",
                "empty": "Henüz sütun yok.",
                "drag": "Sürükleyerek sırala",
                "sourceData": "Veri",
                "sourceProduct": "Ürün",
                "label": "Başlık",
                "type": "Tip",
                "productField": "Ürün alanı",
                "linkText": "Bağlantı metni",
                "linkTextPh": "Boşsa hücredeki metin",
                "linkTextProductPh": "Boşsa kural ayarındaki metin",
                "prefix": "Ön ek",
                "suffix": "Son ek",
                "visible": "Görünür",
                "searchable": "Aranabilir",
                "filterable": "Filtre",
                "excelHeader": "Excel başlığı (yeniden yüklemede otomatik eşlenir)",
                "keyBadge": "Anahtar",
                "newColumn": "Yeni sütun",
                "labelRequired": "Tüm sütunların başlığı olmalı.",
                "deleteConfirm": "\"{name}\" sütunu ve tüm satırlardaki değerleri silinsin mi?",
                "help": "Veri sütunları Excel'den ya da elle doldurulur. Ürün alanları (görsel, fiyat, stok, Ürüne Git…) eşleşen üründen canlı okunur; ürün güncellendikçe katalog da güncel kalır."
            },
            "settings": {
                "general": "Genel",
                "name": "Katalog adı",
                "slug": "Adres",
                "description": "Açıklama",
                "active": "Etkin",
                "activeHelp": "Pasif katalog hiçbir yerde gösterilmez.",
                "isPublic": "Vitrinde yayınla",
                "isPublicHelp": "Katalog kendi sayfasında (/katalog/…) herkese açık olur."
            },
            "rules": {
                "display": "Görünüm",
                "layout": "Düzen",
                "layoutTable": "Tablo",
                "layoutCards": "Kartlar",
                "groupBy": "Gruplama",
                "groupByHelp": "Seçilen sütunun değerlerine göre bölümlere ayırır (ör. Koku Ailesi). Kategori ya da etiket sütununda satır her kategorisinin bölümünde görünür; kategori bölümleri kategori ağacının sırasıyla dizilir.",
                "none": "Yok",
                "sortBy": "Sıralama",
                "manualOrder": "Elle sıra (sürükle-bırak)",
                "sortDir": "Yön",
                "asc": "Artan",
                "desc": "Azalan",
                "showSearch": "Arama kutusu göster",
                "showFilters": "Filtreleri göster",
                "rowLink": "Eşleşen satıra tıklayınca ürüne git",
                "linkLabel": "Ürün butonu metni",
                "linkLabelPh": "Ürüne Git",
                "rowRules": "Satır kuralları",
                "hideUnmatched": "Eşleşmeyenleri gizle",
                "hideUnmatchedHelp": "Yalnız sistemdeki bir ürünle eşleşen satırlar gösterilir.",
                "hideInactive": "Pasif ürünleri gizle",
                "hideInactiveHelp": "Eşleşen ürün pasifse ürün bağlantısı gösterilmez (eşleşmeyenler gizliyse satır da gizlenir).",
                "hideOutOfStock": "Tükenenleri gizle",
                "hideOutOfStockHelp": "Eşleşen ürünün stoğu bittiğinde satır gizlenir.",
                "matching": "Eşleştirme kuralı",
                "keyColumn": "Anahtar sütun",
                "keyColumnHelp": "Satırın kimliği: Excel yeniden yüklenince satırlar bu değere göre güncellenir ve otomatik eşleştirme bu değerle yapılır.",
                "matchAgainst": "Üründe aranacak alan",
                "matchAgainstOptions": {
                    "title": "Ürün adı",
                    "stock_code": "Stok kodu",
                    "sku": "Varyant SKU",
                    "barcode": "Barkod",
                    "id": "Ürün ID"
                },
                "matchAgainstHelp": "Büyük/küçük harf, Türkçe karakter, aksan ve boşluklar yok sayılır (SAN EPICE = San Épice).",
                "autoMatch": "İçe aktarmada otomatik eşleştir"
            },
            "import": {
                "titleNew": "Excel'den Katalog Oluştur",
                "titleExisting": "Kataloğa Excel Yükle",
                "stepFile": "Dosya",
                "stepMap": "Sütun eşleme",
                "stepDone": "Tamam",
                "dropTitle": "Excel dosyasını sürükleyin ya da seçin",
                "dropHint": ".xlsx, .xls, .csv, .ods — en fazla 10 MB, 5000 satır",
                "reading": "Dosya okunuyor…",
                "tooLarge": "Dosya 10 MB'tan büyük olamaz.",
                "tipsTitle": "İpuçları",
                "tip1": "İlk dolu satır başlık kabul edilir; birleştirilmiş başlık hücreleri desteklenir.",
                "tip2": "Hücre köprüleri (ör. Fragrantica) bağlantı olarak, virgüllü listeler etiket olarak algılanır.",
                "tip3": "Aynı dosyayı güncelleyip yeniden yüklediğinizde satırlar anahtar sütuna göre güncellenir; ürün eşleşmeleri korunur.",
                "catalogName": "Katalog adı",
                "mode": "Yükleme modu",
                "modes": {
                    "upsert": "Güncelle + yenileri ekle",
                    "replace": "Tümünü değiştir",
                    "append": "Hepsini yeni satır olarak ekle"
                },
                "modeHelp": {
                    "upsert": "Anahtar değeri aynı olan satırlar güncellenir, yeni değerler eklenir. Eşleşmeler korunur.",
                    "replace": "Mevcut satırlar silinip dosyadaki satırlar yazılır. Anahtarı aynı kalan satırların eşleşmesi taşınır.",
                    "append": "Dosyadaki tüm satırlar mevcutların sonuna eklenir."
                },
                "sheet": "Sayfa",
                "headerRow": "Başlık satırı",
                "detected": "{rows} satır, {columns} sütun bulundu · veri {start}. satırdan başlıyor",
                "excelColumn": "Excel sütunu",
                "action": "İşlem",
                "catalogColumn": "Katalog sütunu",
                "type": "Tip",
                "key": "Anahtar",
                "keyHelp": "Satırın kimliği ve ürün eşleştirme kaynağı",
                "group": "Grupla",
                "groupHelp": "Katalogu bu sütunun değerlerine göre bölümlere ayır",
                "filter": "Filtre",
                "filterHelp": "Vitrinde bu sütun için filtre çipleri göster",
                "actions": {
                    "new": "Yeni sütun",
                    "existing": "Mevcut sütuna",
                    "skip": "Atla"
                },
                "keyColumn": "Anahtar sütun",
                "noKey": "Seçilmedi",
                "keyColumnHelp": "Bu sütundaki değer (ör. PARNOVÉ adı) üründe aranır.",
                "autoMatch": "Ürünlerle otomatik eşleştir",
                "addProductColumns": "Ürün görseli ve \"Ürüne Git\" sütunlarını ekle",
                "previewRows": "İlk {count} satırı göster",
                "commit": "{count} satırı içe aktar",
                "back": "Geri",
                "doneTitle": "İçe aktarma tamamlandı",
                "stats": {
                    "created": "Yeni satır",
                    "updated": "Güncellenen",
                    "matched": "Eşleşen",
                    "unmatched": "Eşleşmeyen"
                },
                "unmatchedHint": "Eşleşmeyen satırları Ürünler sekmesinde \"Ürünle eşleştir\" ile elle bağlayabilirsiniz.",
                "openCatalog": "Kataloğa git"
            },
            "preview": {
                "title": "Vitrin önizlemesi",
                "summary": "{shown} / {total} satır gösteriliyor (kurallar uygulanmış)",
                "reload": "Yenile",
                "openTab": "Yeni sekmede aç",
                "notPublic": "Katalog henüz yayında değil (ya da uygulama pasif). Önizleme imzalı geçici linkle açılır ve arama motorlarına kapalıdır.",
                "embedTitle": "Başka bir sayfaya ekleyin",
                "embedText": "Tema düzenleyicisinde (Site Yönetimi → Tema) herhangi bir sayfanın içerik alanına \"Ürün Kataloğu\" bileşenini ekleyip bu kataloğu seçebilirsiniz."
            }
        },
        "appDetailPage": {
            "noFields": "Bu uygulama ek bilgi gerektirmez; kurup etkinleştirmeniz yeterli.",
            "marketBreadcrumb": "Uygulama Pazarı",
            "statusInstalledActive": "Kurulu · Aktif",
            "statusInstalledInactive": "Kurulu · Pasif",
            "statusNotInstalled": "Kurulu değil",
            "aboutTitle": "Uygulama Hakkında",
            "connectionInfoTitle": "Bağlantı Bilgileri",
            "setupTitle": "Kurulum",
            "loading": "Yükleniyor...",
            "activeLabel": "Aktif",
            "saveSettings": "Ayarları Kaydet",
            "installApp": "Uygulamayı Kur",
            "uninstallApp": "Uygulamayı Kaldır",
            "manageLabel": "Yönetim",
            "credentialsEncrypted": "Girdiğiniz kimlik bilgileri şifrelenerek saklanır.",
            "notFoundTitle": "Uygulama bulunamadı",
            "backToMarket": "Uygulama Pazarına Dön",
            "fieldRequired": "\"{field}\" alanı zorunlu.",
            "settingsSaved": "Ayarlar kaydedildi",
            "appInstalled": "{name} kuruldu",
            "uninstallConfirm": "\"{name}\" uygulamasını kaldırmak istediğinize emin misiniz?",
            "uninstallConfirmButton": "Kaldır",
            "cancel": "Vazgeç",
            "appUninstalled": "Uygulama kaldırıldı"
        }
    },
    "filters": {
        "title": "Filtre Seçenekleri",
        "name": "Ad",
        "user": {
            "id": "Kullanıcı ID"
        },
        "library": {
            "id": "ID (Video ya da Klasör)",
            "title": "Başlık"
        }
    },
    "components": {
        "libraryVideo": {
            "uploadTitle": "Videoları sürükleyin veya tıklayarak seçin"
        },
        "mediaPicker": {
            "remove": "Kaldır",
            "selectFromLibrary": "Kütüphaneden Seç"
        },
        "media": {
            "title": "Medya Kütüphanesi",
            "folders": "Klasörler",
            "newFolder": "Yeni klasör",
            "allFiles": "Tüm Dosyalar",
            "root": "Kök",
            "loading": "Yükleniyor…",
            "searchPlaceholder": "Dosya adına göre ara…",
            "move": "Taşı",
            "uploading": "Yükleniyor…",
            "fileLabel": "dosya",
            "folderLabel": "klasör",
            "fileSingular": "Dosya",
            "rename": "Yeniden adlandır",
            "actions": "İşlemler",
            "noMediaHere": "Bu konumda medya yok.",
            "cancel": "İptal",
            "moveToFolder": "Klasöre Taşı",
            "targetFolder": "Hedef klasör",
            "selectFolder": "Klasör seçin",
            "confirm": "Onay",
            "confirmDeleteFiles": "%s dosya silinsin mi?",
            "confirmDeleteFile": "Bu dosya silinsin mi?",
            "filesDeleted": "%s dosya silindi",
            "fileDeleted": "Dosya silindi",
            "folderName": "Klasör adı",
            "newFolderTitle": "Yeni Klasör",
            "nameRequired": "Ad gerekli",
            "folderCreated": "Klasör oluşturuldu",
            "newName": "Yeni ad",
            "renameFolderTitle": "Klasörü Yeniden Adlandır",
            "updated": "Güncellendi",
            "confirmDeleteFolder": "Bu klasör silinsin mi? İçindeki dosyalar üst klasöre taşınır.",
            "folderDeleted": "Klasör silindi",
            "moved": "Taşındı",
            "moveFailed": "Taşıma başarısız",
            "folderMoved": "Klasör taşındı",
            "folderMoveFailed": "Klasör taşınamadı",
            "filesMoved": "Dosyalar taşındı",
            "fileMoved": "Dosya taşındı",
            "uploadComplete": "Yükleme tamamlandı",
            "uploadFailed": "Yükleme başarısız"
        },
        "iconPicker": {
            "choose": "İkon seç",
            "clear": "Temizle",
            "search": "İkon ara…",
            "noResult": "İkon bulunamadı"
        },
        "themeSchema": {
            "remove": "Kaldır",
            "item": "Öğe",
            "noItems": "Henüz öğe yok.",
            "htmlPlaceholder": "HTML içerebilir",
            "unknownType": "Bilinmeyen tip:",
            "labels": {
                "logo_image": "Logo",
                "title": "Başlık",
                "subtitle": "Alt Başlık",
                "shortTitle": "Kısa Başlık",
                "description": "Açıklama",
                "content": "İçerik",
                "poster": "Görsel",
                "image": "Görsel",
                "icon": "İkon",
                "name": "Ad",
                "slug": "Slug",
                "url": "Bağlantı",
                "link": "Bağlantı",
                "items": "Öğeler",
                "text": "Metin",
                "label": "Etiket",
                "value": "Değer",
                "group": "Grup",
                "showSearch": "Arama İkonu",
                "showFavorites": "Favori İkonu",
                "showAccount": "Hesap İkonu",
                "showCart": "Sepet İkonu",
                "showCurrency": "Para Birimi Seçici",
                "showLanguage": "Dil Seçici",
                "variant": "Görünüm Çeşidi",
                "sidebar": "Kenar Çubuğu",
                "button_text": "Buton Metni",
                "button_url": "Buton Bağlantısı",
                "link_text": "Bağlantı Metni",
                "empty_text": "Boş Durum Metni",
                "bg_color": "Arka Plan Rengi",
                "text_color": "Metin Rengi",
                "dismissible": "Kapatılabilir",
                "free_shipping_text": "Ücretsiz Kargo Metni",
                "reviews": "Yorumlar",
                "reviews_variant": "Yorumlar Görünümü",
                "image_side": "Görsel Konumu",
                "category_ids": "Kategoriler",
                "show_count": "Ürün Sayısını Göster",
                "limit": "Adet Sınırı",
                "fallback_title": "Yedek Başlık",
                "fallback_text": "Yedek Metin",
                "fallback_button_text": "Yedek Buton Metni",
                "socials": "Sosyal Bağlantılar",
                "rate": "Puan",
                "message": "Mesaj",
                "phone": "Telefon",
                "email": "E-posta",
                "address": "Adres",
                "working_hours": "Çalışma Saatleri",
                "hours": "Çalışma Saatleri",
                "whatsapp": "WhatsApp (numara ya da bağlantı)",
                "show_socials": "Sosyal Bağlantıları Göster",
                "recipient_email": "Alıcı E-posta (boşsa site e-postası)",
                "subjects": "Konu Seçenekleri",
                "show_phone": "Telefon Alanı",
                "show_details": "İletişim Bilgilerini Göster",
                "consent_text": "Onay Metni (KVKK vb.)",
                "success_message": "Başarı Mesajı",
                "map": "Harita (Google Haritalar yerleştirme kodu ya da adres)",
                "directions_url": "Yol Tarifi Bağlantısı",
                "map_url": "Harita / Yol Tarifi Bağlantısı",
                "height": "Yükseklik (px)",
                "grayscale": "Siyah-Beyaz Harita",
                "eyebrow": "Üst Etiket",
                "year": "Yıl / Tarih",
                "photo": "Fotoğraf",
                "role": "Unvan",
                "bio": "Kısa Biyografi",
                "linkedin": "LinkedIn Bağlantısı",
                "instagram": "Instagram Bağlantısı"
            }
        },
        "menuTree": {
            "dragToSort": "Sıralamak / taşımak için sürükleyin",
            "addChild": "Alt öğe ekle",
            "dropHere": "Alt öğeleri buraya sürükleyin",
            "columns": "kolon",
            "collapse": "Alt öğeleri gizle",
            "expand": "Alt öğeleri göster"
        },
        "productAddons": {
            "title": "Eklentiler",
            "description": "Bu ürünle birlikte satın alınabilecek ek ürünleri tanımlayın.",
            "addAddon": "Eklenti Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra eklentileri buradan ekleyebilirsiniz.",
            "noAddons": "Henüz eklenti yok",
            "cols": {
                "product": "Ürün",
                "quantity": "Adet",
                "price": "Fiyat",
                "cart": "Sepet"
            },
            "variant": "Varyant",
            "selectVariant": "Varyant kombinasyonu seçin",
            "variantHint": "Eklenti üründe birden fazla varyant varsa hangisinin ekleneceğini seçin.",
            "automatic": "Otomatik",
            "locked": "Kilitli",
            "editAddon": "Eklentiyi Düzenle",
            "newAddon": "Yeni Eklenti",
            "drawerSubtitle": "Ürünle birlikte satılacak ek ürün",
            "cartBehavior": "Sepet Davranışı",
            "autoAddCart": "Sepete otomatik ekle",
            "autoAddCartHint": "Ürün sepete eklenince bu eklenti de eklensin.",
            "cannotRemoveCart": "Sepetten çıkarılamasın",
            "cannotRemoveCartHint": "Müşteri bu eklentiyi sepetten kaldıramaz.",
            "prices": "Fiyatlar",
            "addPrice": "Fiyat Ekle",
            "noPrices": "Fiyat eklenmedi — ana ürün fiyatı geçerli olur.",
            "discount": "İndirim",
            "invoice": "Fatura",
            "cancel": "İptal"
        },
        "productPersonalizations": {
            "title": "Kişiselleştirme Alanları",
            "description": "Müşterinin ürünü kişiselleştirmesi için alanlar tanımlayın (hediye paketi, not, renk seçimi…).",
            "addField": "Alan Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra kişiselleştirme alanlarını buradan ekleyebilirsiniz.",
            "noFields": "Henüz kişiselleştirme alanı yok",
            "editField": "Alanı Düzenle",
            "newField": "Yeni Alan",
            "drawerSubtitle": "Ürün detayında müşteriye gösterilecek alan",
            "cols": {
                "field": "Alan",
                "type": "Tip",
                "price": "Fiyat",
                "rules": "Kurallar"
            },
            "fieldTitle": "Başlık",
            "fieldTitlePlaceholder": "Hediye Paketi",
            "fieldDescription": "Açıklama",
            "fieldDescriptionPlaceholder": "Ürününüz hediye paketiyle gönderilir",
            "types": {
                "boolean": "Evet / Hayır",
                "select": "Seçim",
                "color": "Renk",
                "date": "Tarih",
                "file": "Dosya",
                "text": "Yazı",
                "textarea": "Paragraf"
            },
            "typeHints": {
                "boolean": "Müşteri aç/kapat anahtarıyla seçer.",
                "select": "Müşteri açılır listeden tek seçenek seçer.",
                "color": "Müşteri renk seçeneklerinden birini seçer (varyantlardaki görünüm).",
                "date": "Müşteri tarih seçer.",
                "file": "Müşteri dosya yükler.",
                "text": "Müşteri kısa yazı girer (256 karakter).",
                "textarea": "Müşteri uzun yazı girer (2000 karakter)."
            },
            "items": "Seçenekler",
            "addItem": "Seçenek Ekle",
            "noItems": "Henüz seçenek eklenmedi.",
            "itemLabel": "Etiket",
            "itemValue": "Değer",
            "itemsRequired": "Seçim ve renk tipleri için en az bir seçenek girin.",
            "requiredLabel": "Zorunlu olsun",
            "requiredHint": "Müşteri bu alanı doldurmadan ürünü sepete ekleyemez.",
            "required": "Zorunlu",
            "dependsOn": "Bağımlılık",
            "dependsOnHint": "Seçilen alan doldurulmadan bu alan müşteriye gösterilmez.",
            "noDependency": "Bağımsız (her zaman görünür)",
            "sort": "Sıra",
            "free": "Ücretsiz",
            "noPrices": "Fiyat eklenmedi — alan ücretsiz olur."
        },
        "productAttributeValues": {
            "title": "Özel Alanlar",
            "description": "Ürünün özellik setine tanımlı alan değerlerini girin.",
            "set": "Set",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra özel alan değerlerini buradan girebilirsiniz.",
            "noFields": "Tanımlı özel alan yok",
            "noFieldsHint": "Bu ürüne bir özellik seti atanmadığı için gösterilecek alan yok. Setler kategori üzerinden atanır.",
            "saveValues": "Değerleri Kaydet",
            "invalidJson": "{name} alanı geçerli bir JSON içermiyor."
        },
        "productGallery": {
            "title": "Görsel Galerisi",
            "description": "Kütüphaneden çoklu görsel seçin; sürükleyerek sıralayın, posteri belirleyin.",
            "addImage": "Görsel Ekle",
            "adding": "Ekleniyor",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra görsel galerisini buradan yönetebilirsiniz.",
            "noImages": "Henüz görsel yok",
            "noImagesHint": "Kütüphaneden çoklu görsel seçip sürükleyerek sıralayabilirsiniz.",
            "selectFromLibrary": "Kütüphaneden Seç",
            "dragToSort": "Sürükleyerek sırala",
            "poster": "Poster",
            "makePoster": "Poster yap",
            "makePassive": "Pasif yap",
            "makeActive": "Aktif yap",
            "imagesAdded": "%s görsel eklendi"
        },
        "productPackageItems": {
            "title": "Paket Öğeleri",
            "description": "Bu paketin içereceği ürünleri, adet ve fiyatlarıyla yönetin.",
            "addItem": "Öğe Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra paket öğelerini buradan ekleyebilirsiniz.",
            "noItems": "Henüz paket öğesi yok",
            "noItemsHint": "Bu paketin içereceği ürünleri adet ve fiyatlarıyla ekleyin.",
            "cols": {
                "product": "Ürün",
                "quantity": "Adet",
                "price": "Fiyat",
                "usage": "Kullanım"
            },
            "variant": "Varyant",
            "selectVariant": "Varyant kombinasyonu seçin",
            "variantHint": "Paket öğesi üründe birden fazla varyant varsa hangisinin dahil edileceğini seçin.",
            "editItem": "Paket Öğesini Düzenle",
            "newItem": "Yeni Paket Öğesi",
            "drawerSubtitle": "Pakete dahil edilecek ürün",
            "usageRule": "Kullanım Kuralı",
            "fixedDate": "Sabit Tarih",
            "dayCount": "Gün Sayısı",
            "usageDayCount": "Kullanım Gün Sayısı",
            "prices": "Fiyatlar",
            "addPrice": "Fiyat Ekle",
            "noPrices": "Fiyat eklenmedi — ana ürün fiyatı geçerli olur.",
            "discounted": "İndirimli",
            "cancel": "İptal",
            "days": "gün"
        },
        "productVariants": {
            "title": "Varyantlar",
            "description": "Renk, beden vb. kombinasyonları, her biri için stok ve fiyat ile yönetin.",
            "stockReadonlyHint": "Varyant stoğu salt-okunurdur; yalnızca Stok Yönetimi (satın alma / düzeltme / transfer / sayım) üzerinden değişir.",
            "addCombination": "Kombinasyon Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra varyant kombinasyonlarını buradan ekleyebilirsiniz.",
            "noVariants": "Henüz varyant yok",
            "noVariantsHint": "Renk, beden vb. kombinasyonları stok ve fiyatlarıyla ekleyin.",
            "cols": {
                "combination": "Kombinasyon",
                "image": "Görsel",
                "stock": "Stok",
                "price": "Fiyat"
            },
            "selectedCount": "{count} kombinasyon seçildi",
            "deleteSelected": "Seçilenleri Sil",
            "deleteSelectedConfirm": "Seçili {count} kombinasyon silinecek. Onaylıyor musunuz?",
            "bulkCurrency": "Para birimi",
            "bulkApply": "Uygula & Kaydet",
            "listSeparately": "Varyantları ayrı listele",
            "listSeparatelyHint": "Açıksa her varyant kombinasyonu ürün listesinde ayrı bir ürün gibi gösterilir.",
            "listVariantGroup": "Listeleme varyant grubu",
            "listVariantGroupHint": "Liste sayfasında bu gruba göre ayrı kart gösterilir (örn. Renk). Diğer boyutlar ürün sayfasında seçilir.",
            "autoFirstGroup": "Otomatik (ilk grup)",
            "addImage": "Görsel Ekle",
            "manageImages": "Görselleri Yönet",
            "imageDrawerSubtitle": "Sürükleyerek sırala, ekle veya kaldır",
            "noImages": "Henüz görsel yok — kütüphaneden ekleyin.",
            "dragToSort": "Sıralamak için sürükleyin",
            "inlineHint": "Stok ve fiyatı tablodan; görselleri ise görsel kutucuğuna tıklayıp açılan pencereden düzenleyin.",
            "generateTitle": "Kombinasyon Üret",
            "generateSubtitle": "Değerleri seç, tüm kombinasyonlar otomatik oluşturulsun",
            "generateHint": "Seçilen değerlerin tüm kombinasyonları boş olarak (stok 0, fiyatsız) oluşturulur. Zaten var olanlar atlanır; stok ve fiyatı sonra tablodan girebilirsiniz.",
            "comboPreview": "{count} kombinasyon oluşturulacak",
            "generateResult": "{created} kombinasyon oluşturuldu, {skipped} tanesi zaten vardı (atlandı).",
            "generate": "Üret",
            "variantSelection": "Varyant Seçimi",
            "noVariantTypes": "Bu ürün grubunda tanımlı varyant tipi yok.",
            "prices": "Fiyatlar",
            "addPrice": "Fiyat Ekle",
            "noPrices": "Fiyat eklenmedi — ana ürün fiyatı geçerli olur.",
            "discounted": "İndirimli",
            "cancel": "İptal"
        }
    },
    "customTable": {
        "noData": "Listelenecek veri bulunamadı.",
        "showingPageInformationPattern": "%s kayıttan, %d ile %d arası gösteriliyor"
    },
    "userMenu": {
        "language": "Dil",
        "account": "Hesabım",
        "security": "Güvenlik",
        "userRoles": "Üyeler & Roler",
        "integration": "Entegrasyonlar",
        "darkMode": "Koyu Mod",
        "signOut": "Çıkış Yap"
    },
    "footer": {
        "copyrightText": "Ticatix E-Ticaret Çözümleri. Tüm hakları saklıdır."
    },
    "endpointActions": {
        "get": "Görüntüleme",
        "post": "Ekleme",
        "put": "Güncelleme",
        "delete": "Silme"
    },
    "responseErrors": {
        "record_not_found": "Kayıt bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen farklı bir kayıt arayınız.",
        "method_not_found": "İşlem bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen tekrar deneyin.",
        "invalid_file_type": "Geçersiz dosya türü seçildi. Lütfen uygun bir dosya türü kullanınız.",
        "current_password_invalid": "Mevcut şifre hatalı. Lütfen doğru şifreyi girip tekrar deneyiniz.",
        "this_group_not_usable": "Bu grup şu an kullanılamaz. Lütfen farklı bir grup seçin.",
        "invalid_identification_number": "Geçersiz kimlik numarası girildi. Lütfen geçerli bir kimlik numarası kullanınız.",
        "validate_error": "Doğrulama hatası oluştu. Lütfen bilgilerinizi kontrol ederek tekrar deneyiniz.",
        "provider_handler_not_found_by_code": "Belirtilen koda göre sağlayıcı bulunamadı. Lütfen geçerli bir kod giriniz.",
        "video_id_invalid": "Geçersiz video kimliği girdiniz. Lütfen geçerli bir kimlik giriniz.",
        "invalid_customer_id": "Müşteri numarası hatalı. Lütfen geçerli bir müşteri numarası ile tekrar deneyiniz.",
        "login_description": "Lütfen tarafınıza iletilen yetkili giriş bilgilerini kullanarak oturum açın.",
        "login_error": "Giriş bilgilerinizi kontrol edin.",
        "invalid_credentials": "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
    },
    "topbar": {
        "search": "Ara...",
        "notifications": "Bildirimler",
        "appsInstalled": "{n} kurulu",
        "appsEmpty": "Henüz kurulu uygulama yok",
        "loading": "Yükleniyor...",
        "market": "Pazar",
        "searchHint": "Ürün veya müşteri arayın…",
        "searchEmpty": "Sonuç bulunamadı",
        "searchMin": "Aramak için en az 2 karakter girin",
        "products": "Ürünler",
        "customers": "Müşteriler",
        "orders": "Siparişler",
        "categories": "Kategoriler",
        "brands": "Markalar",
        "coupons": "Kuponlar",
        "variantGroups": "Varyant Tipleri",
        "productGroups": "Ürün Grupları",
        "suppliers": "Tedarikçiler",
        "units": "Birimler",
        "attributeSets": "Özellik Setleri",
        "tags": "Etiketler",
        "customerGroups": "Müşteri Grupları",
        "discountCampaigns": "İndirim Kampanyaları",
        "marketingCampaigns": "Pazarlama Kampanyaları",
        "automations": "Otomasyonlar",
        "priceLists": "Fiyat Listeleri",
        "salesChannels": "Satış Kanalları",
        "warehouses": "Depolar",
        "menus": "Menüler",
        "pages": "Sayfalar",
        "notifEmpty": "Henüz bildirim yok",
        "notifMarkAll": "Tümünü okundu işaretle",
        "notifNew": "yeni",
        "notifAll": "Tümü",
        "notifUnread": "Okunmayan",
        "notifRead": "Okunan",
        "notifClearAll": "Tümünü temizle",
        "notifDelete": "Sil",
        "notifSwipeHint": "Silmek için sağa kaydır",
        "notifClearConfirm": "Tüm bildirimler silinsin mi?",
        "notifClearYes": "Evet, sil",
        "notifMarkAllShort": "Tümü okundu"
    }
};
